import { forwardRef } from "react";
import PropTypes from "prop-types";

// Common PropTypes for all icons
const iconPropTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

export function TickIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79079 0.21967C10.0697 0.512563 10.0697 0.987437 9.79079 1.28033L4.0765 7.28033C3.79756 7.57322 3.3453 7.57322 3.06635 7.28033L0.209209 4.28033C-0.0697365 3.98744 -0.0697365 3.51256 0.209209 3.21967C0.488155 2.92678 0.940416 2.92678 1.21936 3.21967L3.57143 5.68934L8.78064 0.21967C9.05958 -0.0732233 9.51184 -0.0732233 9.79079 0.21967Z"
        fill={color}
      />
    </svg>
  );
}

export function NoMatchIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M73.437 70.625L55.6696 53C59.6735 48.375 61.9257 42.5 61.9257 36C61.9257 21.75 50.1642 10 35.9003 10C21.5112 10 10 21.75 10 36C10 50.375 21.6364 62 35.9003 62C42.2815 62 48.1623 59.75 52.7918 55.75L70.434 73.5C70.9345 73.875 71.435 74 72.0606 74C72.5611 74 73.0616 73.875 73.437 73.5C74.1877 72.75 74.1877 71.375 73.437 70.625ZM36.0254 58C23.7634 58 14.0039 48.125 14.0039 36C14.0039 23.875 23.7634 14 36.0254 14C48.1623 14 58.0469 23.875 58.0469 36C58.0469 48.25 48.1623 58 36.0254 58Z"
        fill="#3270D8"
      />
      <path
        d="M45.2328 43.2972C46.0461 44.0472 46.0461 45.3597 45.2328 46.1097C44.8575 46.4847 44.357 46.6722 43.8565 46.6722C43.2934 46.6722 42.793 46.4847 42.4176 46.1097L35.8487 39.5472L29.2172 46.1097C28.8418 46.4847 28.3413 46.6722 27.8409 46.6722C27.2778 46.6722 26.7773 46.4847 26.402 46.1097C25.5887 45.3597 25.5887 44.0472 26.402 43.2972L32.9709 36.6722L26.402 30.1097C25.5887 29.3597 25.5887 28.0472 26.402 27.2972C27.1527 26.4847 28.4665 26.4847 29.2172 27.2972L35.8487 33.8597L42.4176 27.2972C43.1683 26.4847 44.4821 26.4847 45.2328 27.2972C46.0461 28.0472 46.0461 29.3597 45.2328 30.1097L38.6639 36.7347L45.2328 43.2972Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function SuccessIcon({
  className,
  circleColor,
  tickColor,
  width,
  height,
  ...props
}) {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 84 84"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} fx--no-shrink`}
        {...props}
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M39.2109 52.0938C38.4141 52.8906 36.9531 52.8906 36.1562 52.0938L27.6562 43.5938C26.8594 42.7969 26.8594 41.3359 27.6562 40.5391C28.4531 39.7422 29.9141 39.7422 30.7109 40.5391L37.75 47.5781L53.1562 32.0391C53.9531 31.2422 55.4141 31.2422 56.2109 32.0391C57.0078 32.8359 57.0078 34.2969 56.2109 35.0938L39.2109 52.0938ZM76 42C76 60.8594 60.7266 76 42 76C23.1406 76 8 60.8594 8 42C8 23.2734 23.1406 8 42 8C60.7266 8 76 23.2734 76 42ZM42 12.25C25.5312 12.25 12.25 25.6641 12.25 42C12.25 58.4688 25.5312 71.75 42 71.75C58.3359 71.75 71.75 58.4688 71.75 42C71.75 25.6641 58.3359 12.25 42 12.25Z"
          fill={circleColor}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M39.2109 52.0938C38.4141 52.8906 36.9531 52.8906 36.1562 52.0938L27.6562 43.5938C26.8594 42.7969 26.8594 41.3359 27.6562 40.5391C28.4531 39.7422 29.9141 39.7422 30.7109 40.5391L37.75 47.5781L53.1562 32.0391C53.9531 31.2422 55.4141 31.2422 56.2109 32.0391C57.0078 32.8359 57.0078 34.2969 56.2109 35.0938L39.2109 52.0938Z"
          fill={tickColor}
        />
      </svg>
    </>
  );
}

export function SearchIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8898 19.1836L19.1836 19.8898C19.0368 20.0367 18.7993 20.0367 18.6524 19.8898L14.8588 16.0963C14.7901 16.0244 14.7495 15.9307 14.7495 15.8307V15.4182C13.6089 16.4025 12.1246 16.9994 10.4997 16.9994C6.90922 16.9994 4 14.0901 4 10.4997C4 6.90922 6.90922 4 10.4997 4C14.0901 4 16.9994 6.90922 16.9994 10.4997C16.9994 12.1246 16.4025 13.6089 15.4182 14.7495H15.8307C15.9307 14.7495 16.0244 14.787 16.0963 14.8588L19.8898 18.6524C20.0367 18.7993 20.0367 19.0368 19.8898 19.1836ZM5.5 10.4974C5.5 13.2597 7.73737 15.4971 10.4997 15.4971C13.2621 15.4971 15.4995 13.2597 15.4995 10.4974C15.4995 7.73502 13.2621 5.49766 10.4997 5.49766C7.73737 5.49766 5.5 7.73502 5.5 10.4974Z"
        fill="#9F9FAF"
      ></path>
    </svg>
  );
}
export function CloseIcon({
  color,
  className,
  width,
  height,
  onClick,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
      onClick={onClick}
    >
      <path
        d="M18.554 19.8454L18.5543 19.8457C18.8933 20.1848 19.5067 20.1848 19.8457 19.8457C20.1848 19.5067 20.1848 18.8933 19.8457 18.5543L13.2667 11.9753L19.8454 5.44598L19.8457 5.44571C20.1848 5.10666 20.1848 4.49334 19.8457 4.15429C19.5067 3.81524 18.8933 3.81524 18.5543 4.15429L18.554 4.15456L12.0247 10.7333L5.44571 4.15429C5.10666 3.81524 4.49334 3.81524 4.15429 4.15429C3.81524 4.49334 3.81524 5.10666 4.15429 5.44571L4.15456 5.44598L10.7333 11.9753L4.15429 18.5543C3.81524 18.8933 3.81524 19.5067 4.15429 19.8457C4.49334 20.1848 5.10666 20.1848 5.44571 19.8457L12.0247 13.2667L18.554 19.8454Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      ></path>
    </svg>
  );
}

export function LinkedInIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3.43294C2 2.64138 2.66158 2 3.47781 2H20.5219C21.3381 2 22 2.64138 22 3.43294V20.5673C22 21.3586 21.3381 22 20.5219 22H3.47781C2.66158 22 2 21.3586 2 20.5673V3.43294ZM6.52677 9C7.46176 9 8.0441 8.33285 8.0441 7.5C8.02667 6.6484 7.46176 6 6.54468 6C5.62711 6 5.02734 6.6484 5.02734 7.5C5.02734 8.33285 5.60945 9 6.50934 9H6.52677ZM5.02734 19H8.0441V10H5.02734V19ZM10.0557 19H13.0204V14.0893C13.0204 13.8264 13.0397 13.5636 13.1181 13.376C13.3324 12.8509 13.8202 12.3068 14.6393 12.3068C15.7123 12.3068 16.1412 13.1137 16.1412 14.2953V19H19.1059V13.9578C19.1059 11.2568 17.6434 10 15.6925 10C14.0929 10 13.3908 10.8813 13.0009 11.4817H13.0204V10.2063H10.0557C10.0945 11.0312 10.0557 19 10.0557 19Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function InstagramIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M12.0223 6.84375C9.16518 6.84375 6.88839 9.16518 6.88839 11.9777C6.88839 14.8348 9.16518 17.1116 12.0223 17.1116C14.8348 17.1116 17.1562 14.8348 17.1562 11.9777C17.1562 9.16518 14.8348 6.84375 12.0223 6.84375ZM12.0223 15.3259C10.192 15.3259 8.67411 13.8527 8.67411 11.9777C8.67411 10.1473 10.1473 8.67411 12.0223 8.67411C13.8527 8.67411 15.3259 10.1473 15.3259 11.9777C15.3259 13.8527 13.8527 15.3259 12.0223 15.3259ZM18.5402 6.66518C18.5402 5.99554 18.0045 5.45982 17.3348 5.45982C16.6652 5.45982 16.1295 5.99554 16.1295 6.66518C16.1295 7.33482 16.6652 7.87054 17.3348 7.87054C18.0045 7.87054 18.5402 7.33482 18.5402 6.66518ZM21.933 7.87054C21.8438 6.26339 21.4866 4.83482 20.3259 3.67411C19.1652 2.51339 17.7366 2.15625 16.1295 2.06696C14.4777 1.97768 9.52232 1.97768 7.87054 2.06696C6.26339 2.15625 4.87946 2.51339 3.67411 3.67411C2.51339 4.83482 2.15625 6.26339 2.06696 7.87054C1.97768 9.52232 1.97768 14.4777 2.06696 16.1295C2.15625 17.7366 2.51339 19.1205 3.67411 20.3259C4.87946 21.4866 6.26339 21.8438 7.87054 21.933C9.52232 22.0223 14.4777 22.0223 16.1295 21.933C17.7366 21.8438 19.1652 21.4866 20.3259 20.3259C21.4866 19.1205 21.8438 17.7366 21.933 16.1295C22.0223 14.4777 22.0223 9.52232 21.933 7.87054ZM19.7902 17.8705C19.4777 18.7634 18.7634 19.433 17.9152 19.7902C16.5759 20.3259 13.4509 20.192 12.0223 20.192C10.5491 20.192 7.42411 20.3259 6.12946 19.7902C5.23661 19.433 4.56696 18.7634 4.20982 17.8705C3.67411 16.5759 3.80804 13.4509 3.80804 11.9777C3.80804 10.5491 3.67411 7.42411 4.20982 6.08482C4.56696 5.23661 5.23661 4.56696 6.12946 4.20982C7.42411 3.67411 10.5491 3.80804 12.0223 3.80804C13.4509 3.80804 16.5759 3.67411 17.9152 4.20982C18.7634 4.52232 19.433 5.23661 19.7902 6.08482C20.3259 7.42411 20.192 10.5491 20.192 11.9777C20.192 13.4509 20.3259 16.5759 19.7902 17.8705Z"
        fill="white"
        stroke="white"
        strokeWidth="0.1"
      ></path>
    </svg>
  );
}

export function FacebookIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4536 5.53723C15.9071 5.37766 15.2787 5.27128 14.7049 5.27128C13.9945 5.27128 12.4645 5.7234 12.4645 6.60106V8.70213H16.0984V12.2394H12.4645V22H8.80328V12.2394H7V8.70213H8.80328V6.92021C8.80328 4.23404 10.0601 2 13.0929 2C14.1311 2 15.9891 2.05319 17 2.39894L16.4536 5.53723Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function PlaystoreIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M14.7022 11.1541L6.09327 2.50791L17.0465 8.80602L14.7022 11.1541ZM3.84646 2C3.33936 2.26568 3 2.75015 3 3.37918V20.6208C3 21.2499 3.33936 21.7343 3.84646 22L13.8557 11.998L3.84646 2ZM20.4323 10.8142L18.1348 9.48193L15.572 12.002L18.1348 14.522L20.4791 13.1897C21.1812 12.631 21.1812 11.3729 20.4323 10.8142ZM6.09327 21.496L17.0465 15.1979L14.7022 12.8498L6.09327 21.496Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function AppstoreIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M17.6394 12.6358C17.6493 11.8692 17.8537 11.1176 18.2335 10.4509C18.6133 9.7841 19.1561 9.22391 19.8116 8.82239C19.3952 8.22985 18.8459 7.74221 18.2073 7.39821C17.5687 7.0542 16.8583 6.86331 16.1327 6.84069C14.5849 6.6788 13.0843 7.76357 12.2956 7.76357C11.4915 7.76357 10.2771 6.85676 8.96942 6.88357C8.12355 6.9108 7.29919 7.15589 6.57665 7.59496C5.85411 8.03403 5.25804 8.6521 4.84651 9.38896C3.06388 12.4643 4.39356 16.984 6.1012 19.4699C6.95557 20.6871 7.95407 22.0468 9.26062 21.9986C10.5391 21.9458 11.0166 21.1863 12.5599 21.1863C14.0889 21.1863 14.5369 21.9986 15.8699 21.968C17.2419 21.9458 18.1062 20.7453 18.9306 19.5165C19.5445 18.6492 20.0169 17.6906 20.3302 16.6762C19.5332 16.3403 18.853 15.7781 18.3745 15.0596C17.896 14.3411 17.6403 13.4981 17.6394 12.6358Z"
        fill="#F2F2F9"
      ></path>
      <path
        d="M15.1214 5.20594C15.8694 4.31119 16.238 3.16113 16.1487 2C15.0059 2.1196 13.9503 2.66383 13.1921 3.52425C12.8215 3.94459 12.5376 4.43361 12.3567 4.96334C12.1758 5.49307 12.1015 6.05313 12.1379 6.6115C12.7095 6.61736 13.275 6.49391 13.7918 6.25045C14.3086 6.00698 14.7632 5.64985 15.1214 5.20594Z"
        fill="#F2F2F9"
      ></path>
    </svg>
  );
}

export function PointArrowIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M6.1875 0.164178L10.3125 4.10168C10.4297 4.21887 10.5 4.35949 10.5 4.52355C10.5 4.66418 10.4297 4.8048 10.3125 4.92199L6.1875 8.85949C5.97656 9.07043 5.60156 9.07043 5.39062 8.83605C5.17969 8.62512 5.17969 8.25012 5.41406 8.03918L8.53125 5.08605H0.5625C0.234375 5.08605 0 4.82824 0 4.52355C0 4.19543 0.234375 3.96105 0.5625 3.96105H8.53125L5.41406 0.984491C5.17969 0.773553 5.17969 0.398553 5.39062 0.187616C5.60156 -0.0467593 5.95312 -0.0467593 6.1875 0.164178Z"
        fill={color}
      ></path>
    </svg>
  );
}

export function ChatMessageIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M12 5C7.5625 5 4 7.90625 4 11.5C4 12.9688 4.625 14.3438 5.65625 15.4375C5.1875 16.6562 4.21875 17.7188 4.21875 17.7188C4 17.9375 3.96875 18.25 4.0625 18.5312C4.15625 18.8438 4.4375 19 4.75 19C6.65625 19 8.15625 18.2188 9.09375 17.5625C9.96875 17.8438 10.9688 18 12 18C16.4062 18 19.9688 15.0938 19.9688 11.5312C19.9688 7.96875 16.4062 5 12 5ZM12 17C11.0938 17 10.2188 16.875 9.375 16.625C9.09375 16.5312 8.75 16.5625 8.5 16.75C7.8125 17.25 6.6875 17.8438 5.28125 18C5.65625 17.5312 6.21875 16.7188 6.5625 15.8125C6.71875 15.4688 6.625 15.0938 6.375 14.7812C5.46875 13.8125 5 12.6875 5 11.5C5 8.46875 8.125 6 11.9688 6C15.8125 6 18.9375 8.46875 18.9375 11.5C18.9375 14.5312 15.8438 17 12 17Z"
        fill="#3270D8"
      />
      <path
        d="M12.5026 12.5H8.50265C8.2214 12.5 8.00265 12.75 8.00265 13C7.9714 13.2812 8.2214 13.5 8.50265 13.5H12.5026C12.7526 13.5 12.9714 13.2812 12.9714 13C12.9714 12.75 12.7526 12.5 12.5026 12.5ZM15.5026 9.5H8.50265C8.2214 9.5 8.00265 9.75 8.00265 10C7.9714 10.2812 8.2214 10.5 8.50265 10.5H15.5026C15.7526 10.5 15.9714 10.2812 15.9714 10C15.9714 9.75 15.7526 9.5 15.5026 9.5Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function CalendarIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M6.5 4C6.75 4 7 4.25 7 4.5V6H13V4.5C13 4.25 13.2188 4 13.5 4C13.75 4 14 4.25 14 4.5V6H15C16.0938 6 17 6.90625 17 8V10.0312C16.8125 10.0312 16.6562 10 16.5 10C16.3125 10 16.1562 10.0312 16 10.0312V10H4V18C4 18.5625 4.4375 19 5 19H12.25C12.5625 19.4062 12.9062 19.7188 13.3125 20H5C3.875 20 3 19.125 3 18V8C3 6.90625 3.875 6 5 6H6V4.5C6 4.25 6.21875 4 6.5 4ZM15 7H5C4.4375 7 4 7.46875 4 8V9H16V8C16 7.46875 15.5312 7 15 7Z"
        fill="#3270D8"
      />
      <path
        d="M16.4688 13C16.75 13 16.9688 13.25 16.9688 13.5V15H18C18.25 15 18.5 15.25 18.5 15.5C18.5 15.7812 18.25 16 18 16H16.4688C16.2188 16 15.9688 15.7812 15.9688 15.5V13.5C15.9688 13.25 16.2188 13 16.4688 13ZM12 15.5C12 13.0312 14 11 16.5 11C18.9688 11 21 13.0312 21 15.5C21 18 18.9688 20 16.5 20C14 20 12 18 12 15.5ZM16.5 19C18.4062 19 20 17.4375 20 15.5C20 13.5938 18.4062 12 16.5 12C14.5625 12 13 13.5938 13 15.5C13 17.4375 14.5625 19 16.5 19Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function ReceptionistIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M11.9688 7H12C13.1875 7 14.25 7.71875 14.7188 8.78125C15.2188 9.875 15 11.125 14.2188 12H14.5C15 12 15.4688 11.75 15.75 11.3125C15.9062 10.9062 16 10.4688 16 10C16 7.8125 14.1875 6 12 6C9.78125 6 8 7.8125 8 10C8 11.2812 8.59375 12.375 9.5 13.125C9.5 13.0938 9.5 13.0625 9.5 13C9.5 12.6562 9.59375 12.3125 9.75 12C8.96875 11.125 8.75 9.875 9.25 8.78125C9.71875 7.71875 10.7812 7 11.9688 7Z"
        fill="#FD8B1F"
      />
      <path
        d="M6.5 11C6.75 11 7 10.7812 7 10.5V10C7 7.25 9.21875 5 12 5C14.75 5 17 7.25 17 10V10.5C17 11.9062 15.875 13 14.5 13H13.5C13.5 12.4688 13.0312 12 12.5 12H11.5C10.9375 12 10.5 12.4688 10.5 13C10.5 13.5625 10.9375 14 11.5 14H14.5C16.4062 14 17.9688 12.4375 18 10.5V10C18 6.71875 15.2812 4 12 4C8.6875 4 6 6.71875 6 10V10.5C6 10.7812 6.21875 11 6.5 11ZM14.8125 15H9.15625C6.84375 15 5 16.875 5 19.1875C5 19.6562 5.34375 20 5.8125 20H18.1562C18.625 20 19 19.6562 19 19.1875C19 16.875 17.125 15 14.8125 15ZM6 19C6.0625 17.3438 7.46875 16 9.15625 16H14.8125C16.5 16 17.9062 17.3438 17.9688 19H6Z"
        fill="#3270D8"
      />
    </svg>
  );
}

export function LeadQualificationIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M10.5625 13.5H7.40625C4.40625 13.5 2 15.9375 2 18.9375C2 19.5312 2.46875 20 3.0625 20H14.9062C15.5 20 16 19.5312 16 18.9375C16 15.9375 13.5625 13.5 10.5625 13.5ZM14.9062 19H3.0625C3.03125 19 3 18.9688 3 18.9375C3 16.5 4.96875 14.5 7.40625 14.5H10.5625C13 14.5 15 16.5 15 18.9375C15 18.9688 14.9375 19 14.9062 19ZM9 12C11.1875 12 13 10.2188 13 8C13 5.8125 11.1875 4 9 4C6.78125 4 5 5.8125 5 8C5 10.2188 6.78125 12 9 12ZM9 5C10.625 5 12 6.375 12 8C12 9.65625 10.625 11 9 11C7.34375 11 6 9.65625 6 8C6 6.375 7.34375 5 9 5Z"
        fill="#3270D8"
      />
      <path
        d="M21.8594 8.84082C21.6719 8.65332 21.3281 8.65332 21.1406 8.84082L18.1719 11.8408L16.8594 10.5283C16.6719 10.3408 16.3281 10.3408 16.1406 10.5283C15.9531 10.7158 15.9531 11.0283 16.1406 11.2158L17.8281 12.9033C17.9219 12.9971 18.0469 13.0283 18.1719 13.0283C18.2969 13.0283 18.4219 12.9971 18.5156 12.9033L21.8594 9.55957C22.0469 9.37207 22.0469 9.05957 21.8594 8.84082Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function HeadphoneIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M12.7812 4.03881C7.96875 3.57006 4.15625 7.41381 4.03125 12.0076L4 12.4763C4 12.7576 4.25 12.9763 4.53125 12.9763C4.78125 12.9763 5 12.7576 5.03125 12.5076V11.9763C5.125 8.00756 8.46875 4.63256 12.6562 5.00756C16.3125 5.35131 19.0312 8.53881 19.0312 12.1951V17.4763C19.0312 18.2888 18.3438 18.9763 17.5312 18.9763H14.9062C15.0625 18.6326 15.0625 18.2263 14.8438 17.8201C14.5625 17.2888 13.9688 16.9763 13.375 16.9763H11.5625C10.8438 16.9763 10.1875 17.4763 10.0312 18.1951C9.875 19.1638 10.5938 19.9763 11.5 19.9763H17.4688C18.8438 19.9763 19.9688 18.8826 19.9688 17.5076V12.1951C20.0312 8.03881 16.9062 4.41381 12.7812 4.03881ZM13.5 18.9763H11.5C11.2188 18.9763 11 18.7576 11 18.4763C11 18.2263 11.2188 17.9763 11.5 17.9763H13.5C13.75 17.9763 14 18.2263 14 18.4763C14 18.7576 13.7812 18.9763 13.5 18.9763Z"
        fill="#3270D8"
      />
      <path
        d="M10 11C10 10.4688 9.53125 10 9 10H8C6.875 10 6 10.9062 6 12V14C6 15.0938 6.90625 16 8 16H9C9.5625 16 10 15.5625 10 15V11ZM9 15H8C7.4375 15 7 14.5625 7 14V12C7 11.4688 7.4375 11 8 11H9V15ZM16 16C17.0938 16 18 15.0938 18 14V12C18 10.9062 17.0938 10.0312 16 10.0312H15.0312C14.4688 10.0312 14.0312 10.5 14.0312 11.0312V15.0312C14.0312 15.5938 14.4688 16.0312 15.0312 16.0312H16V16ZM15 11H15.9688C16.5 11 16.9688 11.4688 16.9688 12V14C16.9688 14.5625 16.5 15 15.9688 15H14.9688L15 11Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function ChatSmileIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M18 4H6C4.875 4 4 4.875 4 5.96875V14.9375C4 16.0312 4.875 16.9062 6 16.9062H9V19.5312C9 19.8438 9.34375 20 9.59375 19.8125L13.5 16.9062H18C19.0938 16.9062 20 16 20 14.9375V5.96875C20 4.875 19.125 4 18 4ZM19.0312 14.9688C19.0312 15.5312 18.5625 15.9688 18.0312 15.9688H13.5C13.2812 15.9688 13.0938 16.0625 12.9062 16.1875L10.0312 18.3438V16.4688C10.0312 16.2188 9.78125 15.9688 9.53125 15.9688H6.03125C5.46875 15.9688 5.03125 15.5312 5.03125 14.9688V5.96875C5.03125 5.4375 5.46875 4.96875 6.03125 4.96875H18.0312C18.5625 4.96875 19.0312 5.4375 19.0312 5.96875V14.9688Z"
        fill="#3270D8"
      />
      <path
        d="M14.2666 9.46875C14.7041 9.46875 15.0166 9.15625 15.0166 8.71875C15.0166 8.3125 14.7041 7.96875 14.2666 7.96875C13.8604 7.96875 13.5166 8.3125 13.5166 8.71875C13.5166 9.15625 13.8604 9.46875 14.2666 9.46875ZM14.6416 11.6562C14.0479 12.3438 13.2041 12.7188 12.2666 12.7188C11.3604 12.7188 10.4854 12.3438 9.92286 11.6562C9.73536 11.4375 9.42286 11.4062 9.20411 11.5938C8.98536 11.7812 8.98536 12.0938 9.14161 12.3125C9.92286 13.2188 11.0791 13.7188 12.2979 13.7188C13.4854 13.7188 14.6416 13.2188 15.4229 12.3125C15.5791 12.0938 15.5791 11.7812 15.3604 11.5938C15.1416 11.4062 14.8291 11.4375 14.6416 11.6562ZM10.2666 9.46875C10.7041 9.46875 11.0166 9.15625 11.0166 8.71875C11.0166 8.3125 10.7041 7.96875 10.2666 7.96875C9.86036 7.96875 9.51661 8.3125 9.51661 8.71875C9.51661 9.15625 9.86036 9.46875 10.2666 9.46875Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function EmptyCalendarIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M5.04761 3.49937V2.13573C5.04761 1.38255 5.55632 0.772095 6.18397 0.772095C6.81162 0.772095 7.32033 1.38255 7.32033 2.13573V3.49937"
        stroke="#FD8B1F"
        stroke-width="1.08225"
      />
      <path
        d="M14.5931 3.49937V2.13573C14.5931 1.38255 15.1018 0.772095 15.7294 0.772095C16.3571 0.772095 16.8658 1.38255 16.8658 2.13573V3.49937"
        stroke="#FD8B1F"
        stroke-width="1.08225"
      />
      <path
        d="M1.41125 7.81748H20.5022"
        stroke="#FD8B1F"
        stroke-width="1.08225"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.056 19.4085H3.85655C2.50608 19.4085 1.41125 18.3041 1.41125 16.9413V3.49939H20.5022V16.9413C20.5022 18.3041 19.4069 19.4085 18.056 19.4085Z"
        stroke="#3270D8"
        stroke-width="1.08225"
      />
    </svg>
  );
}

export function HomeServicesIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M11.6562 4.15625C11.8437 3.96875 12.125 3.96875 12.3125 4.15625L15 6.5V5.75C15 5.34375 15.3125 5 15.75 5H18.25C18.6562 5 19 5.34375 19 5.75V10.0312L20.8125 11.625C21.0312 11.8125 21.0312 12.125 20.8437 12.3438C20.6875 12.5625 20.375 12.5625 20.1562 12.375L19 11.3438V17.5C19 18.9062 17.875 20 16.5 20H7.49998C6.09373 20 4.99998 18.9062 4.99998 17.5V11.3438L3.81248 12.375C3.59373 12.5625 3.28123 12.5625 3.12498 12.3438C2.93748 12.125 2.93748 11.8125 3.15623 11.625L11.6562 4.15625ZM18 6H16V7.375L18 9.15625V6ZM5.99998 10.4688V17.5C5.99998 18.3438 6.65623 19 7.49998 19H16.5C17.3125 19 18 18.3438 18 17.5V10.4688L12 5.1875L5.99998 10.4688Z"
        fill="#3270D8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 10C14.0313 10 14.5 10.4688 14.5 11V14C14.5 14.5625 14.0313 15 13.5 15H10.4688C9.9375 15 9.46875 14.5625 9.46875 14V11C9.46875 10.4688 9.9375 10 10.4688 10H13.5ZM10.5 11H13.5V14H10.5V11Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function RestorationIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M11.0312 15.8437C10.8438 15.5312 10.4688 15.4687 10.2188 15.7187L7.375 18.5624C6.90625 19.0312 6.15625 19.1562 5.59375 18.7812C4.875 18.2812 4.78125 17.2499 5.375 16.6562L9.59375 12.4374C9.78125 12.2499 9.78125 11.9374 9.59375 11.7499C9.40625 11.5624 9.09375 11.5624 8.875 11.7499L4.65625 15.9687C3.71875 16.8749 3.71875 18.3749 4.65625 19.3124C5.1875 19.8437 5.90625 20.0937 6.65625 19.9999C7.1875 19.9062 7.6875 19.6249 8.0625 19.2499L10.9062 16.4062C11.0625 16.2499 11.0938 16.0312 11 15.8437C11.0312 15.8437 11.0312 15.8437 11.0312 15.8437ZM12.0938 6.78118C12.25 6.53118 12.4375 6.31243 12.625 6.09368C13.3438 5.40618 14.2812 4.99993 15.25 4.99993C15.4688 4.99993 15.6875 5.03118 15.9062 5.06243L13.75 7.24993L14.1562 9.84368L16.75 10.2499L18.9375 8.09368C19.125 9.28118 18.75 10.4999 17.9062 11.3749C17.75 11.4999 17.5938 11.6249 17.4375 11.7499C17.2188 11.9062 17.1875 12.2812 17.4062 12.4687C17.5938 12.6562 17.875 12.6874 18.0625 12.5312C18.25 12.4062 18.4375 12.2499 18.5938 12.0624C19.7812 10.8749 20.25 9.21868 19.8438 7.59368C19.7812 7.31243 19.5312 7.06243 19.25 6.96868C18.9375 6.90618 18.625 6.96868 18.4062 7.18743L16.4062 9.18743L15.0312 8.96868L14.8125 7.59368L16.7812 5.59368C17 5.37493 17.0938 5.06243 17 4.74993C16.9375 4.46868 16.6875 4.21868 16.4062 4.15618C14.7812 3.74993 13.125 4.21868 11.9375 5.40618C11.6562 5.65618 11.4375 5.93743 11.2812 6.24993C11.1562 6.43743 11.1875 6.71868 11.3438 6.87493C11.5625 7.09368 11.9375 7.06243 12.0938 6.78118ZM5.96875 17.4999C5.96875 17.7812 6.1875 17.9687 6.46875 17.9687C6.71875 17.9687 6.9375 17.7499 6.9375 17.4999C6.9375 17.2812 6.6875 17.0312 6.46875 17.0312C6.21875 17.0312 5.96875 17.2499 5.96875 17.4999Z"
        fill="#3270D8"
      />
      <path
        d="M19.6875 16.1875L15.8125 12.2812C15.3125 11.8125 14.6875 11.5625 14.0312 11.5625C13.5625 11.5625 13.0625 11.6875 12.6562 11.9688L9.96875 9.3125V7L6 4L4 6L7 9.96875H9.28125L11.9375 12.625C11.3125 13.5938 11.4062 14.9062 12.2812 15.7812L16.1562 19.6562C16.3438 19.9062 16.5938 20 16.875 20C17.125 20 17.375 19.9062 17.5625 19.7188L19.6562 17.5938C20.0938 17.2188 20.0938 16.5625 19.6875 16.1875ZM8.96875 9H7.5L5.3125 6.09375L6.0625 5.34375L8.9375 7.5V9H8.96875ZM16.875 19L12.9688 15.125C12.6875 14.8438 12.5312 14.4688 12.5312 14.0625C12.5312 13.6562 12.6875 13.2812 12.9688 13C13.25 12.7188 13.625 12.5625 14.0312 12.5625C14.4375 12.5625 14.8125 12.7188 15.0938 13L18.9688 16.875L16.875 19Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function PlumbingIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M15 9H14.4375C13.8125 7.96875 12.75 7.21875 11.5 7.0625V6H15.5C15.75 6 16 5.78125 16 5.5C16 5.25 15.75 5.03125 15.5 5.03125L11.5 5V4.5C11.5 4.25 11.25 4 11 4C10.7188 4 10.5 4.25 10.5 4.5V5L6.46875 5.03125C6.21875 5.03125 6 5.25 6 5.5C6 5.78125 6.21875 6 6.5 6H10.5V7.0625C9.21875 7.21875 8.15625 7.96875 7.53125 9H4.5C4.21875 9 4 9.25 4 9.5C4 9.78125 4.21875 10 4.5 10H8.15625C8.59375 8.84375 9.6875 8 11 8C12.2812 8 13.375 8.84375 13.8125 10H15C17.1875 10 19 11.8125 19 14H17C17 12.9062 16.0938 12 15 12H13.8125C13.375 13.1875 12.2812 14 11 14C9.6875 14 8.59375 13.1875 8.15625 12H4.5C4.21875 12 4 12.25 4 12.5C4 12.7812 4.21875 13 4.5 13H7.53125C8.21875 14.2188 9.5 15 11 15C12.4688 15 13.75 14.2188 14.4375 13H15.0312C15.5938 13 15.9688 13.4688 15.9688 14.0312C16 14.5625 16.4375 15 17 15H19C19.5312 15 19.9688 14.5625 20 14.0312C20 11.25 17.75 9 15 9Z"
        fill="#3270D8"
      />
      <path
        d="M17.5625 16.1875C17.25 16.6875 16.5 17.8438 16.5 18.4688C16.5 19.3125 17.1562 19.9688 18 19.9688C18.8125 19.9688 19.5 19.3125 19.5 18.4688C19.5 17.8438 18.7188 16.6875 18.4062 16.1875C18.2188 15.9375 17.75 15.9375 17.5625 16.1875ZM18 18.9688C17.7188 18.9688 17.5 18.75 17.5 18.4688C17.5 18.3438 17.6875 17.9062 18 17.4062C18.2812 17.9062 18.4688 18.3438 18.5 18.4688C18.5 18.75 18.25 18.9688 18 18.9688Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function ElectricalIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M6 4C6.25 4 6.5 4.25 6.5 4.5V7.5H5.5V4.5C5.5 4.25 5.71875 4 6 4ZM12 4C12.25 4 12.5 4.25 12.5 4.5V7.5H11.5V4.5C11.5 4.25 11.7188 4 12 4ZM14.5 8.5C14.75 8.5 15 8.75 15 9C15 9.28125 14.75 9.5 14.5 9.5H14V10.625C13.625 10.7812 13.2812 11.0312 13 11.2812V9.5H5V11.5C5 13.7188 6.78125 15.5 9 15.5C9.71875 15.5 10.4062 15.3125 11 14.9688C11 15.1562 11 15.3125 11 15.5C11 15.7188 11 15.9062 11 16.0938C10.5312 16.2812 10.0312 16.4375 9.5 16.5V19.5C9.5 19.7812 9.25 20 9 20C8.71875 20 8.5 19.7812 8.5 19.5V16.5C5.96875 16.25 4 14.0938 4 11.5V9.5H3.5C3.21875 9.5 3 9.28125 3 9C3 8.75 3.21875 8.5 3.5 8.5H14.5Z"
        fill="#3270D8"
      />
      <path
        d="M17.9688 12.9688C18.125 13.0938 18.1562 13.2812 18.0625 13.4375L17.125 15.125H18.25C18.4062 15.125 18.5312 15.25 18.5938 15.4062C18.6562 15.5625 18.5938 15.7188 18.4688 15.8125L15.4688 18.0625C15.3125 18.1562 15.125 18.1562 15 18.0312C14.8438 17.9375 14.8125 17.75 14.9062 17.5938L15.8438 15.875H14.75C14.5625 15.875 14.4375 15.7812 14.375 15.625C14.3125 15.4688 14.375 15.3125 14.5 15.2188L17.5 12.9688C17.6562 12.8438 17.8438 12.875 17.9688 12.9688ZM21 15.5C21 18 18.9688 20 16.5 20C14 20 12 18 12 15.5C12 13.0312 14 11 16.5 11C18.9688 11 21 13.0312 21 15.5ZM16.5 12C14.5625 12 13 13.5938 13 15.5C13 17.4375 14.5625 19 16.5 19C18.4062 19 20 17.4375 20 15.5C20 13.5938 18.4062 12 16.5 12Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function HvacIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M19 5H5C3.875 5 3 5.90625 3 7V11C3 12.125 3.875 13 5 13H19C20.0938 13 21 12.125 21 11V7C21 5.90625 20.0938 5 19 5ZM20 11C20 11.5625 19.5312 12 19 12H5C4.4375 12 4 11.5625 4 11V7C4 6.46875 4.4375 6 5 6H19C19.5312 6 20 6.46875 20 7V11ZM17.5 9H6.5C6.21875 9 6 9.25 6 9.5C6 9.78125 6.21875 10 6.5 10H17.5C17.75 10 18 9.78125 18 9.5C18 9.25 17.75 9 17.5 9Z"
        fill="#3270D8"
      />
      <path
        d="M10 18C10 19.125 9.09375 20 8 20C7.15625 20 6.5 19.3438 6.5 18.5C6.5 17.6875 7.15625 17 8 17C8.25 17 8.5 16.7812 8.5 16.5C8.5 16.25 8.25 16 8 16C6.59375 16 5.5 17.125 5.5 18.5C5.5 19.8438 6.59375 21 8 21C9.625 21 11 19.6562 11 18V14H10V18ZM16 15C15.7188 15 15.5 15.25 15.5 15.5C15.5 15.75 15.7188 16 16 16C16.8125 16 17.5 16.6875 17.5 17.5C17.5 18.3438 16.8125 19 16 19C14.875 19 14 18.125 14 17V14H13V17C13 18.6562 14.3438 20 16 20C17.375 20 18.5 18.9062 18.5 17.5C18.5 16.125 17.375 15 16 15Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function ConstructionIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M18.9976 18.7812C18.5913 17.1562 17.1226 16 15.4663 16H8.56006C6.87256 16 5.43506 17.1562 5.02881 18.7812C4.87256 19.4062 5.37256 20 6.02881 20H17.9976C18.6538 20 19.1538 19.4062 18.9976 18.7812ZM6.02881 19C6.31006 17.8438 7.37256 17 8.56006 17H15.4351C16.6226 17 17.6851 17.8438 17.9976 19H6.02881ZM15.0913 11C15.0913 12.6562 13.7476 14 12.0913 14C10.4351 14 9.09131 12.6562 9.09131 11C9.09131 10.75 8.87256 10.5 8.59131 10.5C8.31006 10.5 8.09131 10.75 8.09131 11C8.09131 13.2188 9.87256 15 12.0913 15C14.2788 15 16.0913 13.2188 16.0913 11C16.0913 10.75 15.8726 10.5 15.5913 10.5C15.3101 10.5 15.0913 10.75 15.0913 11Z"
        fill="#3270D8"
      />
      <path
        d="M7.52881 9.5H16.5913C16.8413 9.5 17.0913 9.28125 17.0913 9C17.0913 8.75 16.8413 8.5 16.5913 8.5H16.0601C16.0601 6.46875 14.5288 4.8125 12.5601 4.5625V4.5C12.5601 4.25 12.3413 4 12.0601 4C11.7788 4 11.5601 4.25 11.5601 4.5V4.5625C9.56006 4.8125 8.02881 6.46875 8.02881 8.53125L7.52881 8.5C7.24756 8.5 7.02881 8.75 7.02881 9C7.02881 9.28125 7.24756 9.5 7.52881 9.5ZM12.5601 5.5625C13.9663 5.8125 15.0601 7.03125 15.0601 8.5H12.5601V5.5625ZM9.02881 8.5C9.02881 7 10.1226 5.78125 11.5601 5.53125V8.5H9.02881Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function FranchiseIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M6 12.5V15H18V12.5C18 12.25 18.2188 12 18.5 12C18.75 12 19 12.25 19 12.5V18C19 19.125 18.0938 20 17 20H7C5.875 20 5 19.125 5 18V12.5C5 12.25 5.21875 12 5.5 12C5.75 12 6 12.25 6 12.5ZM6 18C6 18.5625 6.4375 19 7 19H17C17.5312 19 18 18.5625 18 18V16H6V18Z"
        fill="#FD8B1F"
      />
      <path
        d="M16.4877 10.4688C16.3315 10.375 16.2065 10.25 16.0815 10.0938C15.9565 10.25 15.8315 10.375 15.6752 10.4688C15.2065 10.8125 14.644 11 14.0502 11C13.4252 11 12.8627 10.8125 12.4252 10.4688C12.269 10.375 12.1127 10.25 11.9877 10.0938C11.8627 10.25 11.7377 10.375 11.5815 10.4688C11.144 10.8125 10.5815 11 9.95646 11C9.36271 11 8.80021 10.8125 8.33146 10.4688C8.17521 10.375 8.05021 10.25 7.92521 10.0938C7.80021 10.25 7.67521 10.375 7.51896 10.4688C7.05021 10.8125 6.48771 11 5.89396 11C5.76896 11 5.64396 11 5.51896 11C3.76896 10.75 2.95646 8.71875 3.89396 7.25L5.67521 4.4375C5.83146 4.15625 6.11271 4 6.42521 4H17.5815C17.894 4 18.1752 4.15625 18.3315 4.4375L20.1127 7.25C21.0502 8.71875 20.2377 10.75 18.4877 11C18.3627 11 18.2377 11 18.1127 11C17.4877 11 16.9252 10.8125 16.4877 10.4688ZM17.519 5H6.48771L4.73771 7.78125C4.14396 8.71875 4.73771 9.875 5.64396 10C5.73771 10 5.80021 10 5.89396 10C6.39396 10 6.86271 9.78125 7.17521 9.4375C7.36271 9.21875 7.64396 9.09375 7.92521 9.09375C8.20646 9.09375 8.48771 9.21875 8.67521 9.4375C8.98771 9.78125 9.45646 10 9.95646 10C10.4877 10 10.9252 9.78125 11.269 9.4375C11.4565 9.21875 11.7065 9.09375 11.9877 9.09375C12.269 9.09375 12.5502 9.21875 12.7377 9.4375C13.0502 9.78125 13.519 10 14.0502 10C14.5502 10 15.019 9.78125 15.3315 9.4375C15.519 9.21875 15.8002 9.09375 16.0815 9.09375C16.3627 9.09375 16.6127 9.21875 16.8002 9.4375C17.144 9.78125 17.5815 10 18.1127 10C18.2065 10 18.269 10 18.3627 10C19.269 9.875 19.8627 8.71875 19.269 7.78125L17.519 5Z"
        fill="#3270D8"
      />
    </svg>
  );
}

export function RemodelingIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M15.6808 4.49219C16.3683 3.83594 17.462 3.83594 18.1495 4.49219L19.4933 5.83594C20.1495 6.52344 20.1495 7.61719 19.4933 8.30469L9.71202 18.0859C9.33702 18.4297 8.89952 18.7109 8.43077 18.8359L4.64952 19.9609C4.46202 19.9922 4.27452 19.9609 4.14952 19.8359C4.02452 19.7109 3.96202 19.5234 4.02452 19.3359L5.14952 15.5547C5.27452 15.0859 5.55577 14.6484 5.89952 14.2734L15.6808 4.49219ZM17.4308 5.21094C17.1495 4.92969 16.6808 4.92969 16.3683 5.21094L14.6808 6.92969L17.0558 9.30469L18.7745 7.61719C19.0558 7.30469 19.0558 6.83594 18.7745 6.55469L17.4308 5.21094ZM6.08702 15.8359L5.24327 18.7422L8.14952 17.8984C8.46202 17.7734 8.77452 17.6172 8.99327 17.3672L16.337 10.0234L13.962 7.61719L6.61827 14.9922C6.36827 15.2109 6.18077 15.5234 6.08702 15.8359Z"
        fill="#3270D8"
      />
      <path
        d="M9.64844 4.58594L11.8672 6.80469L11.1484 7.49219L10.1484 6.49219L9.08594 7.58594C8.89844 7.77344 8.55469 7.77344 8.36719 7.58594C8.17969 7.39844 8.17969 7.05469 8.36719 6.86719L9.46094 5.80469L8.92969 5.27344C8.55469 4.89844 7.89844 4.89844 7.52344 5.27344L5.77344 7.02344C5.39844 7.39844 5.39844 8.05469 5.77344 8.42969L7.99219 10.6484L7.30469 11.3672L5.08594 9.14844C4.30469 8.36719 4.30469 7.08594 5.08594 6.30469L6.80469 4.58594C7.58594 3.80469 8.86719 3.80469 9.64844 4.58594ZM14.8047 18.8672L12.5859 16.6484L13.3047 15.9609L15.5234 18.1797C15.8984 18.5547 16.5547 18.5547 16.9297 18.1797L18.6797 16.4297C19.0547 16.0547 19.0547 15.3984 18.6797 15.0234L18.1484 14.4922L17.0859 15.5859C16.8984 15.7734 16.5547 15.7734 16.3672 15.5859C16.1797 15.3984 16.1797 15.0547 16.3672 14.8672L17.4609 13.8047L16.4609 12.8047L17.1484 12.0859L19.3672 14.3047C20.1484 15.0859 20.1484 16.3672 19.3672 17.1484L17.6484 18.8672C16.8672 19.6484 15.5859 19.6484 14.8047 18.8672Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function LandscapingIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M9 12C9.53125 12 10 12.4688 10 13V15C10 15.5625 9.53125 16 9 16H7C6.4375 16 6 15.5625 6 15V13C6 12.4688 6.4375 12 7 12H9ZM9 13H7V15H9V13ZM2 18V12.9062C2 12.3438 2.21875 11.8125 2.625 11.4062L6.625 7.75C7.40625 7.0625 8.5625 7.0625 9.34375 7.75L13.3438 11.4062C13.75 11.8125 14 12.3438 14 12.9062V18C14 19.125 13.0938 20 12 20H4C2.875 20 2 19.125 2 18ZM3 12.9062V18C3 18.5625 3.4375 19 4 19H12C12.5312 19 13 18.5625 13 18V12.9062C13 12.625 12.875 12.3438 12.6562 12.1562L8.65625 8.5C8.28125 8.125 7.6875 8.125 7.3125 8.5L3.3125 12.1562C3.09375 12.3438 2.96875 12.625 2.96875 12.9062H3Z"
        fill="#3270D8"
      />
      <path
        d="M11.75 8.49219L11 7.80469L14 4.49219C14.5938 3.83594 15.625 3.83594 16.2188 4.49219L19.875 8.55469C20.0312 8.74219 20.125 8.92969 20.125 9.14844C20.125 9.61719 19.7188 9.99219 19.25 9.99219H18.1562L20.875 13.3359C21.0312 13.5234 21.125 13.7422 21.125 13.9922C21.125 14.5547 20.6562 14.9922 20.0938 14.9922H18.75L21.875 18.4297C22.0312 18.5859 22.125 18.8047 22.125 19.0547C22.125 19.5859 21.6875 19.9922 21.1562 19.9922H14.625C14.8125 19.7109 15 19.3672 15.0625 18.9922H21.0312L17.25 14.8359C17.0938 14.7109 17.0625 14.4922 17.1562 14.3047C17.2188 14.1172 17.4062 13.9922 17.625 13.9922H20.0938H20.125C20.125 13.9609 20.0938 13.9609 20.0938 13.9609L16.7188 9.83594C16.5938 9.67969 16.5625 9.46094 16.6562 9.30469C16.75 9.11719 16.9062 8.99219 17.125 8.99219H18.9375L15.4688 5.17969C15.2812 4.96094 14.9375 4.96094 14.75 5.17969L11.75 8.49219Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function ServiceMinderIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M20.5846 10.695H19.8265C19.7079 10.6904 19.5933 10.6501 19.4979 10.5794C19.4025 10.5087 19.3306 10.4109 19.2917 10.2986L18.2533 7.88596C18.2001 7.78108 18.18 7.6625 18.1958 7.54596C18.2116 7.42942 18.2624 7.32044 18.3415 7.23346L18.8608 6.71423C18.938 6.63614 18.9814 6.53072 18.9814 6.42086C18.9814 6.31101 18.938 6.20559 18.8608 6.1275L17.6233 4.90384C17.5449 4.82647 17.4392 4.78309 17.329 4.78309C17.2189 4.78309 17.1132 4.82647 17.0348 4.90384L16.4792 5.46288C16.3913 5.54307 16.2815 5.5954 16.1639 5.61326C16.0462 5.63113 15.9259 5.61373 15.8181 5.56327L13.7187 4.71865C13.6081 4.68162 13.5112 4.6124 13.4402 4.51989C13.3693 4.42738 13.3277 4.31578 13.3206 4.19942V3.41365C13.3201 3.30409 13.2764 3.19914 13.1989 3.12166C13.1214 3.04418 13.0165 3.00046 12.9069 3L11.1571 3C11.0473 3 10.9419 3.04352 10.864 3.12105C10.7862 3.19858 10.7422 3.30379 10.7417 3.41365V4.19077C10.7369 4.30976 10.6968 4.42463 10.6266 4.52078C10.5563 4.61693 10.459 4.69003 10.3471 4.73077L7.91193 5.76923C7.8086 5.82365 7.69099 5.84487 7.57515 5.83C7.45931 5.81514 7.35087 5.7649 7.26463 5.68615L6.7177 5.13923C6.63991 5.06207 6.53477 5.01878 6.4252 5.01878C6.31563 5.01878 6.2105 5.06207 6.1327 5.13923L4.90386 6.375C4.86519 6.41344 4.8345 6.45915 4.81356 6.5095C4.79261 6.55984 4.78183 6.61383 4.78183 6.66836C4.78183 6.72289 4.79261 6.77688 4.81356 6.82723C4.8345 6.87758 4.86519 6.92328 4.90386 6.96173L5.49751 7.55711C5.57832 7.64431 5.63135 7.75358 5.64984 7.87101C5.66833 7.98844 5.65146 8.10873 5.60136 8.21653L4.77232 10.2935C4.73633 10.4046 4.6674 10.5022 4.57467 10.5733C4.48194 10.6444 4.36979 10.6856 4.25309 10.6915H3.41194C3.35747 10.6918 3.30358 10.7027 3.25337 10.7238C3.20315 10.745 3.1576 10.7758 3.11933 10.8145C3.08106 10.8533 3.05081 10.8992 3.03034 10.9497C3.00986 11.0002 2.99956 11.0542 3.00001 11.1086V12.8654C2.99979 12.9197 3.01026 12.9735 3.03084 13.0238C3.05142 13.0741 3.0817 13.1198 3.11995 13.1584C3.1582 13.197 3.20367 13.2276 3.25377 13.2486C3.30387 13.2696 3.35762 13.2805 3.41194 13.2808H4.23751C4.35606 13.2858 4.47037 13.3263 4.5657 13.3969C4.66102 13.4676 4.73299 13.5652 4.77232 13.6771L5.78828 16.0708C5.84324 16.1746 5.86475 16.2928 5.84988 16.4093C5.83501 16.5258 5.78447 16.6349 5.7052 16.7215L5.13578 17.2875C5.05863 17.3653 5.01533 17.4704 5.01533 17.58C5.01533 17.6896 5.05863 17.7947 5.13578 17.8725L6.37501 19.0961C6.41328 19.1345 6.45873 19.1649 6.50877 19.1857C6.55882 19.2065 6.61247 19.2172 6.66665 19.2172C6.72083 19.2172 6.77447 19.2065 6.82452 19.1857C6.87456 19.1649 6.92002 19.1345 6.95828 19.0961L7.56751 18.4921C7.65447 18.4113 7.76388 18.3588 7.88131 18.3415C7.99873 18.3242 8.11864 18.3429 8.2252 18.3952L10.3471 19.2415C10.4582 19.2799 10.5552 19.3507 10.6256 19.4448C10.6959 19.5389 10.7364 19.652 10.7417 19.7694V20.5794C10.7422 20.6893 10.7862 20.7945 10.864 20.872C10.9419 20.9495 11.0473 20.9931 11.1571 20.9931H12.9069C13.0165 20.9926 13.1214 20.9489 13.1989 20.8714C13.2764 20.7939 13.3201 20.689 13.3206 20.5794V19.7763C13.3257 19.658 13.3665 19.544 13.4375 19.4492C13.5086 19.3544 13.6065 19.2832 13.7187 19.245L16.0915 18.2308C16.1959 18.1772 16.3142 18.1568 16.4305 18.1723C16.5467 18.1878 16.6555 18.2384 16.7423 18.3173L17.2788 18.8556C17.3566 18.9327 17.4618 18.976 17.5713 18.976C17.6809 18.976 17.786 18.9327 17.8638 18.8556L19.0962 17.6233C19.1733 17.5455 19.2166 17.4403 19.2166 17.3308C19.2166 17.2212 19.1733 17.1161 19.0962 17.0383L18.525 16.4688C18.4455 16.3812 18.3938 16.2718 18.3765 16.1547C18.3593 16.0376 18.3772 15.918 18.4281 15.8111L19.2935 13.6719C19.3308 13.5591 19.4016 13.4603 19.4966 13.3889C19.5915 13.3174 19.7061 13.2767 19.8248 13.2721H20.5829C20.6919 13.2726 20.7967 13.2302 20.8747 13.1541C20.9527 13.078 20.9977 12.9743 21 12.8654V11.1086C20.9995 10.9988 20.9556 10.8936 20.8777 10.816C20.7999 10.7385 20.6945 10.695 20.5846 10.695Z"
        fill="#4D4D4D"
      />
      <path
        d="M14.9994 12.019C14.9997 12.6127 14.8239 13.1932 14.4943 13.687C14.1647 14.1808 13.696 14.5657 13.1475 14.7931C12.5991 15.0204 11.9955 15.08 11.4132 14.9643C10.8308 14.8485 10.2959 14.5626 9.87609 14.1428C9.45627 13.723 9.1704 13.1881 9.05465 12.6058C8.93891 12.0234 8.99849 11.4199 9.22585 10.8714C9.45322 10.3229 9.83815 9.85424 10.332 9.5246C10.8258 9.19496 11.4062 9.01919 12 9.01953C12.3938 9.01953 12.7839 9.09711 13.1478 9.24785C13.5117 9.39858 13.8423 9.61952 14.1209 9.89804C14.3994 10.1766 14.6203 10.5072 14.7711 10.8711C14.9218 11.235 14.9994 11.6251 14.9994 12.019Z"
        fill="#F58220"
      />
      <path
        d="M17.5488 11.9998C17.5485 10.7649 17.1361 9.56536 16.377 8.59131C15.6178 7.61725 14.5554 6.92437 13.3579 6.62244C12.1604 6.32052 10.8965 6.42681 9.76625 6.92449C8.63603 7.42216 7.7042 8.28276 7.1184 9.36992C6.5326 10.4571 6.32633 11.7086 6.53228 12.9263C6.73822 14.1439 7.3446 15.258 8.25534 16.0921C9.16607 16.9261 10.3291 17.4324 11.5601 17.5307C12.7911 17.629 14.0198 17.3137 15.0513 16.6348C15.1393 16.9284 15.33 17.1805 15.5886 17.345C15.8472 17.5095 16.1563 17.5754 16.4595 17.5307C16.7627 17.4859 17.0396 17.3335 17.2397 17.1013C17.4397 16.8691 17.5494 16.5726 17.5488 16.2662V11.9998ZM12 14.9992C11.4067 14.9992 10.8268 14.8233 10.3336 14.4938C9.84034 14.1642 9.45589 13.6957 9.22887 13.1477C9.00186 12.5996 8.94246 11.9965 9.05819 11.4147C9.17392 10.8328 9.45959 10.2984 9.87907 9.87891C10.2985 9.45944 10.833 9.17377 11.4148 9.05804C11.9967 8.9423 12.5997 9.0017 13.1478 9.22872C13.6959 9.45574 14.1643 9.84018 14.4939 10.3334C14.8235 10.8267 14.9994 11.4066 14.9994 11.9998C14.9994 12.3937 14.9218 12.7837 14.7711 13.1477C14.6203 13.5116 14.3994 13.8422 14.1209 14.1207C13.8424 14.3993 13.5117 14.6202 13.1478 14.7709C12.7839 14.9217 12.3939 14.9992 12 14.9992Z"
        fill="white"
      />
    </svg>
  );
}

export function ConstantContactIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4575 10.445C14.6079 10.901 15.0288 11.175 15.5094 11.175C15.6298 11.175 15.7498 11.1444 15.8701 11.1139C16.441 10.9014 16.7416 10.2626 16.5313 9.6849C16.1706 8.68135 15.4192 7.89072 14.3676 7.40421C13.8267 7.16078 13.1656 7.40421 12.8951 7.95141C12.6548 8.49895 12.8951 9.16787 13.436 9.44147C13.9768 9.6849 14.3074 10.0195 14.4578 10.445H14.4575ZM14.0972 3.45072C13.4961 3.32901 12.9252 3.72432 12.8049 4.33255C12.6849 4.94078 13.0753 5.51884 13.6763 5.64021C16.1706 6.12707 17.8533 7.8297 18.2742 10.2928C18.3644 10.8403 18.8454 11.2055 19.3559 11.2055C19.416 11.2055 19.4762 11.2055 19.5364 11.1746C20.1374 11.0532 20.5278 10.4752 20.4379 9.89781C19.8666 6.55255 17.493 4.11964 14.0972 3.45072Z"
        fill="#FF9E1A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3023 14.5807C10.3105 14.5807 9.46919 13.7595 9.46919 12.7258C9.46919 11.7219 10.2805 10.8706 11.3023 10.8706C11.9033 10.8706 12.4144 10.3838 12.4144 9.74537C12.4144 9.10663 11.9334 8.62012 11.3023 8.62012C9.07843 8.62012 7.27539 10.4448 7.27539 12.6953C7.27539 14.9455 9.07843 16.7702 11.3023 16.7702C13.5262 16.7702 15.3292 14.9455 15.3292 12.6953C15.3292 12.0871 14.8482 11.5701 14.2171 11.5701C13.6161 11.5701 13.1054 12.0566 13.1054 12.6953C13.1354 13.7595 12.2941 14.5807 11.3023 14.5807Z"
        fill="#1856ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9436 11.6307C17.3426 11.6307 16.8315 12.1176 16.8315 12.756C16.8315 15.8578 14.3375 18.3819 11.2722 18.3819C8.20701 18.3819 5.71303 15.8578 5.71303 12.756C5.71303 9.65417 8.20701 7.13005 11.2722 7.13005C11.8733 7.13005 12.3844 6.64354 12.3844 6.00514C12.3844 5.39691 11.9033 4.87988 11.2722 4.87988C7.03506 4.87988 3.54932 8.4072 3.54932 12.7255C3.54932 17.0438 7.03506 20.5714 11.3023 20.5714C15.5696 20.5714 19.0553 17.0434 19.0553 12.7255C19.0553 12.1173 18.5747 11.6307 17.9436 11.6307Z"
        fill="#1856ED"
      />
    </svg>
  );
}

export function FranConnectIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M9.08154 13.551L16.0641 9.53223L20.486 11.8321L15.5543 14.3216C13.6101 15.3056 11.168 15.104 9.47276 13.8356L9.08154 13.551Z"
        fill="#55575A"
      />
      <path
        d="M20.4858 11.8319V9.42537C20.4858 8.60738 19.9997 7.87237 19.2529 7.54043L8.71387 3V3.03557C8.83242 4.99163 10.1009 6.75801 12.0688 7.71826L20.4858 11.8319Z"
        fill="#D85D0E"
      />
      <path
        d="M14.4044 9.44896L7.42189 13.4678L3 11.1679L7.93165 8.67839C9.87585 7.69443 12.318 7.89596 14.0132 9.16444L14.4044 9.44896Z"
        fill="#C4C1B3"
      />
      <path
        d="M3 11.168V13.0766C3 14.2028 3.66388 15.2105 4.69525 15.6491L14.7838 19.9999V19.9643C14.6652 18.0083 13.3968 16.2419 11.4288 15.2816L3 11.168Z"
        fill="#004C85"
      />
    </svg>
  );
}

export function ServiceTitanIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M4.61324 19.4943C4.61324 19.4943 5.58192 19.8813 5.58192 20.2683C5.56359 20.358 5.51526 20.4387 5.44491 20.4972C5.37455 20.5557 5.28637 20.5884 5.19489 20.5901C4.872 20.5901 4.42084 20.0737 4.42084 19.8161C4.41511 19.7487 4.43072 19.6813 4.46545 19.6234C4.50018 19.5654 4.55228 19.5199 4.61435 19.4932"
        fill="black"
      />
      <path
        d="M3.58174 14.652C3.51649 14.5879 3.51649 14.652 3.58174 14.652L3.51649 14.5879C3.36217 14.6495 3.23016 14.7564 3.13795 14.8946C3.04574 15.0329 2.99767 15.1958 3.00009 15.3619C3.00009 17.1047 7.71299 17.2982 10.2983 20.4619C10.4427 20.6272 10.6214 20.759 10.8219 20.8482C11.0224 20.9374 11.24 20.9818 11.4594 20.9783C12.0211 20.9696 12.5817 20.9264 13.138 20.8489C13.1716 20.8468 13.2034 20.8325 13.2272 20.8087C13.251 20.7849 13.2653 20.7532 13.2674 20.7195V20.526C10.1015 16.2012 4.09814 17.2352 3.58174 14.652Z"
        fill="black"
      />
      <path
        d="M10.3613 9.16423C10.0384 8.84134 9.19907 9.1001 8.7468 9.48712C8.29453 9.87415 8.48915 10.1329 8.48915 10.1329C8.82326 9.69682 9.30555 9.39824 9.84485 9.29361C10.0255 9.29818 10.2041 9.25345 10.3613 9.16423Z"
        fill="black"
      />
      <path
        d="M20.0447 10.0686C20.0447 10.0686 19.3989 10.198 18.8173 9.5522C18.8173 9.5522 19.076 9.5522 19.1402 9.22931C19.076 9.22931 19.4631 9.93923 20.0447 10.0686ZM19.8512 13.0388C19.8512 13.0388 19.7218 13.7487 18.8825 13.7487C17.9791 13.7487 17.2039 12.5224 16.9452 9.61633C17.1387 9.93923 17.3974 10.2621 17.5268 10.6503C17.5268 10.2621 17.7203 9.5522 16.8169 8.90641C16.8169 8.90641 19.2054 9.42282 19.2696 11.8766C19.2696 12.3289 19.0119 12.7159 18.8825 12.9094C18.8825 12.9094 18.7531 12.9735 18.8173 13.167C18.8825 13.2964 19.076 13.2964 19.2696 13.1029C19.4631 12.9094 19.8512 12.6506 19.8512 13.0388ZM16.4907 14.3945C16.4907 14.3945 15.8438 15.6208 14.9426 15.6208C14.5555 15.6208 14.2979 15.3632 14.2979 15.0392C14.2979 14.7152 14.7491 13.4258 16.6201 13.4258C17.0723 13.4258 17.3941 13.491 17.3941 13.8128C17.4583 14.0063 17.006 14.4586 16.4907 14.3945ZM16.4907 8.26063C16.4907 8.26063 16.2319 8.19649 16.2961 7.80947C16.3551 7.71287 16.3782 7.59853 16.3613 7.48657C16.3613 7.29195 16.4255 7.09844 16.5548 7.0343C16.5548 7.0343 16.8136 7.0343 16.8136 7.74422C16.8136 8.06712 16.4907 8.26063 16.4907 8.26063ZM15.6514 8.26063C15.2633 8.19649 15.522 7.61485 15.2633 7.61485C15.1339 7.61485 15.1339 8.26063 15.0056 8.19649C14.7469 8.00298 14.9404 7.55071 14.9404 7.35719C14.9404 7.16368 15.0697 6.90492 14.8762 7.0343C14.6827 7.16368 14.5533 7.48657 14.4892 7.74422C14.4251 8.00187 14.5533 8.13125 14.6827 8.45414C14.8121 8.77704 14.6219 8.64434 14.6219 8.64434C13.6521 8.06269 14.3631 6.77223 14.3631 6.77223C14.8143 6.0612 15.4601 6.25472 15.4601 6.25472C15.5895 6.31996 15.5895 6.38409 15.5895 6.51347C15.5895 6.64285 15.6547 6.70699 15.783 6.77223C15.9765 6.83637 16.0417 7.02988 16.0417 7.41691C16.0417 7.86918 15.783 8.32145 15.6547 8.25621L15.6514 8.26063ZM17.1387 8.20202L18.7531 8.71843C18.7531 8.71843 19.076 9.29897 18.4303 9.10546C17.8497 8.90641 17.2647 8.77704 17.2647 8.77704C17.1866 8.70618 17.1324 8.61273 17.1098 8.50967C17.0872 8.40662 17.0973 8.29908 17.1387 8.20202ZM9.19797 10.6503C8.03578 10.8438 7.64433 10.5242 7.64433 10.198C7.64433 9.29344 10.2982 8.58352 11.0059 8.58352C11.1342 8.77704 10.8766 8.77704 10.8124 9.09993C10.6831 9.42282 10.4243 9.5522 10.0384 9.61633C9.66446 9.68745 9.31141 9.84205 9.00556 10.0686C8.74791 10.2621 9.00556 10.3915 9.45783 10.2621C9.9101 10.1327 9.97313 10.3263 10.1678 10.2621C10.3624 10.198 10.1678 9.93923 10.296 9.93923C10.4254 9.87509 10.6842 10.0686 10.6842 10.0686L11.3288 10.5242L10.5548 10.9112C10.4906 10.9112 10.4254 10.9754 10.4254 11.1047C10.4254 11.2341 10.8135 11.2341 11.0071 11.2341C11.1353 11.2341 11.2006 11.4918 11.2006 11.4918C11.0071 11.7505 10.4265 11.7505 10.4265 11.7505C10.5559 12.0093 11.2669 11.944 11.3952 12.0093C11.5246 12.0093 11.5246 12.2028 11.6539 12.5257C11.7181 12.8486 12.1692 12.9768 12.1692 12.9768C12.2975 13.491 11.7159 13.6204 11.3288 13.6204C8.93922 13.491 9.19797 10.6503 9.19797 10.6503ZM9.45673 7.0343C9.26211 6.06563 9.65024 4.96868 9.65024 4.96868C9.65024 4.96868 8.68157 5.74273 8.74681 7.0343C7.9064 7.0343 6.68008 7.09844 5.97016 7.74422C4.93734 8.58352 4.80796 10.198 4.74383 10.6503C4.74398 10.6588 4.74239 10.6673 4.73916 10.6752C4.73592 10.6832 4.7311 10.6903 4.72499 10.6963C4.71889 10.7023 4.71163 10.707 4.70365 10.7101C4.69567 10.7132 4.68714 10.7147 4.67859 10.7144H4.61445C4.35569 10.585 3.84039 10.0686 4.22632 8.97166C4.74383 7.55071 6.29305 4.70992 9.32735 4.51641C9.32735 4.51641 10.2949 4.45116 10.8755 4.8393C10.8839 4.83915 10.8923 4.84071 10.9002 4.84388C10.908 4.84705 10.9152 4.85176 10.9211 4.85775C10.9271 4.86374 10.9319 4.87087 10.935 4.87871C10.9382 4.88656 10.9397 4.89497 10.9396 4.90343V4.96868C10.6831 5.16219 9.84376 5.93625 9.585 7.09623C9.5853 7.10478 9.58386 7.11331 9.58076 7.12129C9.57765 7.12927 9.57296 7.13653 9.56696 7.14264C9.56096 7.14874 9.55377 7.15356 9.54585 7.1568C9.53792 7.16003 9.52942 7.16162 9.52086 7.16147C9.52086 7.03209 9.45673 7.03209 9.45673 7.03209V7.0343ZM11.7159 10.8438C11.7159 10.8438 11.9746 12.0723 12.5552 12.5224C12.5552 12.5224 12.5552 12.6506 12.3617 12.6506C12.1681 12.6506 11.8464 12.393 11.7159 11.6831C11.5865 11.0373 11.7159 10.8438 11.7159 10.8438ZM12.5552 7.74754C11.8464 7.74422 11.5224 7.09623 11.5224 7.09623C11.5224 7.09623 12.3617 7.87028 13.5238 7.22561C13.5238 7.28974 13.2651 7.74201 12.5552 7.74201V7.74754ZM21.4668 8.77704C21.2733 8.39001 21.0156 8.13125 20.434 8.00298C19.9187 7.87028 19.4631 7.93884 19.1446 8.20202L18.1118 7.81499C17.9835 7.55624 17.9183 7.29748 17.7889 7.10397C17.7364 6.93751 17.6204 6.79845 17.466 6.71694C16.7517 6.32217 14.8795 5.35571 14.1685 6.32217C14.1331 6.35646 14.1101 6.40161 14.1033 6.45044L13.8456 6.38631C13.7163 5.99928 13.3281 5.67639 12.8128 5.54701C12.4899 5.48177 12.1659 5.48177 11.9083 5.61114C11.8664 5.62352 11.8297 5.6491 11.8035 5.68408C11.7774 5.71905 11.7633 5.76155 11.7633 5.80521C11.7633 5.84888 11.7774 5.89137 11.8035 5.92634C11.8297 5.96132 11.8664 5.98691 11.9083 5.99928L12.7487 6.32217C12.9422 6.38631 13.0716 6.57982 12.9422 6.77444C12.8781 6.96685 12.6845 7.09623 12.491 6.96685C12.491 6.96685 11.9746 6.83858 11.5865 6.7092C11.5417 6.6954 11.4939 6.6941 11.4484 6.70544C11.4029 6.71679 11.3613 6.74035 11.3282 6.77357C11.2951 6.8068 11.2717 6.84844 11.2605 6.894C11.2493 6.93956 11.2507 6.9873 11.2647 7.03209C11.3505 7.25535 11.4894 7.45436 11.6694 7.61195C11.8493 7.76954 12.0649 7.88097 12.2975 7.93663C12.5045 7.98887 12.7198 7.99856 12.9306 7.96511C13.1414 7.93165 13.3432 7.85576 13.5238 7.74201L13.7174 7.80725C13.7174 8.25842 14.1044 8.84007 14.4273 9.03358C14.9437 9.35647 15.396 9.09772 15.9124 8.77482C15.9124 8.77482 17.2681 9.80874 16.6223 12.843C14.9437 13.0366 14.3001 13.6171 13.7174 14.2629C13.3292 14.1335 12.1692 14.0041 11.5224 14.1988C11.7562 13.9613 12.0442 13.784 12.3617 13.6823C12.5552 13.6204 12.6204 13.491 12.6204 13.2964C12.6204 13.2964 13.3945 13.0388 13.3945 12.78C13.3945 12.5213 12.4269 12.5224 12.0388 10.4578C11.9746 10.2002 11.9094 10.0067 11.5224 9.8773C11.5224 9.8773 11.393 9.68379 11.5865 9.42503C11.78 9.16628 11.8464 9.09993 11.78 8.90641C11.7137 8.7129 11.4571 8.58352 11.4571 8.58352V8.26063C11.4571 8.26063 10.6831 7.68009 10.6831 6.84079C10.6831 6.00149 11.78 5.03281 12.0388 4.77406V4.70992C12.0389 4.70146 12.0374 4.69305 12.0342 4.6852C12.031 4.67735 12.0263 4.67022 12.0203 4.66424C12.0143 4.65825 12.0072 4.65353 11.9993 4.65036C11.9915 4.64719 11.9831 4.64563 11.9746 4.64578C11.5865 4.38703 10.8766 4 9.71438 4C5.19499 4 4.16218 8.06712 3.19019 10.0045V10.1327C4.16218 12.0723 5.7114 11.8766 5.84078 13.5552C5.90491 14.8456 5.58202 14.8456 5.32437 14.8456C5.12975 14.8456 4.80796 14.6532 4.67859 14.5239H4.61445C4.61445 14.5239 4.54921 14.588 4.61445 14.588C4.74383 14.9109 5.06561 15.686 6.09953 15.686C6.61594 15.686 6.74421 15.2338 6.74421 14.7815V13.2964C6.73094 13.1594 6.68711 13.0272 6.61594 12.9094C6.29305 12.5865 5.51788 11.8766 5.51788 11.2949C5.51569 11.2435 5.52421 11.1922 5.54288 11.1443C5.56156 11.0963 5.58999 11.0528 5.62637 11.0164C5.66276 10.98 5.7063 10.9516 5.75425 10.9329C5.8022 10.9142 5.8535 10.9057 5.90491 10.9079C6.29305 10.9079 6.67897 11.4884 7.00297 12.2636C7.05686 12.4113 7.14519 12.5439 7.26062 12.6506H7.32586V12.5865C7.20201 12.1342 7.20201 11.6831 7.13235 11.4884C7.11591 11.3916 7.07085 11.3018 7.00297 11.2308C6.68008 10.972 5.90491 10.198 5.90491 9.03579C5.90491 7.48768 8.42281 7.61485 8.93922 7.61485C9.06859 8.13125 9.39149 8.3889 9.585 8.45414C8.81094 8.7129 7.13235 9.29344 7.13235 10.2621C7.13235 11.2949 8.87508 11.2308 8.87508 11.2308C8.87508 11.2308 8.61743 13.2964 10.5537 13.9422C10.5537 13.9422 10.2308 14.2651 9.19797 14.2651C8.22929 14.2651 7.77702 13.8128 7.51937 13.2964C7.51952 13.288 7.51797 13.2796 7.5148 13.2717C7.51163 13.2639 7.50691 13.2567 7.50092 13.2507C7.49494 13.2448 7.48781 13.24 7.47996 13.2369C7.47211 13.2337 7.4637 13.2321 7.45524 13.2323C7.44668 13.232 7.43816 13.2334 7.43018 13.2365C7.4222 13.2396 7.41493 13.2443 7.40883 13.2503C7.40272 13.2563 7.39791 13.2635 7.39467 13.2714C7.39143 13.2794 7.38984 13.2879 7.39 13.2964C7.32586 13.4258 7.32586 13.6846 7.45524 13.9422C7.71289 14.3945 8.09992 14.6532 8.09992 15.2338C8.09992 15.686 7.71289 15.9437 7.51937 16.0078C7.9064 16.072 9.65024 16.5242 10.8124 17.1048C10.9407 17.0395 11.9746 16.3949 12.0388 15.4903C12.0388 15.4903 12.1029 14.9098 11.2647 14.8445C11.6009 14.7519 11.9488 14.7087 12.2975 14.7163C12.9422 14.7163 13.6521 15.2327 12.3617 17.9441V18.0093C12.5552 18.1376 14.0402 19.1063 15.0089 20.0097H15.0731C15.0815 20.0099 15.0899 20.0083 15.0978 20.0051C15.1056 20.002 15.1128 19.9972 15.1187 19.9913C15.1247 19.9853 15.1295 19.9781 15.1326 19.9703C15.1358 19.9624 15.1373 19.954 15.1372 19.9456C15.2666 19.8162 15.5253 19.365 15.6547 18.267C15.6508 18.2408 15.6531 18.214 15.6614 18.1888C15.6697 18.1637 15.6837 18.1408 15.7024 18.122C15.7211 18.1032 15.7439 18.089 15.769 18.0806C15.7941 18.0722 15.8209 18.0697 15.8471 18.0735C16.4288 17.8799 18.3661 17.2994 19.2054 16.1361C20.1741 14.7804 20.5611 14.588 20.5611 14.588C20.5611 14.588 21.2069 14.201 20.9482 13.2323C20.8188 12.7159 20.0447 11.4243 19.2696 10.0686C19.4503 10.1816 19.6461 10.2683 19.8512 10.3263C20.0537 10.3885 20.2667 10.4093 20.4775 10.3872C20.6882 10.3652 20.8923 10.3008 21.0775 10.198C21.1417 10.1327 21.2069 10.0686 21.2069 10.0045C21.2069 9.94033 21.1417 9.87509 21.0775 9.81096L20.2382 9.48806C20.1413 9.44739 20.062 9.37353 20.0146 9.27971C19.9672 9.18589 19.9547 9.07825 19.9795 8.97608C20.0203 8.87799 20.095 8.79786 20.1901 8.75035C20.2851 8.70284 20.394 8.69111 20.497 8.71732L21.271 8.97608C21.3061 8.98051 21.3418 8.97694 21.3753 8.96564C21.4088 8.95434 21.4393 8.9356 21.4646 8.91084C21.5287 8.8467 21.4646 8.91084 21.4646 8.78146"
        fill="black"
      />
      <path
        d="M10.0374 11.2295C10.0374 11.2295 9.71446 11.2947 9.7797 11.81C9.84384 12.2623 10.2309 12.2623 10.2309 12.2623C9.90797 11.8753 10.0374 11.2295 10.0374 11.2295Z"
        fill="black"
      />
      <path
        d="M4.41991 17.6217C5.5821 18.2642 8.16524 19.0383 8.68164 20.3984C8.68164 20.3984 8.87516 20.7213 7.84234 20.7213C7.06829 20.7213 6.87367 20.5278 6.35726 19.882C5.5832 18.9774 3.96874 18.3969 3.96874 17.6859C3.9035 17.7511 3.96874 17.363 4.41991 17.6217Z"
        fill="black"
      />
    </svg>
  );
}

export function PipeDriveIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M3.54932 3.42871H20.4507V20.5716H3.54932V3.42871Z"
        fill="#26292C"
      />
      <path
        d="M10.6552 10.644C10.6552 8.99247 11.576 8.40104 12.4343 8.40104C13.4913 8.40104 14.2029 9.2983 14.2029 10.6238C14.2029 12.1426 13.3027 12.826 12.4133 12.826C11.21 12.826 10.6552 11.6942 10.6552 10.644ZM12.8633 6.45361C11.6075 6.45361 10.8854 7.00424 10.5295 7.39167C10.4876 7.06561 10.2679 6.63738 9.39914 6.63738H7.52612V8.56424H8.29007C8.41548 8.56424 8.45739 8.60504 8.45739 8.73738V17.5461H10.6968V14.243V13.9982C11.0423 14.3143 11.7123 14.7425 12.7588 14.7425C14.9458 14.7425 16.4737 13.0399 16.4737 10.6032C16.4737 8.12573 15.0192 6.45396 12.8636 6.45396L12.8633 6.45361Z"
        fill="white"
      />
    </svg>
  );
}

export function ZenDeskIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M11.7772 8.71222V19.06H3L11.7772 8.71222ZM11.7772 5C11.7772 7.36474 9.8153 9.28032 7.39318 9.28032C4.97144 9.28032 3 7.36474 3 5H11.7772ZM13.2228 19.06C13.2228 16.6953 15.1847 14.7797 17.6068 14.7797C20.0286 14.7797 21.9905 16.6953 21.9905 19.06H13.2228ZM13.2228 15.3478V5H22L13.2228 15.3478Z"
        fill="black"
      />
    </svg>
  );
}

export function SalesForceIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <g clipPath="url(#clip0_1235_30621)">
        <mask
          id="mask0_1235_30621"
          maskUnits="userSpaceOnUse"
          x="2"
          y="5"
          width="20"
          height="14"
        >
          <path
            d="M2.50439 5.53467H21.3352V18.6885H2.50439V5.53467Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1235_30621)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3233 6.97449C10.9312 6.34172 11.7772 5.94987 12.7118 5.94987C13.9579 5.94987 15.0379 6.64218 15.6195 7.67372C16.1357 7.44295 16.6948 7.32381 17.2603 7.3241C19.5033 7.3241 21.3241 9.15872 21.3241 11.4226C21.3241 13.6864 19.5033 15.521 17.2603 15.521C16.9861 15.521 16.7189 15.4935 16.4572 15.4414C15.9483 16.3483 14.9756 16.9645 13.8679 16.9645C13.417 16.9654 12.9718 16.8631 12.5664 16.6654C12.0506 17.8769 10.8495 18.7285 9.45103 18.7285C7.99026 18.7285 6.75103 17.8077 6.27333 16.5131C6.06072 16.558 5.84401 16.5805 5.62672 16.5804C3.88903 16.5804 2.48364 15.1542 2.48364 13.4027C2.48364 12.2258 3.11641 11.2012 4.05518 10.6473C3.85602 10.1885 3.75351 9.69362 3.75403 9.19347C3.75403 7.17193 5.3948 5.53809 7.41633 5.53809C8.60018 5.53809 9.65941 6.10232 10.324 6.97809"
            fill="#00A1E0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.22791 12.3747C5.21608 12.4056 5.23214 12.412 5.23595 12.4175C5.27132 12.4431 5.30725 12.4617 5.34325 12.4825C5.53571 12.5843 5.7171 12.6141 5.90679 12.6141C6.2931 12.6141 6.53333 12.4084 6.53333 12.0775V12.071C6.53333 11.765 6.26195 11.6535 6.00856 11.5739L5.9754 11.5632C5.78363 11.501 5.61817 11.4469 5.61817 11.3209V11.3145C5.61817 11.2065 5.71509 11.1268 5.86463 11.1268C6.03078 11.1268 6.22878 11.1822 6.35548 11.2521C6.35548 11.2521 6.393 11.2764 6.40664 11.2402C6.41404 11.2206 6.47864 11.0477 6.48556 11.0283C6.4929 11.008 6.48002 10.9927 6.4668 10.9848C6.32141 10.8962 6.12064 10.836 5.91295 10.836L5.87439 10.8361C5.52062 10.8361 5.27347 11.0501 5.27347 11.3561V11.3626C5.27347 11.6853 5.54624 11.7905 5.80101 11.8632L5.84199 11.8759C6.02753 11.933 6.18815 11.9825 6.18815 12.1127V12.1192C6.18815 12.239 6.08361 12.3283 5.91607 12.3283C5.85092 12.3283 5.6433 12.3272 5.4183 12.185C5.39109 12.1691 5.37558 12.1577 5.35461 12.1449C5.34353 12.1382 5.31584 12.126 5.30379 12.1623L5.22764 12.3742M10.8838 12.3742C10.872 12.405 10.888 12.4115 10.892 12.417C10.9272 12.4426 10.9633 12.4611 10.9993 12.482C11.1917 12.5837 11.3731 12.6135 11.5628 12.6135C11.9491 12.6135 12.1893 12.4079 12.1893 12.077V12.0705C12.1893 11.7645 11.9187 11.653 11.6646 11.5734L11.6314 11.5626C11.4396 11.5005 11.2742 11.4463 11.2742 11.3203V11.3139C11.2742 11.2059 11.3711 11.1263 11.5206 11.1263C11.6868 11.1263 11.8841 11.1816 12.0115 11.2516C12.0115 11.2516 12.049 11.2758 12.0627 11.2396C12.0701 11.22 12.1347 11.0472 12.141 11.0278C12.1484 11.0075 12.1354 10.9922 12.1223 10.9843C11.9769 10.8957 11.7761 10.8354 11.5684 10.8354L11.5298 10.8356C11.176 10.8356 10.9289 11.0495 10.9289 11.3555V11.3621C10.9289 11.6847 11.2016 11.7899 11.4564 11.8626L11.4973 11.8754C11.6835 11.9324 11.8435 11.982 11.8435 12.1121V12.1186C11.8435 12.2384 11.7389 12.3277 11.5714 12.3277C11.5061 12.3277 11.2979 12.3266 11.0736 12.1844C11.0464 12.1686 11.0305 12.1576 11.0099 12.1443C11.0029 12.1399 10.9703 12.1272 10.9591 12.1618L10.883 12.3736M14.746 11.7256C14.746 11.9125 14.7111 12.06 14.6429 12.1645C14.5748 12.2677 14.4719 12.3182 14.3286 12.3182C14.1853 12.3182 14.0828 12.2681 14.0157 12.1652C13.948 12.0614 13.9139 11.9132 13.9139 11.7263C13.9139 11.5394 13.9482 11.3926 14.0157 11.2895C14.0827 11.187 14.1846 11.1378 14.3286 11.1378C14.4726 11.1378 14.575 11.1875 14.6429 11.2895C14.7116 11.3926 14.746 11.5394 14.746 11.7263M15.0687 11.3795C15.0369 11.2722 14.9877 11.178 14.9219 11.0991C14.856 11.0202 14.773 10.9565 14.674 10.9108C14.5757 10.8647 14.4594 10.8415 14.3279 10.8415C14.1963 10.8415 14.0807 10.8649 13.9817 10.9108C13.8834 10.9567 13.7997 11.0202 13.7339 11.0991C13.6683 11.178 13.619 11.2722 13.5871 11.3795C13.5556 11.4861 13.5396 11.6024 13.5396 11.7263C13.5396 11.8502 13.5556 11.9665 13.5871 12.0732C13.6188 12.1805 13.6681 12.2746 13.7339 12.3535C13.7997 12.4325 13.8834 12.4955 13.9817 12.5405C14.0807 12.5853 14.197 12.6082 14.3279 12.6082C14.4587 12.6082 14.575 12.5853 14.6733 12.5405C14.7717 12.4956 14.8554 12.4325 14.9212 12.3535C14.9869 12.2746 15.0361 12.1805 15.068 12.0732C15.0994 11.9665 15.1154 11.8502 15.1154 11.7263C15.1154 11.6031 15.0994 11.4861 15.068 11.3795M17.7195 12.2656C17.7089 12.2343 17.6783 12.2461 17.6783 12.2461C17.6314 12.264 17.5814 12.2806 17.5281 12.2889C17.4744 12.2974 17.4145 12.3016 17.3515 12.3016C17.1958 12.3016 17.0712 12.2552 16.9825 12.1632C16.8932 12.0711 16.8434 11.9229 16.8441 11.7222C16.8446 11.5394 16.8887 11.4023 16.968 11.2971C17.0462 11.1932 17.1667 11.1392 17.3259 11.1392C17.4588 11.1392 17.5606 11.1547 17.6672 11.188C17.6672 11.188 17.6925 11.199 17.7046 11.1657C17.7329 11.0875 17.7538 11.0314 17.7842 10.9456C17.7928 10.921 17.7718 10.9106 17.7641 10.9077C17.7223 10.8913 17.6235 10.8645 17.5488 10.8532C17.4789 10.8426 17.3979 10.837 17.3065 10.837C17.1708 10.837 17.0503 10.8602 16.9472 10.9062C16.844 10.9521 16.7568 11.0156 16.6875 11.0945C16.6183 11.1734 16.5657 11.2676 16.5304 11.3749C16.4954 11.4815 16.4778 11.5985 16.4778 11.7224C16.4778 11.9897 16.5498 12.2064 16.6924 12.3649C16.835 12.5241 17.0496 12.6044 17.3293 12.6044C17.4948 12.6044 17.6644 12.571 17.7862 12.5227C17.7862 12.5227 17.8095 12.5115 17.7994 12.4844L17.7198 12.2656M18.284 11.5456C18.2994 11.4418 18.3279 11.3552 18.3726 11.2881C18.4396 11.1856 18.5415 11.1295 18.6849 11.1295C18.8282 11.1295 18.923 11.1859 18.9909 11.2881C19.0359 11.3556 19.0555 11.4452 19.0629 11.5456L18.2805 11.5455L18.284 11.5456ZM19.3709 11.3172C19.3434 11.214 19.2754 11.1095 19.2311 11.0617C19.1605 10.9862 19.0919 10.9329 19.0234 10.9038C18.9244 10.8618 18.818 10.8402 18.7105 10.8404C18.5741 10.8404 18.4502 10.8634 18.3498 10.9103C18.2494 10.9575 18.1649 11.0217 18.0985 11.1021C18.0321 11.1824 17.9822 11.2772 17.9503 11.3859C17.9185 11.4932 17.9024 11.6109 17.9024 11.7341C17.9024 11.8601 17.9191 11.9771 17.9519 12.0831C17.9851 12.1897 18.0384 12.2831 18.1104 12.3607C18.1824 12.4389 18.2745 12.4998 18.3853 12.5427C18.4954 12.5853 18.629 12.6074 18.782 12.6069C19.0977 12.6059 19.2638 12.5356 19.3317 12.4975C19.3438 12.4908 19.3552 12.4791 19.341 12.4453L19.2696 12.2453C19.2587 12.2154 19.2285 12.2262 19.2285 12.2262C19.1503 12.2554 19.0395 12.3079 18.7799 12.3072C18.6103 12.3069 18.485 12.2569 18.4061 12.1785C18.3258 12.0981 18.2856 11.9811 18.2794 11.815L19.3732 11.8158C19.3732 11.8158 19.402 11.8155 19.405 11.7874C19.4062 11.7758 19.4424 11.5631 19.3724 11.3174L19.3709 11.3172ZM9.54016 11.5456C9.5556 11.4418 9.58412 11.3552 9.62878 11.2881C9.69579 11.1856 9.7977 11.1295 9.94101 11.1295C10.0843 11.1295 10.1792 11.1859 10.247 11.2881C10.2919 11.3556 10.3116 11.4452 10.319 11.5456L9.5367 11.5455L9.54016 11.5456ZM10.6271 11.3172C10.5997 11.214 10.5315 11.1095 10.4872 11.0617C10.4166 10.9862 10.3481 10.9329 10.2795 10.9038C10.1806 10.8618 10.0741 10.8402 9.96662 10.8404C9.83024 10.8404 9.70631 10.8634 9.60593 10.9103C9.50554 10.9575 9.42108 11.0217 9.35462 11.1021C9.28837 11.1824 9.23831 11.2772 9.20647 11.3859C9.17469 11.4932 9.1587 11.6109 9.1587 11.7341C9.1587 11.8601 9.17524 11.9771 9.20827 12.0831C9.24136 12.1897 9.29481 12.2831 9.36611 12.3607C9.43811 12.4389 9.53019 12.4998 9.64096 12.5427C9.75104 12.5853 9.88396 12.6074 10.0377 12.6069C10.3533 12.6059 10.5195 12.5356 10.5873 12.4975C10.5994 12.4908 10.6109 12.4791 10.5966 12.4453L10.5252 12.2453C10.5142 12.2154 10.4841 12.2262 10.4841 12.2262C10.4058 12.2554 10.2951 12.3079 10.0354 12.3072C9.86651 12.3069 9.74051 12.2569 9.66159 12.1785C9.58128 12.0981 9.54113 11.9811 9.5349 11.815L10.6287 11.8158C10.6287 11.8158 10.6575 11.8155 10.6605 11.7874C10.6617 11.7758 10.698 11.5631 10.6278 11.3174L10.6271 11.3172ZM7.17939 12.2587C7.13654 12.2245 7.13058 12.2161 7.11639 12.1939C7.09472 12.1605 7.08365 12.1129 7.08365 12.052C7.08365 11.9564 7.11549 11.8872 7.18126 11.8408C7.18057 11.841 7.27541 11.7591 7.49834 11.7619C7.59756 11.7637 7.69655 11.7721 7.79464 11.7872V12.2835H7.79478C7.79478 12.2835 7.65632 12.3134 7.49986 12.3228C7.27763 12.3362 7.17932 12.2588 7.18001 12.259L7.17939 12.2587ZM7.61416 11.4902C7.56985 11.487 7.51239 11.4854 7.44385 11.4854C7.35039 11.4854 7.2597 11.497 7.17524 11.5199C7.09008 11.5428 7.01324 11.5784 6.94747 11.6258C6.88152 11.6728 6.82727 11.7344 6.78893 11.8058C6.75023 11.8778 6.7305 11.9622 6.7305 12.0578C6.7305 12.1547 6.74732 12.2385 6.78055 12.307C6.81312 12.375 6.86214 12.4338 6.92317 12.478C6.98388 12.5222 7.05886 12.5549 7.1454 12.5742C7.23124 12.5938 7.32817 12.6037 7.43478 12.6037C7.54694 12.6037 7.6584 12.5943 7.7664 12.5761C7.85838 12.5603 7.95002 12.5424 8.04124 12.5227C8.07766 12.5143 8.11809 12.5033 8.11809 12.5033C8.14509 12.4964 8.14301 12.4676 8.14301 12.4676L8.14239 11.4706C8.14239 11.2519 8.08396 11.0892 7.96862 10.9888C7.8537 10.8884 7.68547 10.8379 7.46739 10.8379C7.3857 10.8379 7.25347 10.8489 7.17454 10.8648C7.17454 10.8648 6.93639 10.911 6.83808 10.988C6.83808 10.988 6.81648 11.0013 6.82825 11.0314L6.90579 11.2391C6.91541 11.2661 6.94165 11.2569 6.94165 11.2569C6.94165 11.2569 6.94989 11.2536 6.95958 11.2479C7.16935 11.1336 7.4352 11.1371 7.4352 11.1371C7.55289 11.1371 7.64428 11.161 7.7052 11.2077C7.76481 11.2535 7.7952 11.3226 7.7952 11.468V11.5142C7.70174 11.5006 7.6152 11.4928 7.6152 11.4928L7.61416 11.4902ZM16.4065 10.9274C16.408 10.9237 16.4089 10.9198 16.4089 10.9158C16.4089 10.9119 16.4081 10.9079 16.4066 10.9042C16.4051 10.9006 16.4028 10.8973 16.4 10.8945C16.3971 10.8917 16.3938 10.8895 16.3901 10.8881C16.3714 10.881 16.2786 10.8614 16.2073 10.857C16.0702 10.8484 15.9941 10.8715 15.9255 10.9023C15.8578 10.9328 15.7829 10.9819 15.7414 11.0386L15.7412 10.9057C15.7412 10.8874 15.7283 10.8727 15.7099 10.8727H15.4302C15.412 10.8727 15.3989 10.8874 15.3989 10.9057V12.5326C15.3989 12.5414 15.4024 12.5499 15.4086 12.5561C15.4148 12.5623 15.4233 12.5658 15.432 12.5658H15.7187C15.7274 12.5658 15.7359 12.5623 15.7421 12.5561C15.7483 12.5498 15.7518 12.5414 15.7518 12.5326V11.7157C15.7518 11.6063 15.7638 11.4976 15.7878 11.4291C15.8115 11.3613 15.8437 11.3073 15.8834 11.2685C15.9212 11.231 15.9675 11.2033 16.0184 11.1875C16.0661 11.1738 16.1155 11.1668 16.1651 11.1669C16.2222 11.1669 16.2849 11.1815 16.2849 11.1815C16.3059 11.1839 16.3176 11.171 16.3248 11.152C16.3435 11.1021 16.3968 10.9527 16.4072 10.9229"
            fill="#FFFFFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7295 10.1763C13.6941 10.1656 13.658 10.1571 13.6216 10.1507C13.5725 10.1425 13.5229 10.1387 13.4731 10.1392C13.2756 10.1392 13.1199 10.195 13.0106 10.3052C12.9021 10.4146 12.8282 10.5812 12.7912 10.8005L12.7778 10.8745H12.5299C12.5299 10.8745 12.4996 10.8733 12.4933 10.9063L12.4525 11.1334C12.4497 11.1551 12.4591 11.1687 12.4881 11.1685H12.7295L12.4846 12.5354C12.4654 12.6454 12.4435 12.736 12.4192 12.8046C12.3952 12.8723 12.3718 12.923 12.343 12.9599C12.3151 12.9955 12.2887 13.0218 12.2431 13.0371C12.2054 13.0497 12.1621 13.0556 12.1146 13.0556C12.0881 13.0556 12.0529 13.0511 12.027 13.0459C12.001 13.0408 11.9875 13.035 11.9681 13.0268C11.9681 13.0268 11.9398 13.016 11.9286 13.0444C11.9195 13.0676 11.8552 13.2445 11.8476 13.2664C11.8399 13.288 11.8507 13.305 11.8644 13.3099C11.8966 13.3214 11.9204 13.3287 11.9642 13.3391C12.025 13.3534 12.0762 13.3543 12.1242 13.3543C12.2247 13.3543 12.3163 13.3402 12.3922 13.3127C12.4687 13.2851 12.5352 13.237 12.5941 13.1719C12.6577 13.1016 12.6977 13.028 12.736 12.9276C12.7738 12.8281 12.8061 12.7046 12.8319 12.5607L13.078 11.1685H13.4377C13.4377 11.1685 13.468 11.1696 13.4743 11.1368L13.515 10.9097C13.5179 10.8879 13.5086 10.8744 13.4794 10.8745H13.1302C13.132 10.8666 13.1478 10.7438 13.1879 10.6282C13.205 10.5788 13.2372 10.539 13.2645 10.5117C13.2899 10.4856 13.3213 10.4661 13.3559 10.4548C13.3939 10.443 13.4334 10.4373 13.4731 10.4379C13.506 10.4379 13.5383 10.4418 13.5629 10.4469C13.5967 10.4541 13.6099 10.4579 13.6187 10.4606C13.6543 10.4714 13.6591 10.4609 13.6661 10.4437L13.7496 10.2144C13.7582 10.1897 13.7373 10.1794 13.7295 10.1763ZM8.85054 12.5383C8.85054 12.5565 8.83752 12.5714 8.81924 12.5714H8.52965C8.51131 12.5714 8.49829 12.5565 8.49829 12.5383V10.2074C8.49829 10.1892 8.51131 10.1744 8.52965 10.1744H8.81924C8.83752 10.1744 8.85054 10.1892 8.85054 10.2074V12.5383Z"
            fill="#FFFFFE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1235_30621">
          <rect
            width="18.9"
            height="13.2231"
            fill="white"
            transform="translate(2.5 5.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AutotaskIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M16.2495 11.1781L18.4268 16.5621H15.0636L13.6351 12.9133L5.89873 18.0497L3 11.9285H3.63792L7.07341 14.5619L13.0293 11.3662L12.18 9.19355L11.2656 11.1051L7.40137 13.1973L10.182 6H14.1553L15.7379 9.91398L21 7.09032V8.02399L16.2495 11.1781Z"
        fill="#003369"
      />
      <path
        d="M5.89873 18.0502L13.6351 12.9138L16.2495 11.1786L21 8.02449V7.09082L15.7379 9.91448L13.0293 11.3667L7.07341 14.5624L3.63792 11.929H3L5.89873 18.0502Z"
        fill="#FC0000"
      />
    </svg>
  );
}

export function ZapierIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M20.8471 10.4304H15.5242L19.2646 6.71992C18.9766 6.29153 18.689 6.00641 18.4013 5.57802C17.9873 5.28102 17.6021 4.94659 17.2508 4.57903L13.5111 8.28986V3.15165C13.0414 3.03393 12.5564 2.98605 12.0726 3.00909C11.5881 2.97813 11.1021 3.02637 10.6333 3.15165V8.43278L6.74972 4.57939C6.30297 4.83355 5.91165 5.17302 5.59846 5.57838C5.31046 6.00641 4.87919 6.29189 4.59155 6.71992L8.33154 10.4307H3.15301L3.00902 11.8578C2.97806 12.338 3.02702 12.82 3.15301 13.2848H8.4759L4.59227 17.1378C5.16035 17.9867 5.89402 18.7146 6.74972 19.2783L10.4901 15.5679V20.8486C10.9599 20.9664 11.4444 21.0142 11.9286 20.9912C12.4124 21.0222 12.8984 20.9739 13.3668 20.8486V15.5679L17.1071 19.2787C17.5535 19.0245 17.9445 18.6851 18.2577 18.2797C18.6285 17.9309 18.9654 17.5489 19.2646 17.1382L15.5242 13.427H20.8471C20.9659 12.9612 21.0145 12.4802 20.9911 12C21.0217 11.4726 20.9731 10.9434 20.8471 10.43V10.4304ZM14.2297 11.8574C14.2153 12.4856 14.1188 13.1095 13.9417 13.7128C13.3477 13.9443 12.7087 14.0415 12.0715 13.9983C11.4383 13.9839 10.8097 13.8881 10.2014 13.7128C9.96844 13.1231 9.87016 12.4896 9.91336 11.8574C9.92776 11.2292 10.025 10.6053 10.2014 10.002C10.7957 9.77088 11.4347 9.67332 12.0715 9.71652C12.7051 9.73092 13.3337 9.82668 13.9421 10.002C14.1077 10.6079 14.2045 11.2303 14.2297 11.8574Z"
        fill="#FF4A00"
      />
    </svg>
  );
}

export function HouseCallProIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M8.5 5.37445V13.7621L12.5859 15.9515V14.7797V13.5V5.72907V4.44934V3L8.5 5.37445ZM15.4692 14.7335H13.7731V13.7621H14.4978L14.5286 5.34361H13.7731V4.37225H15.5L15.4692 14.7335Z"
        fill="#2196F3"
      />
      <path
        d="M0.951754 19.2782H2.21491V17.9756H2.65789V20.923H2.21491V19.6905H0.951754V20.923H0.5V17.9756H0.951754V19.2782ZM3.48684 19.9975C3.48684 20.1861 3.53509 20.3308 3.63597 20.4405C3.73246 20.5501 3.87281 20.6072 4.03947 20.6072C4.20614 20.6072 4.34649 20.5589 4.44298 20.4493C4.53947 20.3396 4.5921 20.1949 4.5921 20.0151C4.5921 19.8352 4.54386 19.6905 4.44298 19.5808C4.34649 19.4712 4.20614 19.4142 4.03947 19.4142C3.87281 19.4142 3.74561 19.4712 3.64474 19.5808C3.53509 19.6817 3.48684 19.8221 3.48684 19.9975ZM3.04386 19.9887C3.04386 19.7212 3.14035 19.4975 3.32895 19.3089C3.51754 19.1203 3.75439 19.0238 4.0307 19.0238C4.30702 19.0238 4.54386 19.1203 4.74123 19.3089C4.92982 19.4975 5.02632 19.7344 5.02632 20.0107C5.02632 20.287 4.92982 20.5238 4.74123 20.7124C4.54386 20.901 4.30702 20.9887 4.0307 20.9887C3.75439 20.9887 3.51754 20.8923 3.32895 20.7037C3.14035 20.5107 3.04386 20.2738 3.04386 19.9887ZM5.83333 19.0721V20.1379C5.83333 20.4449 5.95175 20.6028 6.19737 20.6028C6.44298 20.6028 6.5614 20.4449 6.5614 20.1379V19.0721H6.99561V20.1466C6.99561 20.2958 6.97807 20.423 6.9386 20.5326C6.89912 20.6291 6.8421 20.7212 6.75 20.8001C6.60088 20.9273 6.42544 20.9887 6.19737 20.9887C5.9693 20.9887 5.79386 20.9317 5.64474 20.8001C5.55702 20.7212 5.49561 20.6335 5.45614 20.5326C5.41667 20.4449 5.40789 20.3177 5.40789 20.1466V19.0721H5.83333ZM8.58772 19.3879L8.23245 19.5765C8.17544 19.458 8.10526 19.4098 8.02632 19.4098C7.98684 19.4098 7.95614 19.4186 7.92982 19.4493C7.89912 19.48 7.89035 19.5063 7.89035 19.5458C7.89035 19.6159 7.9693 19.6817 8.13596 19.7519C8.36403 19.8484 8.52193 19.9405 8.60088 20.0194C8.67982 20.0984 8.7193 20.2168 8.7193 20.3528C8.7193 20.5282 8.64912 20.6773 8.52193 20.8045C8.39474 20.923 8.23684 20.9712 8.05702 20.9712C7.74123 20.9712 7.52631 20.8221 7.39474 20.5194L7.75877 20.3528C7.80702 20.4405 7.84649 20.5019 7.87719 20.5194C7.92544 20.5677 7.99561 20.5896 8.06579 20.5896C8.21491 20.5896 8.2807 20.5194 8.2807 20.3923C8.2807 20.3133 8.22368 20.2431 8.11403 20.1773C8.07456 20.1598 8.02631 20.1379 7.98684 20.1203C7.94737 20.1028 7.89912 20.0808 7.85965 20.0633C7.73246 20.0063 7.64474 19.9449 7.5921 19.8747C7.52193 19.7958 7.49561 19.6993 7.49561 19.5808C7.49561 19.423 7.55263 19.287 7.66228 19.1773C7.77193 19.0677 7.90789 19.0194 8.07456 19.0194C8.28947 19.0238 8.4693 19.1423 8.58772 19.3879ZM10.4298 19.7519C10.3728 19.5238 10.2237 19.4054 9.99561 19.4054C9.94737 19.4054 9.89912 19.4142 9.84649 19.423C9.79825 19.4405 9.75877 19.4624 9.7193 19.4931C9.67982 19.5238 9.64912 19.5633 9.62281 19.6028C9.5921 19.6423 9.57456 19.6905 9.56579 19.7519H10.4298ZM10.864 20.1072H9.53509C9.54386 20.2563 9.5921 20.3835 9.68421 20.4712C9.77193 20.5589 9.88158 20.6072 10.0175 20.6072C10.1272 20.6072 10.2149 20.5765 10.2851 20.5282C10.3553 20.48 10.4342 20.3791 10.5219 20.2431L10.886 20.4493C10.8289 20.5458 10.7675 20.6247 10.7105 20.6949C10.6535 20.7651 10.5833 20.8221 10.5132 20.8616C10.443 20.901 10.364 20.9405 10.2851 20.958C10.2061 20.9756 10.1184 20.9887 10.0175 20.9887C9.74123 20.9887 9.51316 20.901 9.34649 20.7212C9.17982 20.5458 9.0921 20.3089 9.0921 20.0107C9.0921 19.7168 9.17105 19.48 9.33772 19.3001C9.50438 19.1247 9.72368 19.0326 9.98684 19.0326C10.2632 19.0326 10.4781 19.1203 10.636 19.3001C10.7939 19.4756 10.8728 19.7124 10.8728 20.0194L10.864 20.1072ZM13.5482 19.9975C13.5482 20.173 13.5965 20.3221 13.6974 20.4317C13.7939 20.5414 13.9123 20.5984 14.0702 20.5984C14.2281 20.5984 14.3553 20.5414 14.4561 20.4317C14.5526 20.3221 14.6053 20.1773 14.6053 19.9975C14.6053 19.8177 14.557 19.6817 14.4561 19.5633C14.3596 19.4537 14.2281 19.3966 14.0702 19.3966C13.9211 19.3966 13.8026 19.4537 13.6974 19.5633C13.5965 19.6949 13.5482 19.8308 13.5482 19.9975ZM14.5746 19.0721H15.0088V20.9273H14.5746V20.73C14.3991 20.8966 14.2105 20.9756 14.0044 20.9756C13.75 20.9756 13.5307 20.8879 13.364 20.6993C13.1974 20.5107 13.1184 20.2738 13.1184 19.9887C13.1184 19.7124 13.1974 19.4756 13.364 19.287C13.5307 19.0984 13.7368 19.0107 13.9868 19.0107C14.2018 19.0107 14.3991 19.0984 14.5702 19.2782V19.0721C14.5658 19.0721 14.5746 19.0721 14.5746 19.0721ZM15.9167 17.9756V20.9361H15.4912V17.9756H15.9167ZM16.8421 17.9756V20.9361H16.4079V17.9756H16.8421ZM18.5965 19.3177H18.7632C19.1667 19.3177 19.3728 19.1598 19.3728 18.844C19.3728 18.537 19.1667 18.3923 18.7412 18.3923H18.5921V19.3177H18.5965ZM18.5965 19.7344V20.9273H18.1535V17.98H18.6579C18.9035 17.98 19.0921 17.9975 19.2193 18.0282C19.3465 18.0589 19.4561 18.1247 19.5526 18.2256C19.7193 18.3923 19.807 18.5984 19.807 18.8484C19.807 19.1159 19.7193 19.3308 19.5395 19.4887C19.364 19.6466 19.114 19.7256 18.8114 19.7256L18.5965 19.7344ZM20.1754 19.0721H20.6096V19.2387C20.6886 19.1598 20.7588 19.1028 20.8158 19.0721C20.8728 19.0414 20.9518 19.0238 21.0307 19.0238C21.1404 19.0238 21.2588 19.0633 21.386 19.1335L21.1886 19.5282C21.1096 19.4712 21.0307 19.4405 20.9518 19.4405C20.7149 19.4405 20.5965 19.6159 20.5965 19.9712V20.9361H20.1623L20.1754 19.0721ZM21.9605 19.9975C21.9605 20.1861 22.0088 20.3308 22.1096 20.4405C22.2061 20.5501 22.3465 20.6072 22.5132 20.6072C22.6798 20.6072 22.8202 20.5589 22.9167 20.4493C23.0132 20.3396 23.0658 20.1949 23.0658 20.0151C23.0658 19.8352 23.0175 19.6905 22.9167 19.5808C22.8202 19.4712 22.6798 19.4142 22.5132 19.4142C22.3465 19.4142 22.2193 19.4712 22.1184 19.5808C22.0088 19.6817 21.9605 19.8221 21.9605 19.9975ZM21.5175 19.9887C21.5175 19.7212 21.614 19.4975 21.8026 19.3089C21.9912 19.1203 22.2281 19.0238 22.5044 19.0238C22.7807 19.0238 23.0175 19.1203 23.2149 19.3089C23.4035 19.4975 23.5 19.7344 23.5 20.0107C23.5 20.287 23.4035 20.5238 23.2149 20.7124C23.0175 20.901 22.7807 20.9887 22.5044 20.9887C22.2281 20.9887 21.9912 20.8923 21.8026 20.7037C21.614 20.5107 21.5175 20.2738 21.5175 19.9887ZM12.2456 19.4098H12.2544H12.2632C12.2807 19.4098 12.3026 19.4098 12.3202 19.4098C12.4781 19.4186 12.636 19.458 12.7719 19.537V19.151C12.6053 19.0633 12.4386 19.0238 12.25 19.0238C11.9649 19.0238 11.7281 19.1203 11.5307 19.3089C11.3333 19.4975 11.2368 19.7344 11.2368 20.0107C11.2368 20.287 11.3333 20.5238 11.5219 20.7124C11.7193 20.901 11.9561 20.9887 12.2412 20.9887C12.4167 20.9887 12.5877 20.9405 12.7632 20.8528V20.4668C12.614 20.5458 12.4561 20.5852 12.3114 20.594C12.2807 20.594 12.2544 20.6028 12.2237 20.6028C12.0658 20.6028 11.9298 20.5458 11.8289 20.4361C11.7325 20.3265 11.6711 20.1817 11.6711 20.0019C11.6711 19.8352 11.7193 19.6861 11.8289 19.5765C11.9605 19.4668 12.0877 19.4098 12.2456 19.4098Z"
        fill="#2196F3"
      />
    </svg>
  );
}

export function HubspotIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        d="M19.0626 11.5716C18.6881 10.9184 18.1611 10.3949 17.5022 10.0006C17.0101 9.7102 16.4997 9.52574 15.9243 9.44654V7.37088C16.4997 7.12334 16.8566 6.57545 16.8566 5.93603C16.8566 5.06448 16.167 4.35854 15.3084 4.35854C14.4485 4.35854 13.7471 5.06483 13.7471 5.93568C13.7471 6.57511 14.0838 7.12334 14.6588 7.37088V9.44757C14.1987 9.51477 13.7214 9.66014 13.2857 9.88368C12.3957 9.19831 9.47678 6.95054 7.7694 5.6374C7.80997 5.48962 7.84107 5.33705 7.84107 5.17625C7.84107 4.21111 7.07036 3.42871 6.1178 3.42871C5.16524 3.42871 4.39453 4.21111 4.39453 5.17625C4.39453 6.14105 5.16591 6.92345 6.11847 6.92345C6.44332 6.92345 6.74383 6.82745 7.00309 6.66871L7.36343 6.94608L12.3145 10.5619C12.0529 10.8053 11.8092 11.0827 11.6141 11.3936C11.2186 12.0272 10.9773 12.7246 10.9773 13.4851V13.6441C10.9773 14.178 11.0777 14.6823 11.2477 15.1558C11.3981 15.5693 11.6175 15.9454 11.8896 16.2852L10.2461 17.9549C10.0082 17.8651 9.74924 17.8465 9.50146 17.9017C9.25301 17.9566 9.02586 18.0835 8.8467 18.2659C8.72264 18.391 8.62428 18.5401 8.55735 18.704C8.49042 18.8679 8.45628 19.0435 8.45695 19.2211C8.45695 19.5817 8.59555 19.9205 8.84738 20.1759C8.97076 20.3017 9.1178 20.4015 9.27938 20.4694C9.44095 20.5373 9.61402 20.5723 9.78946 20.5716C9.96456 20.5719 10.1376 20.5373 10.2999 20.4694C10.4615 20.4015 10.6082 20.3014 10.7315 20.1759C10.8556 20.0508 10.954 19.9016 11.0209 19.7381C11.0878 19.5742 11.1223 19.3987 11.1216 19.2211C11.1216 19.0815 11.1003 18.9454 11.0604 18.8158L12.7587 17.094C12.9919 17.2572 13.2431 17.3943 13.5135 17.5126C14.0466 17.7464 14.6354 17.8887 15.2794 17.8887H15.3977C16.1096 17.8887 16.7812 17.7193 17.4127 17.3724C18.0782 17.0055 18.5992 16.5049 18.9926 15.8648C19.3881 15.223 19.6058 14.514 19.6058 13.7343V13.6952C19.6058 12.9283 19.4307 12.2203 19.0626 11.5719V11.5716ZM16.9871 15.1836C16.5264 15.703 15.9967 16.0229 15.3973 16.0229H15.2986C14.9566 16.0229 14.6219 15.9269 14.2944 15.7527C13.9249 15.5607 13.6443 15.2871 13.4145 14.9401C13.1772 14.6 13.0481 14.2284 13.0481 13.8344V13.7148C13.0481 13.3273 13.1214 12.9605 13.3063 12.6135C13.5037 12.2343 13.7704 11.9398 14.1253 11.7049C14.4735 11.4725 14.8457 11.3583 15.2601 11.3583H15.2986C15.6745 11.3583 16.0301 11.4334 16.3658 11.6076C16.7079 11.7931 16.9874 12.0468 17.2041 12.3804C17.4144 12.7143 17.5394 13.0743 17.58 13.4662C17.5861 13.5478 17.5895 13.6315 17.5895 13.711C17.5895 14.2435 17.3887 14.7361 16.9874 15.1836H16.9871Z"
        fill="#F8761F"
      />
    </svg>
  );
}

export function ZohoIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <rect
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        fill="url(#paint0_linear_1557_3380)"
      />
      <path
        d="M16.4008 16.5815C16.3018 16.4149 16.1536 16.2796 15.9746 16.1923C15.7744 16.0984 15.5483 16.0317 15.2816 15.9646C15.0153 15.9377 14.7085 15.9377 14.3488 15.9377L10.3249 16.0048C10.4183 15.6962 10.6312 15.3339 10.9508 14.8776C11.4541 14.2592 11.9878 13.6637 12.5502 13.0933C12.79 12.8517 12.9765 12.6643 13.11 12.5703L13.4962 12.1812C14.5754 11.1215 15.2816 10.2358 15.6148 9.52497C15.8145 9.09555 15.9477 8.69297 16.0411 8.26355C16.0676 8.14277 16.0808 8.022 16.1077 7.90165C16.1474 7.593 16.1743 7.27094 16.1743 6.96229C16.1743 6.66706 16.1346 6.46577 16.0812 6.23806C16.0147 6.03677 15.9212 5.87574 15.7881 5.78181C15.6545 5.66103 15.4015 5.58052 15.1352 5.54026C14.895 5.5 14.615 5.5 14.2558 5.5L9.57852 5.59394C9.01911 5.59394 8.5796 5.71471 8.28644 5.92942C8.04663 6.09045 7.89983 6.332 7.86016 6.60039C7.86016 6.66748 7.83371 6.761 7.83371 6.84152C7.83371 7.2441 7.99329 7.56616 8.28644 7.76745C8.48614 7.88823 8.68628 7.96874 8.95254 8.00858C9.15224 8.03542 9.35238 8.04884 9.55207 8.04884L13.4429 7.98174C13.4429 8.04884 13.4429 8.11594 13.4164 8.20987C13.3772 8.44488 13.2961 8.6718 13.1766 8.88084C13.0166 9.18948 12.6833 9.57823 12.1239 10.1016C11.9639 10.2358 11.7241 10.4639 11.4309 10.7591C10.2186 11.8188 9.31226 12.7716 8.73962 13.5764C8.34334 14.0983 8.02897 14.6722 7.80638 15.2802C7.68647 15.6157 7.57979 15.9377 7.53967 16.2728C7.51322 16.5144 7.5 16.7022 7.5 16.9438C7.5 17.2524 7.53967 17.5208 7.61991 17.7351C7.68603 17.9632 7.8196 18.1243 7.95273 18.2048C8.08587 18.2987 8.31245 18.3658 8.60561 18.4329C8.99222 18.4732 9.52518 18.5 10.1512 18.5L14.3752 18.4329C15.1079 18.4061 15.6677 18.3121 15.9873 18.1243C16.254 17.9632 16.4136 17.7217 16.4405 17.4C16.467 17.3329 16.467 17.239 16.467 17.1316C16.5335 16.9304 16.4934 16.7559 16.4008 16.5815Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1557_3380"
          x1="3.62591"
          y1="3.891"
          x2="3.83646"
          y2="20.6155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D92231" />
          <stop offset="1" stopColor="#BA2234" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function NavPhoneIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path d="M64.5,78.2c1.7-1.9,3.6-3.6,5.4-5.4c2.6-2.7,2.7-5.9,0-8.6c-3.1-3.2-6.3-6.3-9.4-9.4 c-2.6-2.6-5.8-2.6-8.4,0c-2,1.9-3.9,3.9-5.9,5.9c-0.1,0.1-0.3,0.2-0.4,0.3l-1.3,1.3c-0.4,0.2-0.7,0.2-1.2,0 c-1.3-0.7-2.6-1.2-3.8-2c-5.7-3.6-10.5-8.2-14.7-13.4c-2.1-2.6-4-5.3-5.3-8.4c-0.2-0.5-0.2-0.9,0.1-1.3l1.3-1.3 c0.1-0.1,0.1-0.2,0.2-0.3c0.6-0.6,1.2-1.1,1.8-1.7c1.4-1.3,2.7-2.7,4.1-4.1c2.7-2.7,2.7-5.9,0-8.6c-1.5-1.5-3.1-3.1-4.6-4.6 c-1.6-1.6-3.2-3.2-4.8-4.8c-2.6-2.5-5.8-2.5-8.4,0c-2,1.9-3.9,3.9-5.9,5.9c-1.9,1.8-2.8,3.9-3,6.5c-0.3,4.1,0.7,8,2.1,11.8 C5.2,43.8,9.6,50.7,15,57.1c7.2,8.6,15.9,15.4,26,20.4c4.6,2.2,9.3,3.9,14.4,4.2C58.9,81.8,62,81,64.5,78.2z" />
      <path d="M41.1,15.7 c-0.7,0-1.5,0.1-2.2,0.4c-1.7,0.8-2.5,2.8-2,4.8c0.4,1.8,2,3,3.9,3c4.6,0.1,8.6,1.5,12,4.6c3.7,3.4,5.4,7.7,5.6,12.8 c0,0.9,0.4,1.9,0.9,2.6c1.1,1.5,3,1.9,4.8,1.2c1.6-0.6,2.5-2,2.5-3.9c-0.1-7-2.6-12.9-7.5-18.1C54.1,18.4,48.1,15.8,41.1,15.7z" />
      <path d="M69,11.4c8.5,8.7,12.5,18.1,12.8,29.1c0.1,2.5-1.5,4.2-3.9,4.3c-2.6,0.1-4.3-1.4-4.4-4c-0.1-5.4-1.4-10.5-4-15.2 C63.5,14.9,54.2,9.3,42,8.6c-1.4-0.1-2.6-0.2-3.6-1.3c-1.2-1.4-1.3-3-0.7-4.6c0.7-1.6,2-2.4,3.8-2.4c8,0.1,15.3,2.4,22,6.8 C65.7,8.6,67.8,10.4,69,11.4z" />
    </svg>
  );
}
export function UlCheckedIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <path
        id="Mask"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 11V10.1C23 9.5 22.5818 9.1 21.9545 9.1C21.3273 9.1 20.9091 9.5 20.9091 10.1V11C20.9091 16 16.7273 20 11.5 20C6.27273 20 2.09091 16 2.09091 11C2.09091 6 6.27273 2 11.5 2C12.8591 2 14.1136 2.3 15.3682 2.8C15.8909 3 16.5182 2.8 16.7273 2.3C16.9364 1.8 16.7273 1.2 16.2045 1C14.7409 0.3 13.0682 0 11.5 0C5.12273 0 0 4.9 0 11C0 17.1 5.12273 22 11.5 22C17.8773 22 23 17.1 23 11ZM22.2971 1.30223C22.6978 0.901535 23.2988 0.901535 23.6995 1.30223C24.1002 1.70293 24.1002 2.30397 23.6995 2.70467L12.6803 13.7238C12.48 13.9242 12.1795 14.0243 11.9791 14.0243C11.7788 14.0243 11.4783 13.9242 11.2779 13.7238L8.27269 10.7186C7.87199 10.3179 7.87199 9.71685 8.27269 9.31615C8.67339 8.91546 9.27443 8.91546 9.67513 9.31615L11.9791 11.6202L22.2971 1.30223Z"
        fill={color}
      />
    </svg>
  );
}
export function PlayBtnIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink icon-play`}
      {...props}
    >
      <path
        d="M59 116C90.4802 116 116 90.4802 116 59C116 27.5198 90.4802 2 59 2C27.5198 2 2 27.5198 2 59C2 90.4802 27.5198 116 59 116Z"
        fill="black"
        fillOpacity="0.25"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-play-outer"
      />
      <path
        d="M46.3374 37.4037C46.3374 35.8063 48.1176 34.8535 49.4468 35.7396L81.8412 57.3359C83.0287 58.1275 83.0287 59.8724 81.8412 60.6641L49.4468 82.2604C48.1176 83.1464 46.3374 82.1937 46.3374 80.5963V37.4037Z"
        fill="white"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-play-inner"
      />
    </svg>
  );
}

export function TimetableIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        d="M25.3333 23.7975V19.9793C25.3333 17.8704 26.7577 16.1611 28.5151 16.1611C30.2726 16.1611 31.6969 17.8704 31.6969 19.9793V23.7975"
        stroke="#FD8B1F"
        strokeWidth="2.5"
      />
      <path
        d="M52.0606 23.7975V19.9793C52.0606 17.8704 53.485 16.1611 55.2424 16.1611C56.9999 16.1611 58.4242 17.8704 58.4242 19.9793V23.7975"
        stroke="#FD8B1F"
        strokeWidth="2.5"
      />
      <path d="M15.1515 35.8883H68.606" stroke="#FD8B1F" strokeWidth="2.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.7569 68.3433H21.9983C18.217 68.3433 15.1515 65.2509 15.1515 61.4352V25.7978C15.1515 24.6933 16.0469 23.7979 17.1515 23.7979H66.606C67.7106 23.7979 68.606 24.6933 68.606 25.7979V61.4352C68.606 65.2509 65.5394 68.3433 61.7569 68.3433Z"
        stroke="#3270D8"
        strokeWidth="2.5"
      />
    </svg>
  );
}

export function ReceptionistOnCallIcon({
  color,
  className,
  width,
  height,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <circle
        cx="45.7515"
        cy="68.3328"
        r="3.66683"
        stroke="#FD8B1F"
        strokeWidth="2.8"
      />
      <path
        d="M61.3357 36.2487C61.3357 36.2487 41.2849 35.6923 36.8836 28.915C36.8836 28.915 31.1805 36.0167 21.9173 36.2487"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.8749 52.4411C37.2329 53.5302 39.4911 54.2429 42.0474 54.2429C44.6512 54.2429 46.9458 53.5034 48.2948 52.3799"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M50.3351 66.7715C59.4412 64.7416 66.8247 57.1625 69.4683 48.1654"
        stroke="#FD8B1F"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7003 48.1658C13.4475 48.1658 9.99997 44.472 9.99997 39.9154C9.99997 35.3589 13.4475 31.665 17.7003 31.665V48.1658Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.9192 48.1658C70.172 48.1658 73.6195 44.472 73.6195 39.9154C73.6195 35.3589 70.172 31.665 65.9192 31.665V48.1658Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6265 12C29.721 12 20.0697 20.0042 16.8754 31.6649"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        d="M61.769 39.915C61.769 51.3206 52.7232 60.516 41.6264 60.516C30.5295 60.516 21.4837 51.3206 21.4837 39.915C21.4837 28.5095 30.5295 19.3141 41.6264 19.3141C52.7232 19.3141 61.769 28.5095 61.769 39.915Z"
        stroke="#3270D8"
        strokeWidth="2.8"
      />
      <path
        d="M41.6265 12C53.5319 12 63.1832 20.0042 66.3776 31.6649"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ListingIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37 40C37 40.5523 37.4477 41 38 41H62C62.5523 41 63 40.5523 63 40V27C63 26.4477 62.5523 26 62 26H38C37.4477 26 37 26.4477 37 27V40Z"
        stroke="#FD8B1F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M36.9999 48.7718H62.2091"
        stroke="#FD8B1F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M36.9999 56.3343H55.9068"
        stroke="#FD8B1F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M20.5627 68.9392H63.4183C65.3755 68.9392 67.1593 68.1952 68.5024 66.9747C70.025 65.5912 70.981 63.5952 70.981 61.3765V18C70.981 16.8954 70.0856 16 68.981 16H30.1255C29.0209 16 28.1255 16.8954 28.1255 18V61.3765C28.1255 65.5524 24.7386 68.9392 20.5627 68.9392ZM20.5627 68.9392C16.3868 68.9392 13 65.5524 13 61.3765V42.4696C13 40.381 14.6928 38.6882 16.7814 38.6882C18.87 38.6882 20.5627 40.381 20.5627 42.4696V58.8556"
        stroke="#3270D8"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ClockWithArrowIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        d="M42 12C58.5234 12 72 25.4766 72 42C72 58.6406 58.5234 72 42 72C32.1562 72 23.3672 67.3125 17.9766 60.0469C17.2734 59.2266 17.5078 58.0547 18.3281 57.4688C19.1484 56.7656 20.3203 57 20.9062 57.8203C25.7109 64.1484 33.3281 68.25 42 68.25C56.4141 68.25 68.25 56.5312 68.25 42C68.25 27.5859 56.4141 15.75 42 15.75C31.4531 15.75 22.4297 21.9609 18.2109 30.75H28.875C29.8125 30.75 30.75 31.6875 30.75 32.625C30.75 33.6797 29.8125 34.5 28.875 34.5H13.875C12.8203 34.5 12 33.6797 12 32.625V17.625C12 16.6875 12.8203 15.75 13.875 15.75C14.8125 15.75 15.75 16.6875 15.75 17.625V27.4688C20.7891 18.3281 30.6328 12 42 12Z"
        fill="#3270D8"
      />
      <path
        d="M40.2422 27C41.1797 27 42.1172 27.9375 42.1172 28.875V41.2969L50.9062 50.0859C51.6094 50.7891 51.6094 52.0781 50.9062 52.7812C50.2031 53.4844 48.9141 53.4844 48.2109 52.7812L38.8359 43.4062C38.4844 43.0547 38.25 42.5859 38.25 42V28.875C38.25 27.9375 39.1875 27 40.125 27H40.2422Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function FilterIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <mask
        id="mask0_436_5539"
        maskUnits="userSpaceOnUse"
        x="17"
        y="10"
        width="48"
        height="18"
      >
        <rect x="17.5" y="10" width="47" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_436_5539)">
        <path
          d="M38.8525 34.835C41.964 34.835 44.4863 32.3126 44.4863 29.2012C44.4863 26.0897 41.964 23.5674 38.8525 23.5674C35.7411 23.5674 33.2188 26.0897 33.2188 29.2012C33.2188 32.3126 35.7411 34.835 38.8525 34.835Z"
          stroke="#FD8B1F"
          strokeWidth="2.8"
          strokeLinecap="square"
        />
        <path
          d="M56.7406 30.0621C60.0039 30.0621 62.6493 27.4167 62.6493 24.1535C62.6493 20.8903 60.0039 18.2449 56.7406 18.2449C53.4774 18.2449 50.832 20.8903 50.832 24.1535C50.832 27.4167 53.4774 30.0621 56.7406 30.0621Z"
          stroke="#FD8B1F"
          strokeWidth="2.8"
          strokeLinecap="square"
        />
        <path
          d="M24.4176 22.1678C27.2254 22.1678 29.5015 19.8916 29.5015 17.0839C29.5015 14.2761 27.2254 12 24.4176 12C21.6099 12 19.3337 14.2761 19.3337 17.0839C19.3337 19.8916 21.6099 22.1678 24.4176 22.1678Z"
          stroke="#FD8B1F"
          strokeWidth="2.8"
          strokeLinecap="square"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.7883 29.2374C69.3406 29.2374 69.7883 29.6851 69.7883 30.2374V35.3542C69.7883 35.6218 69.6811 35.8782 69.4907 36.0661L47.8805 57.3868C47.69 57.5747 47.5828 57.8311 47.5828 58.0987V67.1566C47.5828 67.5834 47.3118 67.9633 46.9082 68.1022L36.9056 71.544C36.2564 71.7674 35.5803 71.285 35.5803 70.5984V58.0869C35.5803 57.8243 35.477 57.5722 35.2927 57.3851L14.2876 36.0609C14.1033 35.8738 14 35.6217 14 35.3591V30.2374C14 29.6851 14.4477 29.2374 15 29.2374H41.8942H68.7883Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="square"
      />
      <path d="M14.1375 35.4207H69.9258" stroke="#3270D8" strokeWidth="2.8" />
    </svg>
  );
}

export function SchedulingIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        d="M22.75 14C23.625 14 24.5 14.875 24.5 15.75V21H45.5V15.75C45.5 14.875 46.2656 14 47.25 14C48.125 14 49 14.875 49 15.75V21H52.5C56.3281 21 59.5 24.1719 59.5 28V35C58.8438 35 58.2969 35 57.75 35C57.0938 35 56.5469 35 56 35H14V63C14 64.9688 15.5312 66.5 17.5 66.5H42.875C43.9688 67.9219 45.1719 69.0156 46.5938 70H17.5C13.5625 70 10.5 66.9375 10.5 63V28C10.5 24.1719 13.5625 21 17.5 21H21V15.75C21 14.875 21.7656 14 22.75 14ZM52.5 24.5H17.5C15.5312 24.5 14 26.1406 14 28V31.5H56V28C56 26.1406 54.3594 24.5 52.5 24.5Z"
        fill="#3270D8"
      />
      <path
        d="M57.6406 45.5001C58.625 45.5001 59.3906 46.3751 59.3906 47.2501V52.5001H63C63.875 52.5001 64.75 53.3751 64.75 54.2501C64.75 55.2345 63.875 56.0001 63 56.0001H57.6406C56.7656 56.0001 55.8906 55.2345 55.8906 54.2501V47.2501C55.8906 46.3751 56.7656 45.5001 57.6406 45.5001ZM42 54.2501C42 45.6095 49 38.5001 57.75 38.5001C66.3906 38.5001 73.5 45.6095 73.5 54.2501C73.5 63.0001 66.3906 70.0001 57.75 70.0001C49 70.0001 42 63.0001 42 54.2501ZM57.75 66.5001C64.4219 66.5001 70 61.0314 70 54.2501C70 47.5782 64.4219 42.0001 57.75 42.0001C50.9688 42.0001 45.5 47.5782 45.5 54.2501C45.5 61.0314 50.9688 66.5001 57.75 66.5001Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function BilingualChatIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        d="M21.2094 46.5082H23.2576V53.7493H21.2094V46.5082ZM18.4164 53.7493H16.3682V46.5082H18.4164V53.7493ZM21.3542 50.9252H18.2715V49.2287H21.3542V50.9252ZM27.634 53.8424C27.0202 53.8424 26.4754 53.7182 25.9996 53.47C25.5237 53.2217 25.1479 52.8803 24.872 52.4459C24.6031 52.0045 24.4686 51.5011 24.4686 50.9356C24.4686 50.3701 24.6031 49.8701 24.872 49.4356C25.1479 49.0012 25.5237 48.6632 25.9996 48.4219C26.4754 48.1736 27.0202 48.0495 27.634 48.0495C28.2478 48.0495 28.7926 48.1736 29.2684 48.4219C29.7512 48.6632 30.127 49.0012 30.396 49.4356C30.6649 49.8701 30.7994 50.3701 30.7994 50.9356C30.7994 51.5011 30.6649 52.0045 30.396 52.4459C30.127 52.8803 29.7512 53.2217 29.2684 53.47C28.7926 53.7182 28.2478 53.8424 27.634 53.8424ZM27.634 52.2804C27.8616 52.2804 28.0616 52.2286 28.234 52.1252C28.4133 52.0217 28.5547 51.87 28.6581 51.67C28.7615 51.4631 28.8133 51.2183 28.8133 50.9356C28.8133 50.6528 28.7615 50.4149 28.6581 50.2218C28.5547 50.0218 28.4133 49.8701 28.234 49.7667C28.0616 49.6632 27.8616 49.6115 27.634 49.6115C27.4133 49.6115 27.2133 49.6632 27.034 49.7667C26.8616 49.8701 26.7202 50.0218 26.6099 50.2218C26.5065 50.4149 26.4547 50.6528 26.4547 50.9356C26.4547 51.2183 26.5065 51.4631 26.6099 51.67C26.7202 51.87 26.8616 52.0217 27.034 52.1252C27.2133 52.2286 27.4133 52.2804 27.634 52.2804ZM31.921 53.7493V46.0737H33.8864V53.7493H31.921ZM38.7989 53.7493V52.7045L38.6644 52.4459V50.5218C38.6644 50.2115 38.5678 49.9735 38.3747 49.808C38.1885 49.6356 37.8885 49.5494 37.4748 49.5494C37.2058 49.5494 36.9334 49.5942 36.6576 49.6839C36.3817 49.7667 36.1472 49.8839 35.9541 50.0356L35.2921 48.7012C35.6093 48.4943 35.9886 48.3357 36.43 48.2253C36.8782 48.1081 37.323 48.0495 37.7644 48.0495C38.6747 48.0495 39.3781 48.2598 39.8747 48.6805C40.3781 49.0943 40.6298 49.746 40.6298 50.6356V53.7493H38.7989ZM37.1437 53.8424C36.6955 53.8424 36.3162 53.7665 36.0059 53.6148C35.6955 53.4631 35.4576 53.2562 35.2921 52.9941C35.1335 52.7321 35.0542 52.439 35.0542 52.1148C35.0542 51.77 35.1404 51.4735 35.3128 51.2252C35.4921 50.9701 35.7645 50.777 36.13 50.6459C36.4955 50.508 36.9679 50.439 37.5472 50.439H38.8713V51.4631H37.8161C37.4989 51.4631 37.2748 51.5149 37.1437 51.6183C37.0196 51.7218 36.9575 51.8597 36.9575 52.0321C36.9575 52.2045 37.0231 52.3424 37.1541 52.4459C37.2851 52.5493 37.4644 52.601 37.692 52.601C37.9058 52.601 38.0989 52.5493 38.2713 52.4459C38.4506 52.3355 38.5816 52.17 38.6644 51.9493L38.9333 52.6734C38.8299 53.0596 38.6264 53.3527 38.323 53.5527C38.0265 53.7458 37.6334 53.8424 37.1437 53.8424Z"
        fill="#3270D8"
      />
      <path
        d="M30.0494 64.0182H47.2287C48.6138 64.0182 49.7366 62.8954 49.7366 61.5103V46.546M19.2532 64.0182H10.5079C9.12289 64.0182 8.00009 62.8954 8.00009 61.5103V36.6C8.00009 35.215 9.12289 34.0922 10.5079 34.0922H30.0494"
        stroke="#3270D8"
        strokeWidth="2.6"
      />
      <path
        d="M19.2534 64.0182V71.7566C19.2534 71.8574 19.3681 71.9152 19.4491 71.8553L30.0496 64.0182"
        stroke="#3270D8"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <path
        d="M54.1818 41.926H37.0025C35.6174 41.926 34.4946 40.8032 34.4946 39.4182V14.5079C34.4946 13.1228 35.6174 12 37.0025 12H73.7233C75.1083 12 76.2311 13.1228 76.2311 14.5079V39.4182C76.2311 40.8032 75.1083 41.926 73.7233 41.926H64.978"
        stroke="#FD8B1F"
        strokeWidth="2.6"
      />
      <path
        d="M64.7357 41.9258L64.5299 49.9742C64.5273 50.0751 64.4108 50.13 64.3314 50.0677L53.9395 41.9258"
        stroke="#FD8B1F"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <path
        d="M46.0148 23.9831H48.063V31.2242H46.0148V23.9831ZM43.2218 31.2242H41.1736V23.9831H43.2218V31.2242ZM46.1596 28.4002H43.077V26.7037H46.1596V28.4002ZM52.5636 31.3173C51.9015 31.3173 51.3222 31.1932 50.8257 30.9449C50.3361 30.6898 49.9533 30.345 49.6775 29.9105C49.4085 29.4691 49.274 28.9692 49.274 28.4106C49.274 27.852 49.4051 27.3554 49.6671 26.921C49.9361 26.4796 50.305 26.1382 50.774 25.8969C51.2429 25.6486 51.7705 25.5245 52.3567 25.5245C52.9084 25.5245 53.4118 25.6382 53.867 25.8658C54.3221 26.0865 54.6842 26.4141 54.9531 26.8485C55.2221 27.283 55.3566 27.8106 55.3566 28.4312C55.3566 28.5002 55.3531 28.5795 55.3462 28.6692C55.3393 28.7588 55.3324 28.8416 55.3255 28.9174H50.8878V27.883H54.2807L53.5359 28.1726C53.5428 27.9175 53.4946 27.6968 53.3911 27.5106C53.2946 27.3244 53.1566 27.1796 52.9773 27.0761C52.8049 26.9727 52.6015 26.921 52.367 26.921C52.1325 26.921 51.9256 26.9727 51.7463 27.0761C51.5739 27.1796 51.4395 27.3278 51.3429 27.5209C51.2464 27.7071 51.1981 27.9278 51.1981 28.183V28.483C51.1981 28.7588 51.2533 28.9967 51.3636 29.1967C51.4808 29.3967 51.6463 29.5519 51.8601 29.6622C52.0739 29.7657 52.3291 29.8174 52.6256 29.8174C52.9015 29.8174 53.1359 29.7795 53.329 29.7036C53.529 29.6209 53.7256 29.4967 53.9187 29.3312L54.9531 30.407C54.6842 30.7036 54.3531 30.9312 53.9601 31.0898C53.567 31.2415 53.1015 31.3173 52.5636 31.3173ZM56.4739 31.2242V23.5487H58.4393V31.2242H56.4739ZM59.9277 31.2242V23.5487H61.8932V31.2242H59.9277ZM66.1952 31.3173C65.5815 31.3173 65.0367 31.1932 64.5608 30.9449C64.085 30.6967 63.7091 30.3553 63.4333 29.9208C63.1643 29.4795 63.0298 28.9761 63.0298 28.4106C63.0298 27.8451 63.1643 27.3451 63.4333 26.9106C63.7091 26.4761 64.085 26.1382 64.5608 25.8969C65.0367 25.6486 65.5815 25.5245 66.1952 25.5245C66.809 25.5245 67.3538 25.6486 67.8297 25.8969C68.3124 26.1382 68.6883 26.4761 68.9572 26.9106C69.2262 27.3451 69.3607 27.8451 69.3607 28.4106C69.3607 28.9761 69.2262 29.4795 68.9572 29.9208C68.6883 30.3553 68.3124 30.6967 67.8297 30.9449C67.3538 31.1932 66.809 31.3173 66.1952 31.3173ZM66.1952 29.7553C66.4228 29.7553 66.6228 29.7036 66.7952 29.6002C66.9745 29.4967 67.1159 29.345 67.2193 29.145C67.3228 28.9381 67.3745 28.6933 67.3745 28.4106C67.3745 28.1278 67.3228 27.8899 67.2193 27.6968C67.1159 27.4968 66.9745 27.3451 66.7952 27.2416C66.6228 27.1382 66.4228 27.0865 66.1952 27.0865C65.9746 27.0865 65.7746 27.1382 65.5953 27.2416C65.4229 27.3451 65.2815 27.4968 65.1711 27.6968C65.0677 27.8899 65.016 28.1278 65.016 28.4106C65.016 28.6933 65.0677 28.9381 65.1711 29.145C65.2815 29.345 65.4229 29.4967 65.5953 29.6002C65.7746 29.7036 65.9746 29.7553 66.1952 29.7553Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function PuzzleIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0863 55.3555C64.8367 54.1266 63.1717 53.3953 61.4098 53.3015L72.8451 42.0204L61.3767 30.723C64.5657 30.5516 67.2545 28.3184 67.9691 25.2476C68.6836 22.1768 67.2512 19.0103 64.4572 17.484C61.6633 15.9578 58.1826 16.4405 55.9235 18.6676C54.6712 19.8959 53.9287 21.5411 53.8413 23.2811L42.406 12L30.9707 23.3055C30.8834 21.5655 30.1409 19.9203 28.8886 18.692C26.6367 16.4362 23.1398 15.9308 20.3267 17.4546C17.5136 18.9785 16.0691 22.1605 16.79 25.2456C17.5108 28.3307 20.2216 30.5678 23.427 30.723L12 41.9959L23.427 53.277C23.6327 49.4727 26.8549 46.5122 30.7161 46.5798C34.5773 46.6475 37.6908 49.7191 37.7594 53.5282C37.828 57.3373 34.827 60.516 30.9707 60.7189L42.406 72L53.8413 60.7189C53.9688 63.5231 55.7684 65.9863 58.4248 66.9924C61.0811 67.9985 64.0893 67.3564 66.0863 65.3569C67.432 64.0313 68.1881 62.2322 68.1881 60.3562C68.1881 58.4802 67.432 56.6811 66.0863 55.3555V55.3555Z"
        stroke="#3270D8"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.8027 22.4177L42.4168 19.0332L35.6619 25.7938"
        stroke="#FD8B1F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.0422 61.5824L42.4197 64.9669L49.1831 58.2063"
        stroke="#FD8B1F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PauseBtnIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} mr-3-d mr-2 fx--no-shrink`}
      {...props}
      viewBox="0 0 60 60"
      fill="none"
    >
      <circle cx="30" cy="30.1405" r="30" fill="#FD8B1F" />
      <circle cx="30" cy="30.4216" r="30" fill="#FD8B1F" />
      <path
        d="M37 18.1405C38.625 18.1405 40 19.5155 40 21.1405V39.1405C40 40.828 38.625 42.1405 37 42.1405L35 42.078C33.3125 42.078 32 40.703 32 39.078V21.078C32 19.453 33.3125 18.1405 35 18.1405H37ZM25 18.1405C26.625 18.1405 28 19.5155 28 21.1405V39.1405C28 40.828 26.625 42.1405 25 42.1405H23C21.3125 42.1405 20 40.828 20 39.1405V21.1405C20 19.453 21.3125 18.1405 23 18.1405H25Z"
        fill="white"
      />
    </svg>
  );
}
export function SarahAudioInfo({ color, className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 200 34"
      fill="none"
    >
      <path
        d="M2.92 10.592L2.08 9.536C1.76 9.056 1.504 8.608 1.312 8.192C1.12 7.776 0.984 7.264 0.904 6.656C0.792 6.272 0.72 5.912 0.688 5.576C0.656 5.24 0.64 4.856 0.64 4.424C0.656 3.976 0.672 3.424 0.688 2.768C0.704 2.16 0.768 1.72 0.88 1.448C1.008 1.176 1.104 0.975999 1.168 0.847999C1.328 0.655999 1.472 0.631999 1.6 0.775999C1.744 0.919999 1.856 1.168 1.936 1.52C2.032 1.856 2.072 2.256 2.056 2.72C2.104 4.432 2.224 5.792 2.416 6.8C2.624 7.808 2.904 8.424 3.256 8.648C3.448 8.696 3.616 8.688 3.76 8.624C3.92 8.544 4.144 8.352 4.432 8.048C4.736 7.728 5.184 7.248 5.776 6.608C6.208 6.144 6.648 5.648 7.096 5.12C7.56 4.592 7.992 4.088 8.392 3.608C8.808 3.128 9.176 2.72 9.496 2.384C9.832 2.032 10.096 1.8 10.288 1.688C10.352 1.592 10.416 1.52 10.48 1.472C10.56 1.424 10.632 1.4 10.696 1.4C10.76 1.384 10.792 1.376 10.792 1.376C10.92 1.408 10.992 1.512 11.008 1.688C11.024 1.848 11.088 2.008 11.2 2.168C11.232 2.232 11.256 2.304 11.272 2.384C11.288 2.448 11.288 2.52 11.272 2.6C11.272 2.648 11.24 2.712 11.176 2.792C11.112 2.856 11.04 2.928 10.96 3.008C10.896 3.072 10.824 3.144 10.744 3.224C10.536 3.4 10.208 3.712 9.76 4.16C9.328 4.592 8.88 5.064 8.416 5.576C7.952 6.072 7.56 6.52 7.24 6.92C6.536 7.736 5.904 8.44 5.344 9.032C4.8 9.624 4.464 9.976 4.336 10.088C4.32 10.12 4.208 10.232 4 10.424C3.792 10.616 3.648 10.776 3.568 10.904L2.92 10.592ZM1.216 18.632C1.152 18.616 1.056 18.56 0.928 18.464C0.8 18.384 0.656 18.288 0.496 18.176C0.384 18.048 0.312 17.928 0.28 17.816C0.264 17.704 0.288 17.544 0.352 17.336C0.416 17.128 0.504 16.808 0.616 16.376C0.632 16.008 0.704 15.56 0.832 15.032C0.976 14.504 1.144 14.064 1.336 13.712C1.336 13.536 1.376 13.296 1.456 12.992C1.536 12.688 1.632 12.376 1.744 12.056C1.872 11.72 1.984 11.432 2.08 11.192L2.512 9.944L3.472 9.128L4.144 9.872C4.08 9.968 4.024 10.08 3.976 10.208C3.928 10.336 3.864 10.552 3.784 10.856C3.704 11.16 3.584 11.632 3.424 12.272C3.296 12.704 3.152 13.168 2.992 13.664C2.848 14.16 2.712 14.624 2.584 15.056C2.456 15.488 2.344 15.84 2.248 16.112C2.056 16.832 1.912 17.384 1.816 17.768C1.72 18.152 1.632 18.4 1.552 18.512C1.488 18.64 1.376 18.68 1.216 18.632ZM9.72006 16.64C9.51206 16.64 9.34406 16.6 9.21606 16.52C9.10406 16.44 8.96006 16.328 8.78406 16.184C8.48006 15.864 8.26406 15.56 8.13606 15.272C8.00806 14.968 7.96806 14.68 8.01606 14.408C8.06406 14.28 8.08006 14.16 8.06406 14.048C8.06406 13.92 8.06406 13.856 8.06406 13.856C7.98406 13.776 7.96006 13.728 7.99206 13.712C8.02406 13.68 8.05606 13.632 8.08806 13.568C8.18406 13.568 8.21606 13.48 8.18406 13.304C8.15206 13.176 8.21606 12.896 8.37606 12.464C8.53606 12.032 8.73606 11.624 8.97606 11.24C9.07206 11.08 9.21606 10.872 9.40806 10.616C9.60006 10.344 9.80806 10.08 10.0321 9.824C10.2721 9.552 10.4881 9.336 10.6801 9.176C11.0801 8.84 11.4321 8.592 11.7361 8.432C12.0401 8.272 12.3681 8.152 12.7201 8.072C13.0721 7.992 13.3121 7.952 13.4401 7.952C13.5841 7.952 13.7761 8.08 14.0161 8.336C14.3841 8.496 14.6481 8.688 14.8081 8.912C14.9841 9.136 15.0961 9.464 15.1441 9.896C15.1921 10.376 15.1521 10.928 15.0241 11.552C14.9121 12.16 14.5361 12.92 13.8961 13.832C13.4961 14.408 13.1281 14.84 12.7921 15.128C12.4561 15.4 12.0561 15.672 11.5921 15.944C11.2561 16.168 10.9521 16.336 10.6801 16.448C10.4081 16.544 10.0881 16.608 9.72006 16.64ZM12.0241 14.096C12.4081 13.664 12.7121 13.256 12.9361 12.872C13.1761 12.488 13.4001 12 13.6081 11.408C13.6721 11.232 13.7121 11.016 13.7281 10.76C13.7441 10.488 13.7361 10.24 13.7041 10.016C13.6881 9.776 13.6321 9.64 13.5361 9.608C13.3441 9.496 13.1121 9.464 12.8401 9.512C12.5681 9.544 12.2721 9.696 11.9521 9.968C11.4561 10.384 11.0241 10.904 10.6561 11.528C10.2881 12.136 9.92806 12.832 9.57606 13.616C9.33606 14.192 9.28006 14.656 9.40806 15.008C9.55206 15.344 9.84806 15.464 10.2961 15.368C10.7601 15.256 11.3361 14.832 12.0241 14.096ZM22.165 16.952C22.053 17.016 21.901 16.992 21.709 16.88C21.533 16.768 21.357 16.6 21.181 16.376C21.069 16.184 20.989 15.976 20.941 15.752C20.909 15.528 20.893 15.216 20.893 14.816C20.909 14.496 20.893 14.288 20.845 14.192C20.813 14.096 20.725 14.112 20.581 14.24C20.437 14.352 20.189 14.584 19.837 14.936C19.437 15.336 19.053 15.648 18.685 15.872C18.333 16.096 18.045 16.2 17.821 16.184C17.709 16.184 17.581 16.128 17.437 16.016C17.309 15.888 17.189 15.736 17.077 15.56C16.965 15.368 16.869 15.176 16.789 14.984C16.693 14.632 16.677 14.184 16.741 13.64C16.821 13.08 16.949 12.496 17.125 11.888C17.301 11.28 17.501 10.704 17.725 10.16C17.965 9.616 18.205 9.176 18.445 8.84C18.701 8.504 18.925 8.336 19.117 8.336C19.245 8.336 19.357 8.4 19.453 8.528C19.565 8.656 19.677 8.856 19.789 9.128C19.853 9.24 19.877 9.336 19.861 9.416C19.861 9.496 19.797 9.592 19.669 9.704C19.525 9.896 19.357 10.184 19.165 10.568C18.989 10.952 18.813 11.368 18.637 11.816C18.477 12.264 18.333 12.696 18.205 13.112C18.077 13.528 17.989 13.872 17.941 14.144C17.893 14.4 17.901 14.528 17.965 14.528C18.189 14.528 18.453 14.44 18.757 14.264C19.077 14.072 19.381 13.84 19.669 13.568C20.005 13.232 20.301 12.864 20.557 12.464C20.829 12.064 21.101 11.64 21.373 11.192C21.581 10.872 21.797 10.52 22.021 10.136C22.261 9.752 22.413 9.48 22.477 9.32C22.701 8.904 22.869 8.624 22.981 8.48C23.093 8.32 23.229 8.216 23.389 8.168C23.469 8.168 23.541 8.168 23.605 8.168C23.685 8.168 23.725 8.168 23.725 8.168C23.821 8.184 23.933 8.256 24.061 8.384C24.189 8.448 24.261 8.512 24.277 8.576C24.293 8.624 24.301 8.688 24.301 8.768C24.237 8.928 24.133 9.168 23.989 9.488C23.861 9.792 23.765 10.016 23.701 10.16C23.397 10.848 23.093 11.528 22.789 12.2C22.501 12.856 22.293 13.528 22.165 14.216C22.133 14.44 22.125 14.704 22.141 15.008C22.173 15.296 22.221 15.504 22.285 15.632C22.333 15.728 22.389 15.84 22.453 15.968C22.533 16.08 22.621 16.176 22.717 16.256C22.861 16.352 22.885 16.456 22.789 16.568C22.709 16.68 22.597 16.776 22.453 16.856C22.309 16.92 22.213 16.952 22.165 16.952ZM28.1678 6.32C28.0078 6.336 27.9038 6.336 27.8558 6.32C27.8078 6.304 27.7278 6.248 27.6158 6.152C27.5998 6.04 27.6158 5.936 27.6638 5.84C27.7118 5.744 27.7758 5.64 27.8558 5.528C28.0478 5.208 28.2638 4.832 28.5038 4.4C28.7598 3.952 28.9278 3.608 29.0078 3.368C29.0078 3.304 29.0158 3.248 29.0318 3.2C28.7598 3.248 28.4798 3.152 28.1918 2.912C27.8878 2.624 27.7838 2.336 27.8798 2.048C27.9918 1.744 28.2558 1.448 28.6718 1.16C28.9598 0.984 29.1678 0.888 29.2958 0.871999C29.4398 0.855999 29.6558 0.911999 29.9438 1.04C30.2158 1.2 30.3998 1.384 30.4958 1.592C30.6078 1.784 30.6238 1.984 30.5438 2.192C30.4958 2.56 30.4078 2.904 30.2798 3.224C30.1678 3.544 30.0638 3.856 29.9678 4.16C29.8718 4.512 29.7118 4.84 29.4878 5.144C29.2638 5.448 29.0158 5.76 28.7438 6.08C28.7598 6.144 28.7118 6.184 28.5998 6.2C28.4878 6.216 28.3438 6.256 28.1678 6.32ZM28.6763 16.16C28.5323 16.048 28.4283 15.936 28.3643 15.824C28.3163 15.712 28.3163 15.496 28.3643 15.176C28.4123 14.728 28.4763 14.336 28.5563 14C28.6363 13.648 28.7323 13.248 28.8443 12.8C28.8763 12.608 28.9643 12.28 29.1083 11.816C29.2683 11.352 29.4603 10.848 29.6843 10.304C29.9083 9.76 30.1323 9.248 30.3563 8.768C30.5803 8.272 30.7723 7.904 30.9323 7.664C31.0603 7.568 31.2123 7.528 31.3883 7.544C31.5803 7.56 31.7403 7.632 31.8683 7.76C32.0443 7.904 32.0683 8.16 31.9403 8.528C31.8283 8.88 31.5883 9.44 31.2203 10.208C31.0283 10.64 30.8843 10.968 30.7883 11.192C30.6923 11.4 30.6523 11.528 30.6683 11.576C30.6843 11.608 30.7563 11.584 30.8843 11.504C30.9803 11.328 31.1563 11.128 31.4123 10.904C31.6683 10.664 31.9403 10.432 32.2283 10.208C32.5163 9.984 32.7883 9.784 33.0443 9.608C33.3003 9.432 33.4763 9.32 33.5723 9.272C33.7003 9.192 33.8443 9.128 34.0043 9.08C34.1803 9.016 34.3003 8.968 34.3643 8.936C34.7323 8.76 35.1083 8.696 35.4923 8.744C35.8763 8.792 36.1163 8.936 36.2123 9.176C36.2283 9.304 36.2763 9.4 36.3563 9.464C36.4523 9.528 36.5003 9.56 36.5003 9.56C36.5643 9.56 36.5963 9.584 36.5963 9.632C36.6123 9.68 36.6203 9.704 36.6203 9.704C36.6203 9.816 36.5323 9.888 36.3563 9.92C36.1963 9.936 35.9883 9.952 35.7323 9.968C35.5243 9.984 35.3403 10.024 35.1803 10.088C35.0203 10.152 34.8283 10.232 34.6043 10.328C33.9963 10.68 33.4123 11.024 32.8523 11.36C32.3083 11.696 31.7803 12.144 31.2683 12.704C31.1563 12.832 31.0443 12.984 30.9323 13.16C30.8203 13.336 30.7003 13.528 30.5723 13.736C30.4923 13.816 30.4123 13.992 30.3323 14.264C30.2523 14.536 30.1803 14.8 30.1163 15.056C30.0683 15.296 30.0443 15.44 30.0443 15.488C30.0443 15.488 30.0203 15.568 29.9723 15.728C29.9243 15.872 29.8443 16.016 29.7323 16.16C29.5403 16.416 29.3803 16.544 29.2523 16.544C29.1243 16.544 28.9323 16.416 28.6763 16.16ZM41.0928 16.16C40.7568 16.448 40.3648 16.616 39.9168 16.664C39.4848 16.712 39.0608 16.648 38.6448 16.472C38.2288 16.28 37.8848 15.992 37.6128 15.608C37.3408 15.256 37.1648 14.856 37.0848 14.408C37.0048 13.944 36.9968 13.344 37.0608 12.608C37.1088 11.984 37.3088 11.36 37.6608 10.736C38.0128 10.096 38.4368 9.528 38.9328 9.032C39.4448 8.536 39.9488 8.192 40.4448 8C40.6848 7.84 40.8848 7.768 41.0448 7.784C41.2208 7.784 41.4848 7.8 41.8368 7.832C42.2048 7.88 42.4768 7.952 42.6528 8.048C42.8448 8.144 42.9968 8.272 43.1088 8.432C43.3488 8.672 43.5088 8.912 43.5888 9.152C43.6688 9.376 43.7088 9.6 43.7088 9.824C43.6448 10.176 43.4048 10.608 42.9888 11.12C42.5888 11.616 42.0608 12.024 41.4048 12.344C41.0528 12.456 40.6688 12.504 40.2528 12.488C39.8368 12.472 39.4928 12.368 39.2208 12.176C38.9168 12.048 38.7168 12.072 38.6208 12.248C38.5248 12.408 38.4368 12.808 38.3568 13.448C38.2928 14.056 38.3408 14.504 38.5008 14.792C38.6608 15.064 38.8768 15.224 39.1488 15.272C39.4688 15.336 39.7168 15.384 39.8928 15.416C40.0848 15.432 40.3168 15.36 40.5888 15.2C40.8448 15.04 41.0048 14.952 41.0688 14.936C41.1328 14.904 41.1808 14.872 41.2128 14.84C41.2608 14.792 41.3648 14.688 41.5247 14.528C41.6368 14.416 41.7248 14.336 41.7888 14.288C41.8528 14.224 41.9248 14.192 42.0048 14.192C42.0848 14.192 42.1568 14.232 42.2208 14.312C42.2848 14.376 42.3488 14.424 42.4128 14.456C42.5728 14.456 42.6048 14.552 42.5088 14.744C42.4288 14.936 42.2608 15.168 42.0048 15.44C41.7488 15.696 41.4448 15.936 41.0928 16.16ZM41.0688 11.072C41.2448 10.992 41.4288 10.88 41.6208 10.736C41.8128 10.576 41.9728 10.408 42.1008 10.232C42.2448 10.04 42.3168 9.88 42.3168 9.752C42.3168 9.528 42.2128 9.344 42.0048 9.2C41.7968 9.04 41.4848 9.016 41.0688 9.128C40.8928 9.176 40.6927 9.296 40.4688 9.488C40.2448 9.664 40.0288 9.864 39.8208 10.088C39.6288 10.312 39.4688 10.512 39.3408 10.688C39.2288 10.864 39.1888 10.968 39.2208 11C39.2688 11.08 39.4048 11.144 39.6288 11.192C39.8528 11.224 40.1008 11.232 40.3728 11.216C40.6608 11.2 40.8928 11.152 41.0688 11.072ZM50.8699 15.872C50.7099 15.776 50.5899 15.68 50.5099 15.584C50.4299 15.488 50.3899 15.352 50.3899 15.176C50.3899 14.936 50.4219 14.688 50.4859 14.432C50.5499 14.16 50.6139 13.896 50.6779 13.64C50.7099 13.352 50.7499 13.064 50.7979 12.776C50.8619 12.472 50.9739 12.192 51.1339 11.936C51.3099 11.328 51.4939 10.728 51.6859 10.136C51.8779 9.528 52.0459 8.904 52.1899 8.264C52.3979 7.672 52.5819 7.152 52.7419 6.704C52.9179 6.24 53.1339 5.656 53.3899 4.952C53.5339 4.552 53.6539 4.128 53.7499 3.68C53.8619 3.216 54.0299 2.8 54.2539 2.432C54.3499 2.288 54.4219 2.168 54.4699 2.072C54.5339 1.96 54.5979 1.856 54.6619 1.76C54.6779 1.696 54.7259 1.656 54.8059 1.64C54.9019 1.624 55.0059 1.632 55.1179 1.664C55.2299 1.696 55.3179 1.752 55.3819 1.832C55.4299 1.816 55.4859 1.864 55.5499 1.976C55.6299 2.072 55.7019 2.184 55.7659 2.312C55.8299 2.44 55.8539 2.552 55.8379 2.648C55.8379 2.712 55.8219 2.8 55.7899 2.912C55.7739 3.024 55.7339 3.128 55.6699 3.224C55.6059 3.288 55.5419 3.384 55.4779 3.512C55.4299 3.624 55.3499 3.784 55.2379 3.992C55.1739 4.2 55.1179 4.416 55.0699 4.64C55.0219 4.848 54.9579 5.04 54.8779 5.216C54.8139 5.408 54.7339 5.592 54.6379 5.768C54.5579 5.944 54.5019 6.088 54.4699 6.2C54.3579 6.568 54.2219 6.928 54.0619 7.28C53.9179 7.632 53.7899 8.008 53.6779 8.408C53.5659 8.792 53.4539 9.192 53.3419 9.608C53.2299 10.008 53.0699 10.392 52.8619 10.76C52.7499 10.936 52.6699 11.16 52.6219 11.432C52.5739 11.704 52.5259 11.976 52.4779 12.248C52.3819 12.536 52.2939 12.808 52.2139 13.064C52.1499 13.304 52.1179 13.456 52.1179 13.52C52.0219 13.872 51.9499 14.224 51.9019 14.576C51.8699 14.912 51.7899 15.208 51.6619 15.464C51.6459 15.624 51.6139 15.752 51.5659 15.848C51.5179 15.944 51.4379 16 51.3259 16.016C51.2139 16.016 51.0619 15.968 50.8699 15.872ZM55.7406 16.256C55.5006 16.224 55.2926 16.056 55.1166 15.752C54.9566 15.432 54.8606 15.144 54.8286 14.888C54.8446 14.76 54.8606 14.576 54.8766 14.336C54.9086 14.096 54.9406 13.848 54.9726 13.592C55.0366 13.288 55.1246 12.92 55.2366 12.488C55.3486 12.04 55.4606 11.592 55.5726 11.144C55.7006 10.696 55.8126 10.312 55.9086 9.992C56.0046 9.672 56.0686 9.48 56.1006 9.416C56.1806 9.288 56.3086 9.256 56.4846 9.32C56.6606 9.384 56.8046 9.48 56.9166 9.608C57.0126 9.736 57.0686 9.888 57.0846 10.064C57.1166 10.24 57.0926 10.496 57.0126 10.832C56.9486 11.168 56.8206 11.664 56.6286 12.32C56.4526 12.96 56.3166 13.48 56.2206 13.88C56.1406 14.264 56.1086 14.672 56.1246 15.104C56.0606 15.648 56.0126 15.984 55.9806 16.112C55.9486 16.224 55.8686 16.272 55.7406 16.256ZM58.5006 6.68C58.4366 6.728 58.3726 6.752 58.3086 6.752C58.2606 6.736 58.1726 6.688 58.0446 6.608C57.9326 6.592 57.7886 6.52 57.6126 6.392C57.4526 6.248 57.3086 6.104 57.1806 5.96C57.0686 5.8 57.0126 5.704 57.0126 5.672C56.9966 5.512 57.0046 5.312 57.0366 5.072C57.0846 4.816 57.1726 4.592 57.3006 4.4C57.4286 4.192 57.6126 4.08 57.8526 4.064C57.9166 4.064 57.9726 4.072 58.0206 4.088C58.0686 4.104 58.2126 4.16 58.4526 4.256C58.5806 4.496 58.7086 4.768 58.8366 5.072C58.9646 5.36 59.0206 5.648 59.0046 5.936C58.9886 6.208 58.8206 6.456 58.5006 6.68ZM61.2252 16.664C60.4252 16.664 59.8412 16.376 59.4732 15.8C59.3612 15.64 59.3052 15.48 59.3052 15.32C59.3212 15.144 59.3692 15.024 59.4492 14.96C59.5452 14.896 59.6572 14.952 59.7852 15.128C60.0092 15.256 60.3292 15.32 60.7452 15.32C60.9532 15.32 61.1692 15.304 61.3932 15.272C61.6172 15.224 61.8412 15.16 62.0652 15.08C62.3052 14.968 62.4652 14.872 62.5452 14.792C62.6252 14.696 62.6092 14.616 62.4972 14.552H62.5212C62.1052 14.44 61.6812 14.264 61.2492 14.024C60.8332 13.768 60.4732 13.496 60.1692 13.208C59.8652 12.904 59.6892 12.632 59.6412 12.392C59.5132 11.896 59.5452 11.392 59.7372 10.88C59.9292 10.352 60.2012 9.888 60.5532 9.488C60.6812 9.408 60.8412 9.312 61.0332 9.2C61.2252 9.072 61.3772 9 61.4892 8.984V9.008C61.7932 8.688 62.1612 8.432 62.5932 8.24C63.0412 8.048 63.5132 7.872 64.0092 7.712L64.3692 7.664C64.5612 7.632 64.7212 7.616 64.8492 7.616C64.8332 7.616 64.8652 7.632 64.9452 7.664C65.0252 7.68 65.0972 7.696 65.1612 7.712C65.2572 7.76 65.3372 7.784 65.4012 7.784C65.6092 7.816 65.8012 7.912 65.9772 8.072C66.1532 8.232 66.2892 8.424 66.3852 8.648C66.4972 8.856 66.5372 9.056 66.5052 9.248C66.4732 9.552 66.3772 9.824 66.2172 10.064C66.0732 10.304 65.8972 10.44 65.6892 10.472C65.7212 10.456 65.6972 10.432 65.6172 10.4C65.5532 10.352 65.4812 10.304 65.4012 10.256L65.3292 10.304C65.3292 10.304 65.3212 10.288 65.3052 10.256C65.3052 10.208 65.2892 10.152 65.2572 10.088C65.2092 9.992 65.1852 9.888 65.1852 9.776C65.1852 9.648 65.1932 9.512 65.2092 9.368C65.2412 9.192 65.2412 9.088 65.2092 9.056C65.1932 9.024 65.0892 9 64.8972 8.984C64.6732 8.936 64.3452 8.976 63.9132 9.104C63.4972 9.232 63.1452 9.408 62.8572 9.632C62.5052 9.856 62.2092 10.072 61.9692 10.28C61.7292 10.472 61.5372 10.664 61.3932 10.856C61.2492 11.032 61.1212 11.24 61.0092 11.48C60.9292 11.592 60.8572 11.704 60.7932 11.816C60.7452 11.912 60.7212 12 60.7212 12.08C60.7212 12.256 60.8492 12.44 61.1052 12.632C61.3772 12.808 61.7772 13.016 62.3052 13.256C62.7212 13.432 63.0732 13.624 63.3612 13.832C63.6492 14.04 63.8492 14.28 63.9612 14.552C63.9932 14.616 64.0012 14.696 63.9852 14.792C63.9852 14.872 63.9692 14.928 63.9372 14.96C63.9692 14.992 63.9852 15.016 63.9852 15.032V15.008C64.1132 15.2 64.1132 15.4 63.9852 15.608C63.8732 15.816 63.6732 16 63.3852 16.16C63.1132 16.304 62.7772 16.416 62.3772 16.496H62.4012C62.1932 16.56 61.9852 16.608 61.7772 16.64C61.5852 16.656 61.4012 16.664 61.2252 16.664ZM69.0929 16.832C68.9169 16.8 68.7329 16.712 68.5409 16.568C68.3649 16.408 68.2049 16.232 68.0609 16.04C67.9329 15.832 67.8449 15.648 67.7969 15.488C67.7969 15.456 67.7729 15.416 67.7249 15.368C67.6929 15.32 67.6769 15.296 67.6769 15.296C67.6129 15.248 67.5729 15.04 67.5569 14.672C67.5569 14.288 67.5809 13.864 67.6289 13.4C67.6769 12.936 67.7329 12.568 67.7969 12.296C67.8769 12.04 67.9969 11.696 68.1569 11.264C68.3169 10.816 68.4529 10.416 68.5649 10.064L69.2129 8.672L68.2529 8.408C68.1409 8.376 68.0449 8.312 67.9649 8.216C67.9009 8.12 67.8689 8.04 67.8689 7.976C67.8689 7.848 67.9409 7.696 68.0849 7.52C68.2289 7.328 68.3329 7.232 68.3969 7.232C68.4769 7.248 68.6209 7.256 68.8289 7.256C69.0529 7.256 69.2689 7.248 69.4769 7.232C69.6849 7.216 69.8129 7.2 69.8609 7.184C69.9249 7.152 69.9889 7.112 70.0529 7.064C70.1169 7 70.1649 6.912 70.1969 6.8C70.2769 6.624 70.3489 6.464 70.4129 6.32C70.4769 6.16 70.5649 5.984 70.6769 5.792C70.7889 5.584 70.8769 5.408 70.9409 5.264C71.0209 5.12 71.1409 4.92 71.3009 4.664C71.3809 4.552 71.4689 4.416 71.5649 4.256C71.6609 4.096 71.7809 3.96 71.9249 3.848C72.0689 3.72 72.2129 3.664 72.3569 3.68C72.5169 3.68 72.7169 3.784 72.9569 3.992C73.0849 4.152 73.1569 4.272 73.1729 4.352C73.1889 4.432 73.1249 4.584 72.9809 4.808C72.8529 5.08 72.7009 5.352 72.5249 5.624C72.3649 5.896 72.2129 6.168 72.0689 6.44C71.8129 6.792 71.7649 6.992 71.9249 7.04C72.0849 7.088 72.5329 7.056 73.2689 6.944C73.7329 6.864 74.0689 6.888 74.2769 7.016C74.4849 7.128 74.6049 7.32 74.6369 7.592C74.6849 7.976 74.6449 8.208 74.5169 8.288C74.3889 8.368 74.0209 8.408 73.4129 8.408C73.0289 8.472 72.7009 8.512 72.4289 8.528C72.1569 8.528 71.9569 8.528 71.8289 8.528C71.6209 8.544 71.4849 8.552 71.4209 8.552C71.3569 8.552 71.2609 8.568 71.1329 8.6C71.0049 8.632 70.9089 8.688 70.8449 8.768C70.7969 8.832 70.7409 8.928 70.6769 9.056C70.6129 9.12 70.5169 9.288 70.3889 9.56C70.2609 9.832 70.1009 10.128 69.9089 10.448C69.6849 11.12 69.4929 11.792 69.3329 12.464C69.1729 13.12 69.0449 13.76 68.9489 14.384C68.8849 14.784 68.8929 15.064 68.9729 15.224C69.0529 15.368 69.2609 15.456 69.5969 15.488C69.7729 15.504 70.0529 15.504 70.4369 15.488C70.8369 15.456 71.1489 15.408 71.3729 15.344C71.5489 15.264 71.7329 15.184 71.9249 15.104C72.1169 15.008 72.2929 14.912 72.4529 14.816C72.5969 14.736 72.7409 14.656 72.8849 14.576C73.0289 14.48 73.1009 14.432 73.1009 14.432C73.1809 14.304 73.2689 14.264 73.3649 14.312C73.4609 14.36 73.5409 14.48 73.6049 14.672C73.6049 14.864 73.5649 15.064 73.4849 15.272C73.4049 15.48 73.1089 15.728 72.5969 16.016C71.8769 16.464 71.2129 16.736 70.6049 16.832C70.0129 16.912 69.5089 16.912 69.0929 16.832ZM76.8222 16.424C76.1982 16.168 75.7902 15.816 75.5982 15.368C75.4222 14.904 75.3902 14.192 75.5022 13.232C75.5342 12.736 75.5502 12.408 75.5502 12.248C75.5502 12.088 75.4622 11.928 75.2862 11.768C75.2382 11.704 75.1502 11.616 75.0222 11.504C74.9102 11.392 74.8622 11.296 74.8782 11.216C74.8622 11.104 74.8702 10.984 74.9022 10.856C74.9342 10.712 74.9822 10.64 75.0462 10.64C75.1102 10.64 75.1742 10.624 75.2382 10.592C75.3182 10.56 75.3902 10.56 75.4542 10.592C75.5182 10.592 75.5902 10.6 75.6702 10.616C75.7502 10.632 75.7902 10.672 75.7902 10.736C75.8542 10.848 75.9582 10.864 76.1022 10.784C76.2462 10.688 76.3982 10.48 76.5582 10.16C76.7182 9.904 76.9262 9.648 77.1822 9.392C77.4542 9.136 77.7182 8.904 77.9742 8.696C78.2462 8.472 78.4702 8.312 78.6462 8.216C78.7262 8.184 78.8462 8.144 79.0062 8.096C79.1662 8.048 79.3342 8.008 79.5102 7.976C79.7022 7.944 79.8622 7.936 79.9902 7.952C80.2782 7.968 80.5182 8.048 80.7102 8.192C80.9182 8.336 81.1102 8.504 81.2862 8.696C81.4942 8.84 81.6222 9.032 81.6702 9.272C81.7342 9.512 81.7502 9.768 81.7182 10.04C81.6862 10.312 81.6142 10.56 81.5022 10.784C81.4542 10.944 81.3182 11.136 81.0942 11.36C80.8702 11.584 80.6142 11.8 80.3262 12.008C80.0382 12.216 79.7742 12.368 79.5342 12.464C79.3262 12.512 79.0542 12.552 78.7182 12.584C78.3982 12.616 78.0942 12.632 77.8062 12.632C77.5342 12.616 77.3502 12.584 77.2542 12.536C77.1422 12.472 77.0542 12.56 76.9902 12.8C76.9262 13.04 76.8782 13.384 76.8462 13.832C76.8142 14.184 76.8142 14.44 76.8462 14.6C76.8782 14.76 76.9102 14.872 76.9422 14.936C77.0542 15.048 77.2062 15.192 77.3982 15.368C77.6062 15.528 77.8942 15.552 78.2622 15.44C78.5662 15.36 78.8622 15.152 79.1502 14.816C79.4542 14.48 79.7342 14.208 79.9902 14C80.0542 13.888 80.1582 13.824 80.3022 13.808C80.4622 13.776 80.6302 13.784 80.8062 13.832C80.9822 13.944 81.0542 14.08 81.0222 14.24C81.0062 14.384 80.9262 14.608 80.7822 14.912C80.7342 15.024 80.6222 15.168 80.4462 15.344C80.2862 15.504 80.1022 15.672 79.8942 15.848C79.7022 16.008 79.5262 16.136 79.3662 16.232C78.8862 16.488 78.4382 16.624 78.0222 16.64C77.6062 16.64 77.2062 16.568 76.8222 16.424ZM78.2382 11.552C78.5902 11.472 78.8702 11.416 79.0782 11.384C79.2862 11.352 79.4862 11.264 79.6782 11.12C79.8702 10.96 80.1102 10.664 80.3982 10.232C80.4622 10.056 80.4782 9.88 80.4462 9.704C80.4302 9.528 80.3902 9.408 80.3262 9.344C80.1822 9.184 80.0062 9.136 79.7982 9.2C79.6062 9.248 79.4222 9.336 79.2462 9.464C79.1342 9.512 78.9662 9.632 78.7422 9.824C78.5342 10 78.3262 10.208 78.1182 10.448C77.9102 10.672 77.7422 10.88 77.6142 11.072C77.4862 11.264 77.4542 11.376 77.5182 11.408C77.4862 11.472 77.5742 11.512 77.7822 11.528C78.0062 11.544 78.1582 11.552 78.2382 11.552ZM90.3869 16.712C90.2269 16.712 90.0589 16.624 89.8829 16.448C89.7229 16.272 89.5789 16.056 89.4509 15.8C89.3389 15.528 89.2829 15.272 89.2829 15.032C89.2829 14.792 89.3389 14.344 89.4509 13.688C89.5789 13.032 89.7309 12.368 89.9069 11.696C90.0349 11.28 90.0749 11.04 90.0269 10.976C89.9789 10.912 89.7629 11 89.3789 11.24C89.1549 11.352 88.9549 11.472 88.7789 11.6C88.6029 11.712 88.4509 11.84 88.3229 11.984C88.2429 12.048 88.1229 12.152 87.9629 12.296C87.8029 12.44 87.6349 12.576 87.4589 12.704C87.2509 12.864 86.9869 13.088 86.6669 13.376C86.3469 13.664 86.0269 13.952 85.7069 14.24C85.4029 14.528 85.1709 14.752 85.0109 14.912C84.9789 14.976 84.9309 15.032 84.8669 15.08C84.8029 15.128 84.7309 15.16 84.6509 15.176C84.5709 15.176 84.4829 15.16 84.3869 15.128C84.2109 15.08 84.0429 14.976 83.8829 14.816C83.7389 14.656 83.6669 14.472 83.6669 14.264C83.6669 14.104 83.7309 13.832 83.8589 13.448C83.9869 13.048 84.1549 12.568 84.3629 12.008C84.5869 11.448 84.8429 10.856 85.1309 10.232C85.1789 10.152 85.2189 10.056 85.2509 9.944C85.2829 9.816 85.3069 9.68 85.3229 9.536C85.3549 9.392 85.3709 9.256 85.3709 9.128C85.3709 9.048 85.3789 8.968 85.3949 8.888C85.4269 8.792 85.4589 8.704 85.4909 8.624C85.5389 8.528 85.5789 8.464 85.6109 8.432C85.6749 8.304 85.7869 8.272 85.9469 8.336C86.1069 8.384 86.2429 8.496 86.3549 8.672C86.5949 8.896 86.7149 9.176 86.7149 9.512C86.7309 9.848 86.6509 10.264 86.4749 10.76C86.4109 10.872 86.3549 10.984 86.3069 11.096C86.2749 11.192 86.2429 11.28 86.2109 11.36C86.1789 11.424 86.1549 11.48 86.1389 11.528C86.1229 11.56 86.1149 11.576 86.1149 11.576C86.1789 11.576 86.3229 11.504 86.5469 11.36C86.7709 11.216 87.0349 11.056 87.3389 10.88C87.5789 10.704 87.7869 10.544 87.9629 10.4C88.1549 10.24 88.3149 10.12 88.4429 10.04C88.5709 9.944 88.6509 9.896 88.6829 9.896C88.7469 9.896 88.8269 9.872 88.9229 9.824C89.0189 9.776 89.0989 9.72 89.1629 9.656C89.2269 9.592 89.2749 9.56 89.3069 9.56C89.3549 9.544 89.3789 9.536 89.3789 9.536C89.3789 9.536 89.4109 9.536 89.4749 9.536C89.5389 9.52 89.6029 9.48 89.6669 9.416C89.7949 9.32 89.9629 9.296 90.1709 9.344C90.3789 9.376 90.5709 9.456 90.7469 9.584C90.9229 9.712 91.0109 9.856 91.0109 10.016C91.0109 10.08 91.0269 10.136 91.0589 10.184C91.1069 10.216 91.1309 10.232 91.1309 10.232C91.2589 10.232 91.3389 10.432 91.3709 10.832C91.4189 11.232 91.3789 11.616 91.2509 11.984C91.2509 12.224 91.2029 12.512 91.1069 12.848C91.0269 13.184 90.9549 13.504 90.8909 13.808C90.7629 14.208 90.6749 14.56 90.6269 14.864C90.5789 15.168 90.5709 15.424 90.6029 15.632C90.6349 15.84 90.6909 16.008 90.7709 16.136C90.8349 16.248 90.8349 16.376 90.7709 16.52C90.7069 16.648 90.5789 16.712 90.3869 16.712ZM94.0156 16.232C93.8876 16.104 93.7916 15.944 93.7276 15.752C93.6796 15.56 93.6636 15.368 93.6796 15.176C93.6956 14.984 93.7356 14.824 93.7996 14.696C93.7996 14.568 93.8156 14.472 93.8476 14.408C93.8956 14.328 93.9116 14.256 93.8956 14.192C93.8796 14.128 93.8956 14.016 93.9436 13.856C93.9916 13.696 94.0396 13.544 94.0876 13.4C94.1996 13.144 94.3196 12.84 94.4476 12.488C94.5756 12.12 94.6956 11.76 94.8076 11.408C94.9196 11.056 95.0156 10.752 95.0956 10.496C95.1756 10.24 95.2236 10.08 95.2396 10.016C95.2396 9.824 95.3676 9.72 95.6236 9.704C95.8156 9.64 95.9596 9.64 96.0556 9.704C96.1516 9.752 96.2796 9.904 96.4396 10.16C96.5676 10.288 96.6156 10.48 96.5836 10.736C96.5516 10.992 96.4476 11.312 96.2716 11.696C96.2076 11.824 96.1276 12.008 96.0316 12.248C95.9516 12.488 95.8956 12.704 95.8636 12.896C95.7996 13.024 95.7196 13.208 95.6236 13.448C95.5436 13.672 95.4716 13.888 95.4076 14.096C95.3756 14.176 95.3436 14.296 95.3116 14.456C95.2796 14.6 95.2396 14.76 95.1916 14.936C95.1436 15.096 95.0796 15.24 94.9996 15.368C94.8556 16.024 94.7196 16.408 94.5916 16.52C94.4796 16.632 94.2876 16.536 94.0156 16.232ZM96.3436 6.488C96.2636 6.408 96.1916 6.296 96.1276 6.152C96.0636 5.992 96.0236 5.848 96.0076 5.72C95.9916 5.576 96.0076 5.504 96.0556 5.504C96.1836 5.488 96.3356 5.352 96.5116 5.096C96.6876 4.84 96.7596 4.616 96.7276 4.424C96.7276 4.36 96.7516 4.304 96.7996 4.256C96.8476 4.192 96.9036 4.152 96.9676 4.136C97.1596 4.008 97.3436 3.992 97.5196 4.088C97.7116 4.168 97.8876 4.336 98.0476 4.592C98.1916 4.896 98.2316 5.152 98.1676 5.36C98.1036 5.552 97.9276 5.824 97.6396 6.176C97.3996 6.496 97.1756 6.672 96.9676 6.704C96.7756 6.736 96.5676 6.664 96.3436 6.488ZM99.3801 15.944C99.3161 15.944 99.2201 15.904 99.0921 15.824C98.9801 15.728 98.8921 15.648 98.8281 15.584C98.7161 15.456 98.6441 15.328 98.6121 15.2C98.5961 15.072 98.5881 14.784 98.5881 14.336C98.5881 13.824 98.6921 13.272 98.9001 12.68C99.1081 12.072 99.4601 11.224 99.9561 10.136L100.748 8.456C100.812 8.328 100.868 8.232 100.916 8.168C100.98 8.104 101.036 8.04 101.084 7.976C101.148 7.976 101.204 7.976 101.252 7.976C101.3 7.976 101.324 7.976 101.324 7.976C101.452 7.976 101.58 8.056 101.708 8.216C101.836 8.36 101.932 8.52 101.996 8.696C101.996 8.904 101.964 9.12 101.9 9.344C101.852 9.568 101.66 9.904 101.324 10.352C101.212 10.528 101.06 10.824 100.868 11.24C100.692 11.656 100.572 12.016 100.508 12.32C100.492 12.336 100.46 12.408 100.412 12.536C100.364 12.648 100.308 12.776 100.244 12.92C100.196 13.064 100.14 13.2 100.076 13.328L99.9561 13.856L101.564 12.2C102.316 11.448 102.924 10.912 103.388 10.592C103.852 10.272 104.22 10.136 104.492 10.184C104.764 10.232 104.996 10.448 105.188 10.832C105.3 11.008 105.38 11.168 105.428 11.312C105.492 11.44 105.532 11.616 105.548 11.84C105.564 12.064 105.548 12.4 105.5 12.848V14.336C105.74 14.272 105.932 14.216 106.076 14.168C106.22 14.104 106.372 14.04 106.532 13.976C106.676 13.912 106.844 13.856 107.036 13.808C107.228 13.744 107.468 13.704 107.756 13.688C107.74 13.896 107.668 14.12 107.54 14.36C107.412 14.584 107.252 14.8 107.06 15.008C106.868 15.216 106.652 15.384 106.412 15.512C106.188 15.64 105.964 15.704 105.74 15.704C105.532 15.704 105.3 15.6 105.044 15.392C104.788 15.184 104.604 14.952 104.492 14.696C104.428 14.52 104.388 14.328 104.372 14.12C104.372 13.912 104.372 13.528 104.372 12.968V12.08C104.372 11.824 104.292 11.752 104.132 11.864C103.988 11.96 103.868 12.048 103.772 12.128C103.532 12.336 103.276 12.576 103.004 12.848C102.748 13.12 102.484 13.4 102.212 13.688C101.476 14.456 100.86 15.024 100.364 15.392C99.8841 15.76 99.5561 15.944 99.3801 15.944ZM111.553 21.584C111.105 21.76 110.633 21.728 110.137 21.488C109.657 21.264 109.241 20.904 108.889 20.408C108.825 20.312 108.745 20.16 108.649 19.952C108.569 19.76 108.489 19.56 108.409 19.352C108.345 19.144 108.305 18.96 108.289 18.8C108.273 18.64 108.289 18.544 108.337 18.512C108.385 18.464 108.465 18.448 108.577 18.464C108.689 18.48 108.793 18.52 108.889 18.584C109.001 18.648 109.073 18.728 109.105 18.824C109.153 18.936 109.225 19.08 109.321 19.256C109.433 19.432 109.553 19.592 109.681 19.736C109.809 19.88 109.905 19.96 109.969 19.976C110.273 20.12 110.497 20.184 110.641 20.168C110.785 20.152 110.913 20.104 111.025 20.024C111.297 19.816 111.521 19.544 111.697 19.208C111.873 18.872 112.073 18.352 112.297 17.648C112.473 17.056 112.649 16.432 112.825 15.776C113.017 15.104 113.185 14.584 113.329 14.216C113.377 14.024 113.433 13.864 113.497 13.736C113.577 13.592 113.649 13.488 113.713 13.424H113.857C113.505 13.648 113.193 13.904 112.921 14.192C112.649 14.48 112.305 14.712 111.889 14.888C111.793 15 111.553 15.072 111.169 15.104C110.801 15.12 110.441 15.072 110.089 14.96C109.865 14.832 109.697 14.736 109.585 14.672C109.489 14.608 109.409 14.52 109.345 14.408C109.297 14.296 109.225 14.12 109.129 13.88C109.017 13.64 109.001 13.248 109.081 12.704C109.161 12.16 109.305 11.616 109.513 11.072C109.705 10.672 109.985 10.24 110.353 9.776C110.721 9.312 111.113 8.896 111.529 8.528C111.945 8.144 112.321 7.904 112.657 7.808C112.785 7.744 112.921 7.704 113.065 7.688C113.225 7.656 113.449 7.68 113.737 7.76C114.009 7.792 114.217 7.856 114.361 7.952C114.505 8.032 114.737 8.208 115.057 8.48C115.265 8.688 115.433 8.896 115.561 9.104C115.705 9.312 115.817 9.528 115.897 9.752C116.009 9.992 116.049 10.216 116.017 10.424C116.001 10.616 115.913 10.816 115.753 11.024C115.609 11.232 115.457 11.44 115.297 11.648C115.137 11.856 115.017 12.144 114.937 12.512C114.857 12.992 114.729 13.536 114.553 14.144C114.377 14.736 114.225 15.288 114.097 15.8L113.713 17.288C113.313 18.648 112.929 19.656 112.561 20.312C112.209 20.984 111.873 21.408 111.553 21.584ZM110.689 13.904C111.009 13.888 111.313 13.824 111.601 13.712C111.889 13.6 112.169 13.416 112.441 13.16C112.713 12.888 112.985 12.544 113.257 12.128C113.529 11.744 113.721 11.344 113.833 10.928C113.945 10.496 113.985 10.08 113.953 9.68C113.937 9.424 113.897 9.256 113.833 9.176C113.769 9.096 113.633 9.072 113.425 9.104C113.121 9.152 112.785 9.32 112.417 9.608C112.049 9.88 111.705 10.224 111.385 10.64C111.145 10.96 110.945 11.344 110.785 11.792C110.625 12.272 110.529 12.728 110.497 13.16C110.465 13.592 110.529 13.84 110.689 13.904ZM126.377 16.952C126.153 16.888 125.969 16.816 125.825 16.736C125.681 16.64 125.489 16.488 125.249 16.28C125.057 16.024 124.905 15.784 124.793 15.56C124.697 15.336 124.633 15.08 124.601 14.792C124.569 14.488 124.553 14.104 124.553 13.64C124.553 13.448 124.585 13.16 124.649 12.776C124.729 12.392 124.817 11.992 124.913 11.576C125.025 11.144 125.121 10.76 125.201 10.424C125.297 10.088 125.353 9.872 125.369 9.776C125.417 9.568 125.337 9.448 125.129 9.416C124.921 9.384 124.689 9.376 124.433 9.392C124.193 9.392 124.033 9.368 123.953 9.32C123.889 9.304 123.857 9.28 123.857 9.248C123.857 9.2 123.857 9.176 123.857 9.176C123.857 9.112 123.849 9.072 123.833 9.056C123.833 9.024 123.809 8.968 123.761 8.888C123.729 8.824 123.745 8.736 123.809 8.624C123.889 8.496 124.017 8.416 124.193 8.384C124.337 8.352 124.529 8.328 124.769 8.312C125.025 8.28 125.281 8.224 125.537 8.144C125.793 8.048 126.001 7.904 126.161 7.712C126.305 7.36 126.473 6.968 126.665 6.536C126.857 6.104 127.041 5.72 127.217 5.384C127.409 5.032 127.537 4.816 127.601 4.736C127.873 4.592 128.073 4.536 128.201 4.568C128.329 4.584 128.473 4.72 128.633 4.976C128.713 5.088 128.769 5.176 128.801 5.24C128.849 5.304 128.857 5.4 128.825 5.528C128.793 5.656 128.705 5.856 128.561 6.128C128.433 6.4 128.233 6.792 127.961 7.304C127.881 7.464 127.809 7.608 127.745 7.736C127.681 7.848 127.649 7.904 127.649 7.904C127.713 7.92 127.809 7.928 127.937 7.928C128.065 7.928 128.225 7.92 128.417 7.904C128.593 7.872 128.817 7.848 129.089 7.832C129.361 7.8 129.577 7.8 129.737 7.832C130.105 7.832 130.377 7.904 130.553 8.048C130.729 8.176 130.825 8.4 130.841 8.72C130.873 8.896 130.833 9 130.721 9.032C130.625 9.064 130.361 9.08 129.929 9.08C129.785 9.08 129.561 9.088 129.257 9.104C128.953 9.12 128.633 9.136 128.297 9.152C127.977 9.168 127.697 9.192 127.457 9.224C127.233 9.24 127.121 9.264 127.121 9.296C127.073 9.328 126.993 9.48 126.881 9.752C126.785 10.024 126.681 10.336 126.569 10.688C126.473 11.024 126.385 11.328 126.305 11.6C126.193 12.144 126.105 12.688 126.041 13.232C125.993 13.776 125.985 14.248 126.017 14.648C126.049 15.048 126.137 15.328 126.281 15.488C126.425 15.632 126.705 15.664 127.121 15.584C127.537 15.488 127.873 15.336 128.129 15.128C128.417 14.888 128.649 14.768 128.825 14.768C129.017 14.768 129.121 14.856 129.137 15.032C129.169 15.192 129.081 15.424 128.873 15.728C128.681 16.016 128.441 16.272 128.153 16.496C127.865 16.704 127.561 16.856 127.241 16.952C126.937 17.032 126.649 17.032 126.377 16.952ZM133.842 16.088C133.506 16.152 133.29 16.176 133.194 16.16C133.114 16.128 132.986 16.032 132.81 15.872C132.554 15.744 132.338 15.584 132.162 15.392C132.002 15.2 131.882 15 131.802 14.792C131.738 14.568 131.714 14.384 131.73 14.24C131.778 13.68 131.914 13.08 132.138 12.44C132.362 11.8 132.634 11.184 132.954 10.592C133.274 10 133.618 9.496 133.986 9.08C134.37 8.648 134.738 8.368 135.09 8.24C135.41 8.112 135.714 8.064 136.002 8.096C136.29 8.128 136.498 8.28 136.626 8.552C136.866 9.016 136.81 9.312 136.458 9.44C136.41 9.44 136.354 9.464 136.29 9.512C136.226 9.544 136.194 9.592 136.194 9.656C136.258 9.688 136.434 9.696 136.722 9.68C137.01 9.648 137.298 9.6 137.586 9.536C137.89 9.456 138.09 9.376 138.186 9.296C138.282 9.248 138.354 9.224 138.402 9.224C138.45 9.224 138.57 9.24 138.762 9.272C139.034 9.352 139.17 9.448 139.17 9.56C139.17 9.624 139.194 9.688 139.242 9.752C139.29 9.8 139.346 9.824 139.41 9.824C139.522 9.84 139.506 9.912 139.362 10.04C139.234 10.168 139.01 10.344 138.69 10.568C138.386 10.76 138.194 10.888 138.114 10.952C138.05 11 138.042 11.112 138.09 11.288C138.218 11.592 138.226 11.944 138.114 12.344C138.002 12.744 137.802 13.152 137.514 13.568C137.226 13.984 136.874 14.376 136.458 14.744C136.058 15.096 135.626 15.4 135.162 15.656C134.714 15.896 134.274 16.04 133.842 16.088ZM133.434 15.032C133.498 15.032 133.61 15 133.77 14.936C133.93 14.856 134.058 14.792 134.154 14.744C134.218 14.68 134.298 14.608 134.394 14.528C134.506 14.432 134.594 14.376 134.658 14.36C134.722 14.36 134.802 14.336 134.898 14.288C134.994 14.224 135.13 14.104 135.306 13.928C135.482 13.736 135.714 13.456 136.002 13.088C136.322 12.736 136.57 12.416 136.746 12.128C136.922 11.824 136.97 11.544 136.89 11.288C136.874 11.224 136.826 11.184 136.746 11.168C136.682 11.152 136.594 11.112 136.482 11.048C136.322 11.048 136.17 11.008 136.026 10.928C135.898 10.832 135.746 10.712 135.57 10.568L135.186 10.088L134.778 10.496C134.522 10.752 134.25 11.136 133.962 11.648C133.69 12.144 133.458 12.656 133.266 13.184C133.074 13.696 132.962 14.104 132.93 14.408C132.914 14.648 132.954 14.808 133.05 14.888C133.146 14.968 133.274 15.016 133.434 15.032ZM149.291 18.2C149.003 18.12 148.771 18.048 148.595 17.984C148.419 17.936 148.331 17.912 148.331 17.912C148.363 17.832 148.347 17.76 148.283 17.696C148.235 17.632 148.123 17.592 147.947 17.576C147.707 17.432 147.483 17.248 147.275 17.024C147.083 16.816 146.923 16.608 146.795 16.4C146.667 16.192 146.571 16.016 146.507 15.872C146.395 15.632 146.339 15.488 146.339 15.44C146.355 15.376 146.451 15.304 146.627 15.224C146.803 15.096 146.931 15.056 147.011 15.104C147.107 15.152 147.219 15.312 147.347 15.584C147.555 15.952 147.907 16.232 148.403 16.424C148.915 16.616 149.483 16.704 150.107 16.688C150.747 16.656 151.355 16.512 151.931 16.256C152.523 16.016 152.891 15.768 153.035 15.512C153.195 15.24 153.139 14.896 152.867 14.48C152.819 14.352 152.763 14.248 152.699 14.168C152.635 14.088 152.531 13.984 152.387 13.856C152.259 13.728 152.043 13.52 151.739 13.232C151.499 13.12 151.275 13.016 151.067 12.92C150.875 12.824 150.667 12.72 150.443 12.608C150.187 12.48 149.875 12.296 149.507 12.056C149.155 11.8 148.819 11.52 148.499 11.216C148.179 10.912 147.947 10.632 147.803 10.376C147.547 10.136 147.355 9.808 147.227 9.392C147.099 8.96 147.051 8.504 147.083 8.024C147.115 7.544 147.235 7.112 147.443 6.728C147.539 6.504 147.699 6.232 147.923 5.912C148.163 5.576 148.427 5.24 148.715 4.904C149.003 4.568 149.283 4.264 149.555 3.992C149.827 3.72 150.051 3.528 150.227 3.416C150.355 3.288 150.491 3.16 150.635 3.032C150.779 2.888 150.851 2.816 150.851 2.816C150.867 2.736 150.891 2.696 150.923 2.696C150.971 2.696 150.995 2.696 150.995 2.696C151.075 2.648 151.251 2.568 151.523 2.456C151.795 2.344 152.091 2.136 152.411 1.832C153.483 1.32 154.355 0.943999 155.027 0.704C155.699 0.464 156.251 0.344 156.683 0.344C157.083 0.36 157.443 0.455999 157.763 0.631999C158.099 0.791999 158.371 1.008 158.579 1.28C158.803 1.552 158.939 1.88 158.987 2.264C159.099 2.648 159.067 3.096 158.891 3.608C158.715 4.104 158.451 4.576 158.099 5.024C157.763 5.456 157.395 5.784 156.995 6.008C156.547 6.2 156.243 6.288 156.083 6.272C155.939 6.24 155.875 6.072 155.891 5.768C155.891 5.64 155.931 5.488 156.011 5.312C156.107 5.136 156.355 4.824 156.755 4.376C157.267 3.624 157.579 3.024 157.691 2.576C157.803 2.128 157.699 1.88 157.379 1.832C157.283 1.8 157.107 1.8 156.851 1.832C156.611 1.864 156.339 1.912 156.035 1.976C155.747 2.024 155.499 2.08 155.291 2.144C155.083 2.192 154.979 2.232 154.979 2.264C154.979 2.264 154.979 2.288 154.979 2.336C154.979 2.384 154.947 2.4 154.883 2.384C154.851 2.384 154.715 2.448 154.475 2.576C154.235 2.704 153.947 2.872 153.611 3.08C153.275 3.288 152.939 3.496 152.603 3.704C152.267 3.912 151.979 4.096 151.739 4.256C151.515 4.4 151.395 4.488 151.379 4.52C151.347 4.696 151.163 4.856 150.827 5C150.507 5.192 150.211 5.472 149.939 5.84C149.683 6.208 149.395 6.664 149.075 7.208C148.803 7.576 148.611 7.976 148.499 8.408C148.387 8.824 148.387 9.16 148.499 9.416C148.579 9.672 148.827 10 149.243 10.4C149.659 10.8 150.179 11.184 150.803 11.552C151.347 11.856 151.835 12.16 152.267 12.464C152.699 12.752 153.051 13.032 153.323 13.304C153.611 13.576 153.803 13.816 153.899 14.024C154.091 14.296 154.227 14.576 154.307 14.864C154.403 15.136 154.451 15.4 154.451 15.656C154.467 15.912 154.443 16.144 154.379 16.352C154.267 16.608 154.067 16.872 153.779 17.144C153.507 17.416 153.275 17.544 153.083 17.528C152.907 17.576 152.771 17.632 152.675 17.696C152.595 17.76 152.499 17.816 152.387 17.864C152.275 17.928 152.035 17.992 151.667 18.056C151.315 18.12 150.923 18.16 150.491 18.176C150.059 18.208 149.659 18.216 149.291 18.2ZM158.755 16.208C158.563 16.24 158.355 16.208 158.131 16.112C157.907 16.016 157.707 15.88 157.531 15.704C157.371 15.528 157.267 15.344 157.219 15.152C157.155 14.816 157.195 14.4 157.339 13.904C157.499 13.392 157.723 12.856 158.011 12.296C158.315 11.72 158.651 11.168 159.019 10.64C159.403 10.112 159.795 9.656 160.195 9.272C160.611 8.872 160.995 8.6 161.347 8.456C161.523 8.344 161.659 8.272 161.755 8.24C161.867 8.192 161.979 8.184 162.091 8.216C162.219 8.248 162.403 8.328 162.643 8.456C162.867 8.52 163.035 8.592 163.147 8.672C163.259 8.752 163.403 8.912 163.579 9.152C163.707 9.392 163.803 9.632 163.867 9.872C163.931 10.112 163.987 10.384 164.035 10.688C164.163 11.088 164.211 11.352 164.179 11.48C164.147 11.592 164.099 11.68 164.035 11.744C163.907 11.904 163.875 11.984 163.939 11.984C163.939 11.984 163.931 12.016 163.915 12.08C163.915 12.128 163.883 12.208 163.819 12.32C163.707 12.672 163.619 13.04 163.555 13.424C163.507 13.792 163.515 14.096 163.579 14.336C163.707 14.688 163.939 14.896 164.275 14.96C164.611 15.024 164.955 14.88 165.307 14.528C165.483 14.4 165.651 14.288 165.811 14.192C165.971 14.08 166.051 14.088 166.051 14.216C166.051 14.216 166.075 14.24 166.123 14.288C166.171 14.32 166.227 14.336 166.291 14.336C166.371 14.336 166.419 14.368 166.435 14.432C166.467 14.496 166.467 14.584 166.435 14.696C166.419 14.792 166.371 14.904 166.291 15.032C166.051 15.272 165.931 15.432 165.931 15.512C165.931 15.512 165.899 15.544 165.835 15.608C165.787 15.656 165.699 15.736 165.571 15.848C165.283 16.024 164.915 16.112 164.467 16.112C164.035 16.112 163.699 16.024 163.459 15.848C163.219 15.672 162.995 15.432 162.787 15.128C162.595 14.824 162.467 14.56 162.403 14.336L162.283 14.096L161.587 14.552C161.411 14.728 161.219 14.896 161.011 15.056C160.819 15.216 160.691 15.328 160.627 15.392C160.579 15.456 160.523 15.512 160.459 15.56C160.411 15.608 160.355 15.632 160.291 15.632C160.227 15.632 160.171 15.632 160.123 15.632C160.075 15.632 160.051 15.632 160.051 15.632C160.051 15.696 159.971 15.776 159.811 15.872C159.667 15.968 159.491 16.048 159.283 16.112C159.091 16.176 158.915 16.208 158.755 16.208ZM158.515 14.912C158.611 14.912 158.779 14.84 159.019 14.696C159.275 14.536 159.555 14.352 159.859 14.144C160.179 13.936 160.459 13.728 160.699 13.52C160.955 13.312 161.131 13.152 161.227 13.04C161.291 12.976 161.395 12.872 161.539 12.728C161.683 12.568 161.811 12.432 161.923 12.32C162.291 11.904 162.547 11.448 162.691 10.952C162.835 10.44 162.819 10.04 162.643 9.752C162.579 9.576 162.499 9.48 162.403 9.464C162.307 9.448 162.107 9.504 161.803 9.632C161.611 9.744 161.371 9.96 161.083 10.28C160.811 10.584 160.515 10.944 160.195 11.36C159.891 11.76 159.603 12.176 159.331 12.608C159.059 13.04 158.835 13.44 158.659 13.808C158.483 14.176 158.395 14.464 158.395 14.672C158.395 14.736 158.411 14.792 158.443 14.84C158.491 14.888 158.515 14.912 158.515 14.912ZM168.311 16.448C168.231 16.608 168.111 16.656 167.951 16.592C167.807 16.528 167.687 16.464 167.591 16.4C167.479 16.4 167.383 16.368 167.303 16.304C167.223 16.24 167.167 16.144 167.135 16.016C167.103 15.92 167.095 15.808 167.111 15.68C167.127 15.536 167.159 15.376 167.207 15.2C167.271 15.008 167.335 14.8 167.399 14.576C167.527 14.048 167.615 13.664 167.663 13.424C167.711 13.184 167.759 12.976 167.807 12.8C167.855 12.624 167.919 12.368 167.999 12.032C168.127 11.712 168.231 11.4 168.311 11.096C168.391 10.792 168.511 10.488 168.671 10.184C168.783 9.768 168.919 9.376 169.079 9.008C169.255 8.624 169.423 8.304 169.583 8.048C169.615 8 169.671 7.936 169.751 7.856C169.847 7.776 169.927 7.736 169.991 7.736C170.119 7.608 170.231 7.56 170.327 7.592C170.439 7.608 170.575 7.68 170.735 7.808C170.927 8.016 170.999 8.256 170.951 8.528C170.919 8.8 170.727 9.2 170.375 9.728C170.183 10.224 170.007 10.656 169.847 11.024C169.687 11.376 169.575 11.712 169.511 12.032C169.687 11.776 169.879 11.544 170.087 11.336C170.311 11.112 170.495 10.928 170.639 10.784C170.991 10.432 171.279 10.176 171.503 10.016C171.743 9.856 172.023 9.672 172.343 9.464C172.535 9.336 172.719 9.224 172.895 9.128C173.071 9.016 173.263 8.936 173.471 8.888C173.695 8.84 173.935 8.84 174.191 8.888C174.351 8.872 174.479 8.92 174.575 9.032C174.687 9.144 174.775 9.296 174.839 9.488C174.903 9.68 174.943 9.904 174.959 10.16C174.591 10.08 174.263 10.096 173.975 10.208C173.687 10.304 173.439 10.424 173.231 10.568C173.039 10.712 172.887 10.824 172.775 10.904C172.535 11.064 172.231 11.28 171.863 11.552C171.495 11.808 171.127 12.12 170.759 12.488C170.471 12.808 170.223 13.08 170.015 13.304C169.823 13.528 169.663 13.728 169.535 13.904C169.423 14.08 169.335 14.264 169.271 14.456C169.111 14.824 168.943 15.224 168.767 15.656C168.591 16.088 168.439 16.352 168.311 16.448ZM175.927 16.136C175.863 16.008 175.783 15.912 175.687 15.848C175.591 15.768 175.543 15.696 175.543 15.632C175.543 15.568 175.535 15.504 175.519 15.44C175.519 15.36 175.487 15.288 175.423 15.224C175.343 15.128 175.351 14.912 175.447 14.576C175.543 14.224 175.703 13.8 175.927 13.304C176.151 12.792 176.415 12.256 176.719 11.696C176.847 11.568 176.975 11.4 177.103 11.192C177.231 10.984 177.327 10.848 177.391 10.784C177.391 10.72 177.415 10.664 177.463 10.616C177.511 10.552 177.567 10.52 177.631 10.52V10.376C177.631 10.296 177.703 10.16 177.847 9.968C178.007 9.776 178.199 9.568 178.423 9.344C178.647 9.104 178.879 8.88 179.119 8.672C179.359 8.448 179.559 8.288 179.719 8.192C180.055 7.968 180.399 7.832 180.751 7.784C181.119 7.736 181.431 7.816 181.687 8.024C181.735 8.072 181.815 8.152 181.927 8.264C182.039 8.376 182.167 8.504 182.311 8.648C182.471 8.776 182.631 8.912 182.791 9.056L183.679 9.848L183.247 11.048C183.039 11.688 182.983 12.248 183.079 12.728C183.191 13.208 183.351 13.624 183.559 13.976C183.639 14.152 183.799 14.32 184.039 14.48C184.295 14.64 184.535 14.736 184.759 14.768C184.887 14.784 185.007 14.832 185.119 14.912C185.231 14.992 185.287 15.12 185.287 15.296C185.287 15.456 185.255 15.584 185.191 15.68C185.127 15.776 185.015 15.84 184.855 15.872C184.327 15.936 183.831 15.808 183.367 15.488C182.919 15.168 182.503 14.64 182.119 13.904C182.055 13.808 181.967 13.632 181.855 13.376C181.759 13.104 181.703 12.928 181.687 12.848C181.623 12.928 181.503 13.08 181.327 13.304C181.151 13.512 181.015 13.664 180.919 13.76C179.783 14.912 178.799 15.688 177.967 16.088C177.151 16.472 176.471 16.488 175.927 16.136ZM176.791 14.792C176.791 14.904 176.959 14.904 177.295 14.792C177.647 14.664 178.023 14.44 178.423 14.12C178.967 13.656 179.511 13.144 180.055 12.584C180.615 12.024 181.063 11.504 181.399 11.024L181.927 10.16C181.767 9.792 181.591 9.544 181.399 9.416C181.223 9.272 181.071 9.2 180.943 9.2C180.735 9.2 180.423 9.392 180.007 9.776C179.607 10.16 179.175 10.672 178.711 11.312C178.247 11.952 177.807 12.656 177.391 13.424C177.231 13.744 177.087 14.056 176.959 14.36C176.847 14.648 176.791 14.792 176.791 14.792ZM187.1 15.704C186.988 15.72 186.868 15.72 186.74 15.704C186.628 15.672 186.516 15.616 186.404 15.536C186.276 15.408 186.188 15.312 186.14 15.248C186.092 15.168 186.076 15.048 186.092 14.888C186.124 14.728 186.18 14.48 186.26 14.144C186.34 13.888 186.436 13.536 186.548 13.088C186.66 12.624 186.78 12.168 186.908 11.72C186.956 11.464 187.02 11.2 187.1 10.928C187.196 10.656 187.292 10.408 187.388 10.184C187.484 9.944 187.556 9.76 187.604 9.632C187.732 9.184 187.852 8.792 187.964 8.456C188.092 8.12 188.244 7.736 188.42 7.304C188.596 6.856 188.812 6.264 189.068 5.528C189.42 4.568 189.684 3.84 189.86 3.344C190.052 2.832 190.188 2.464 190.268 2.24C190.364 2 190.428 1.816 190.46 1.688C190.46 1.56 190.492 1.464 190.556 1.4C190.636 1.336 190.732 1.304 190.844 1.304C191.068 1.304 191.244 1.416 191.372 1.64C191.516 1.848 191.604 2.104 191.636 2.408C191.668 2.696 191.62 2.968 191.492 3.224C191.236 3.8 190.964 4.488 190.676 5.288C190.388 6.072 190.108 6.848 189.836 7.616C189.564 8.368 189.308 9.008 189.068 9.536C189.068 9.6 189.044 9.712 188.996 9.872C188.948 10.032 188.892 10.176 188.828 10.304C188.764 10.432 188.7 10.552 188.636 10.664C188.588 10.776 188.564 10.832 188.564 10.832C188.564 10.896 188.54 11.016 188.492 11.192C188.444 11.368 188.38 11.584 188.3 11.84C188.236 12.032 188.156 12.28 188.06 12.584C187.98 12.888 187.924 13.144 187.892 13.352C187.972 13.208 188.14 12.992 188.396 12.704C188.652 12.416 188.892 12.168 189.116 11.96C189.372 11.736 189.66 11.488 189.98 11.216C190.3 10.944 190.556 10.744 190.748 10.616C190.94 10.488 191.108 10.376 191.252 10.28C191.412 10.168 191.492 10.112 191.492 10.112C191.492 10.048 191.516 10.016 191.564 10.016C191.628 10 191.692 9.992 191.756 9.992C191.82 9.992 191.852 9.984 191.852 9.968C191.868 9.952 191.876 9.912 191.876 9.848C191.876 9.768 191.964 9.696 192.14 9.632C192.332 9.568 192.548 9.52 192.788 9.488C193.044 9.44 193.252 9.416 193.412 9.416C193.604 9.416 193.756 9.456 193.868 9.536C193.98 9.616 194.124 9.792 194.3 10.064C194.492 10.32 194.612 10.632 194.66 11C194.724 11.352 194.692 11.72 194.564 12.104C194.564 12.232 194.54 12.416 194.492 12.656C194.46 12.88 194.444 13.12 194.444 13.376L194.3 14.144H194.684C194.812 14.144 194.932 14.168 195.044 14.216C195.156 14.248 195.212 14.264 195.212 14.264C195.276 14.328 195.34 14.392 195.404 14.456C195.468 14.504 195.532 14.528 195.596 14.528C195.788 14.528 195.86 14.608 195.812 14.768C195.764 14.912 195.644 15.048 195.452 15.176C195.068 15.432 194.716 15.56 194.396 15.56C194.092 15.56 193.812 15.432 193.556 15.176C193.3 14.904 193.14 14.6 193.076 14.264C193.012 13.928 193.044 13.504 193.172 12.992C193.236 12.288 193.268 11.776 193.268 11.456C193.284 11.12 193.204 10.952 193.028 10.952C192.868 10.952 192.588 11.064 192.188 11.288C191.788 11.496 191.34 11.784 190.844 12.152C190.348 12.52 189.86 12.928 189.38 13.376C188.9 13.824 188.5 14.288 188.18 14.768C187.988 15.008 187.804 15.224 187.628 15.416C187.452 15.592 187.276 15.688 187.1 15.704Z"
        fill={color}
      />
    </svg>
  );
}

export const AudioWaveTimeline = forwardRef(
  ({ color, className, width, height, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        ref={ref}
        className={`${className} fx--no-shrink`}
        viewBox="0 0 302 77"
        {...props}
        fill="none"
      >
        <path
          d="M1.99988 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M11.1132 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M20.2266 19.2927V57.2593"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M29.34 9.08472V67.4772"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M38.4534 22.5972V53.9551"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M47.5668 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M56.6714 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M65.7825 19.2927V57.2593"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M74.8959 9.08472V67.4772"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />

        <path
          d="M83.7166 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M93 20.9595V55.5931"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M102 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M111 59.2212V17.3408"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M120 2V74.5621"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M129 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M138 20.9595V55.5931"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M147 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M156 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M165 19.2927V57.2593"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M174 9.08447V67.477"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M183 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M192 6.42773V70.1243"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M201 14.5696V61.9826"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M210 28V48.9973"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M219 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M228 22.5972V53.9551"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M237 13.5034V63.0494"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M246 17.3408V59.2212"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M255 9.08447V67.477"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M264 20.9595V55.5931"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M273 17.3408V59.2212"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M282 20.9595V55.5931"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M291 27.7776V48.7749"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M300 27.3594V48.3567"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <style jsx>{`
          .tc-fill {
            stroke: #ffffff;
          }
          @media (max-width: 1200px) {
            .audioWaveLine {
              width: 246px;
              height: 60px;
            }
          }
        `}</style>
      </svg>
    );
  }
);

export function RoundedTickIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fx--no-shrink`}
      {...props}
    >
      <g xmlns="http://www.w3.org/2000/svg" id="icon/tick_round copy 5">
        <path
          id="Mask"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 11V10.1C22 9.5 21.6 9.1 21 9.1C20.4 9.1 20 9.5 20 10.1V11C20 16 16 20 11 20C6 20 2 16 2 11C2 6 6 2 11 2C12.3 2 13.5 2.3 14.7 2.8C15.2 3 15.8 2.8 16 2.3C16.2 1.8 16 1.2 15.5 1C14.1 0.3 12.5 0 11 0C4.9 0 0 4.9 0 11C0 17.1 4.9 22 11 22C17.1 22 22 17.1 22 11ZM20.3276 2.30248C20.7109 1.90178 21.2858 1.90178 21.6691 2.30248C22.0523 2.70317 22.0523 3.30422 21.6691 3.70491L11.129 14.7241C10.9374 14.9244 10.6499 15.0246 10.4583 15.0246C10.2667 15.0246 9.9792 14.9244 9.78756 14.7241L6.91301 11.7188C6.52973 11.3181 6.52973 10.7171 6.91301 10.3164C7.29628 9.9157 7.87119 9.9157 8.25447 10.3164L10.4583 12.6204L20.3276 2.30248Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export function MiniPlayBtnIcon({ color, className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 13 16"
      fill="none"
    >
      <path
        d="M0 14.6525C0 15.3697 1.08067 15.7614 1.7925 15.3023L12.1068 8.64978C12.6311 8.31165 12.6311 7.68835 12.1068 7.35022L1.7925 0.697654C1.08067 0.238572 0 0.630324 0 1.34747V14.6525Z"
        fill={color}
      />
    </svg>
  );
}

export function ClockBadgeIcon({ className, width, height, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7 1.75C9.89949 1.75 12.25 4.1005 12.25 7C12.25 9.89949 9.89949 12.25 7 12.25C4.1005 12.25 1.75 9.89949 1.75 7C1.75 4.1005 4.1005 1.75 7 1.75"
        stroke="white"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.29175 4.08337V7.29171H4.66675"
        stroke="white"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 11 20"
      fill="none"
    >
      <path
        d="M8.29733 18.6808L0.812617 10.6903C0.649016 10.4811 0.526316 10.2301 0.526316 9.97908C0.526316 9.72807 0.649016 9.47706 0.812617 9.30972L8.29733 1.3192C8.66543 0.900848 9.31983 0.900848 9.68793 1.27736C10.0969 1.65388 10.0969 2.28141 9.72884 2.69976L2.85762 10.0209L9.72884 17.3002C10.0969 17.6768 10.0969 18.3461 9.68793 18.7226C9.31983 19.0992 8.66543 19.0992 8.29733 18.6808Z"
        fill={color}
        stroke={color}
        strokeWidth="0.4"
      />
    </svg>
  );
}

export function ClockIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 82 82"
      fill="none"
    >
      <line
        x1="23.3558"
        y1="25.6925"
        x2="24.8531"
        y2="26.9177"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <line
        x1="27.4144"
        y1="56.9067"
        x2="26.108"
        y2="58.3337"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <line
        x1="20.6"
        y1="42.4"
        x2="18.4"
        y2="42.4"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <circle cx="41" cy="41" r="30" stroke="#3270D8" strokeWidth="2.8" />
      <path
        d="M47.0002 64.5C57.9875 62.1836 65.2652 52.6765 65.2652 41C65.2652 27.5986 54.4012 16.7347 40.9999 16.7347C27.5985 16.7347 16.7346 27.5986 16.7346 41C16.7346 54.4013 27.5985 65.2653 40.9999 65.2653C41.3626 65.2653 41.6414 65.281 42.0002 65.2653"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <line
        x1="41.4"
        y1="18.4"
        x2="41.4"
        y2="20.6"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <line
        x1="58.8226"
        y1="26.6749"
        x2="57.5162"
        y2="28.1019"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        d="M42 62V65"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        d="M56.6971 55L58.9998 57"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <line
        x1="63.6"
        y1="43.4"
        x2="62.4"
        y2="43.4"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        d="M40.9999 29.7551V43.3673H52.8366"
        stroke="#FD8B1F"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CustomScriptIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37 40C37 40.5523 37.4477 41 38 41H62C62.5523 41 63 40.5523 63 40V27C63 26.4477 62.5523 26 62 26H38C37.4477 26 37 26.4477 37 27V40Z"
        stroke="#FD8B1F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M37 48.7719H62.2091"
        stroke="#FD8B1F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M37 56.3344H55.9068"
        stroke="#FD8B1F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M20.5627 68.9392H63.4183C65.3755 68.9392 67.1593 68.1952 68.5024 66.9747C70.025 65.5912 70.981 63.5952 70.981 61.3765V18C70.981 16.8954 70.0856 16 68.981 16H30.1255C29.0209 16 28.1255 16.8954 28.1255 18V61.3765C28.1255 65.5524 24.7386 68.9392 20.5627 68.9392ZM20.5627 68.9392C16.3868 68.9392 13 65.5524 13 61.3765V42.4696C13 40.381 14.6928 38.6882 16.7814 38.6882C18.87 38.6882 20.5627 40.381 20.5627 42.4696V58.8556"
        stroke="#3270D8"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function QualifyLeadIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        d="M33.248 59.4666H27.436H10.0001V51.3298C10.0001 44.91 15.2043 39.7058 21.624 39.7058C28.0438 39.7058 33.248 44.91 33.248 51.3298V59.4666Z"
        fill="#EDF4FC"
      />
      <path
        d="M27.436 59.4666H33.248M33.248 59.4666V51.3298C33.248 44.91 28.0438 39.7058 21.624 39.7058C15.2043 39.7058 10.0001 44.91 10.0001 51.3298V59.4666H33.248Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.337 28.0818C26.1637 28.0833 27.9717 27.7139 29.6514 26.9961C29.2094 23.5582 26.6253 20.7845 23.2272 20.1006C19.8292 19.4167 16.3732 20.9747 14.6356 23.9739C17.1799 26.6001 20.6804 28.0823 24.337 28.0818V28.0818Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="21.6245"
        cy="28.0818"
        r="8.13678"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.9378 67.9999H53.7033H29V56.4716C29 47.3761 36.3734 40.0027 45.4689 40.0027C54.5644 40.0027 61.9378 47.3761 61.9378 56.4716V67.9999Z"
        fill="#EDF4FC"
      />
      <path
        d="M53.7033 67.9999H61.9378M61.9378 67.9999V56.4716C61.9378 47.3761 54.5644 40.0027 45.4689 40.0027C36.3734 40.0027 29 47.3761 29 56.4716V67.9999H61.9378Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.3131 23.5337C51.9012 23.5358 54.4628 23.0125 56.8426 21.9955C56.2163 17.1247 52.5551 13.1949 47.7408 12.2259C42.9264 11.2569 38.03 13.4643 35.5681 17.7136C39.1729 21.4344 44.1324 23.5344 49.3131 23.5337V23.5337Z"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="45.4691"
        cy="23.5338"
        r="11.5282"
        stroke="#3270D8"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="63.5"
        cy="49.5"
        r="10.9"
        fill="#EDF4FC"
        stroke="#FD8B1F"
        strokeWidth="2.8"
      />
      <path
        d="M58.7664 50.3048L61.8515 53.3564L69.0585 46.4292"
        stroke="#FD8B1F"
        strokeWidth="2.8"
        strokeLinecap="square"
      />
    </svg>
  );
}

export function ChevronArrowIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 14 8"
      fill={color}
    >
      <path d="M0.30324 5.97931L6.34423 0.755702C6.54295 0.573058 6.78141 0.5 6.98013 0.5C7.21859 0.5 7.45705 0.573058 7.65577 0.719172L13.6968 5.97931C14.0942 6.30807 14.0942 6.856 13.7365 7.22129C13.3788 7.58658 12.7827 7.58658 12.3852 7.25782L6.98013 2.58214L1.61477 7.25782C1.21734 7.58658 0.621187 7.58658 0.263496 7.22129C-0.0941944 6.856 -0.0941944 6.30807 0.30324 5.97931Z" />
    </svg>
  );
}

export function AestheticBg1({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 317 267"
      fill={color}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M174.043 202.39L316.647 109.794L228.525 574.705L85.5834 667.58L173.698 202.614L173.725 202.597L-285.178 93.0533L-142.284 0.208135L316.619 109.752L269.574 140.319L174.043 202.39Z"
        fill={color}
      />
    </svg>
  );
}

export function AestheticBg2({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 184 230"
      fill={color}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.618 238.217L0.044633 162.447L140.645 614.174L293.246 690.014L152.646 238.231L152.618 238.217ZM443.45 0.848554L0.0671053 162.402L50.2916 187.363L152.618 238.217L596 76.6635L443.45 0.848554Z"
        fill={color}
      />
    </svg>
  );
}

export function AestheticBg3({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 375 408"
      fill={color}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M287.042 216.165L283.123 0.825969L-140.988 420.796L-137.13 636.269L287.044 216.268L287.044 216.228L725.982 620.816L722.125 405.413L283.187 0.825144L284.457 71.7427L287.042 216.165Z"
        fill={color}
      />
    </svg>
  );
}

export function AestheticBg4({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 253 324"
      fill="none"
    >
      <path
        opacity="0.08"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.921 168.285L0.358076 91.2988L73.6605 478.025L192.563 555.281L119.267 168.509L119.244 168.495L500.973 77.3734L382.11 0.142192L0.380809 91.2636L39.5145 116.691L118.921 168.285Z"
        fill={color}
      />
    </svg>
  );
}

export function AestheticBg5({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      {...props}
      viewBox="0 0 459 434"
      fill="none"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.957 202.902L0.353496 110.306L88.4755 575.217L231.417 668.092L143.302 203.126L143.275 203.109L602.178 93.5652L459.284 0.720098L0.380856 110.264L47.4263 140.831L142.957 202.902Z"
        fill={color}
      />
    </svg>
  );
}

export function PlansTickIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      viewBox="0 0 16 12"
      {...props}
      fill="none"
    >
      <path
        d="M15 1L5.14223 11L1 6.798"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CircleInfoIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      viewBox="0 0 13 14"
      {...props}
      fill="none"
    >
      <path
        d="M6.49868 4.33464C6.40668 4.33464 6.33202 4.4093 6.33268 4.5013C6.33268 4.5933 6.40735 4.66797 6.49935 4.66797C6.59135 4.66797 6.66602 4.5933 6.66602 4.5013C6.66602 4.4093 6.59135 4.33464 6.49868 4.33464"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 13V13C3.186 13 0.5 10.314 0.5 7V7C0.5 3.686 3.186 1 6.5 1V1C9.814 1 12.5 3.686 12.5 7V7C12.5 10.314 9.814 13 6.5 13Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50033 7V10.3333"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AgentOnCallIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M21.2108 25.9006C15.2023 25.9036 8.86939 26.0868 2.86375 25.9006C2.14127 25.8781 2.65652 22.8298 7.45485 21.8778C9.47748 21.4765 9.53634 20.8937 9.40874 18.8838"
        stroke={color}
      />
      <path
        d="M3.08984 25.9006C9.09836 25.9036 15.4313 26.0868 21.4369 25.9006C22.1594 25.8781 21.6441 22.8298 16.8458 21.8778C14.8232 21.4765 14.7643 20.8937 14.8919 18.8838"
        stroke={color}
      />
      <path
        d="M15.0767 18.3086C15.1486 18.3086 16.9415 17.8529 17.047 16.4248"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M10.1302 19.4437C9.46866 18.9615 8.99276 18.5555 8.70254 18.2256C8.52038 18.0186 8.30094 17.716 8.04422 17.3179C7.72024 16.8155 7.54793 16.2304 7.54793 15.6326V11.9258C7.54793 10.5499 7.43957 9.022 8.33638 7.84908C9.33922 6.53747 10.6754 5.87782 12.3448 5.87012"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M17.0367 11.9258C17.0367 10.5499 17.1438 9.022 16.2572 7.84908C15.2658 6.53747 13.9449 5.87782 12.2944 5.87012"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6775 12.0898C18.8582 12.0898 19.0219 12.1631 19.1404 12.2816C19.2588 12.4001 19.3321 12.5637 19.3321 12.7445V15.6905C19.3321 15.8713 19.2588 16.035 19.1404 16.1535C19.0219 16.2719 18.8582 16.3452 18.6775 16.3452H17.0408V12.0898H18.6775Z"
        stroke={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5477 12.0898V16.3452H5.91102C5.73024 16.3452 5.56657 16.2719 5.4481 16.1535C5.32962 16.035 5.25635 15.8713 5.25635 15.6905V12.7445C5.25635 12.5637 5.32962 12.4001 5.4481 12.2816C5.56657 12.1631 5.73024 12.0898 5.91102 12.0898H7.5477Z"
        stroke={color}
      />
      <path
        d="M7.68042 11.4408C11.7765 11.7641 12.345 6.36442 17.0095 10.3151"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M14.0945 17.3271H13.2762C12.7338 17.3271 12.2942 17.7668 12.2942 18.3092C12.2942 18.8515 12.7338 19.2912 13.2762 19.2912H14.0945C14.6369 19.2912 15.0765 18.8515 15.0765 18.3092C15.0765 17.7668 14.6369 17.3271 14.0945 17.3271Z"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M8.8573 21.582L12.2943 26.0011"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M15.4039 21.582L11.9669 26.0011"
        stroke={color}
        strokeLinecap="round"
      />
      <line
        x1="23.2249"
        y1="8.40723"
        x2="26.4019"
        y2="8.40723"
        stroke="#FD8B1F"
        strokeLinecap="round"
      />
      <line
        x1="23.2249"
        y1="10.3057"
        x2="26.4019"
        y2="10.3057"
        stroke="#FD8B1F"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3451 5.37598C21.4433 5.37598 20.7123 6.10703 20.7123 7.00884V7.49267L20.1377 7.95229L20.1377 7.95221L20.1301 7.95853L19.0658 8.84545C18.7807 9.08303 18.7953 9.52542 19.0954 9.74369L20.7123 10.9196V11.9454C20.7123 12.8472 21.4433 13.5783 22.3451 13.5783H27.6614C28.5632 13.5783 29.2943 12.8472 29.2943 11.9454V7.00884C29.2943 6.10703 28.5632 5.37598 27.6614 5.37598H22.3451ZM21.6715 10.4265H21.6996V11.9454C21.6996 12.3019 21.9886 12.5909 22.3451 12.5909H27.6614C28.018 12.5909 28.307 12.3019 28.307 11.9454V7.00884C28.307 6.65231 28.018 6.36329 27.6614 6.36329H22.3451C21.9886 6.36329 21.6996 6.65231 21.6996 7.00884V7.95818H21.6994L21.7039 7.96378L20.7584 8.72017L20.1098 9.26063L21.6858 10.4068L21.6715 10.4265Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function LiveChatIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M21.0064 20.1628L21.3187 19.7724C21.23 19.7015 21.1199 19.6628 21.0064 19.6628V20.1628ZM25.5521 23.7993L25.2397 24.1897C25.3898 24.3098 25.5954 24.3332 25.7687 24.2499C25.9419 24.1667 26.0521 23.9915 26.0521 23.7993H25.5521ZM25.5521 9.25391H26.0521C26.0521 8.97776 25.8282 8.75391 25.5521 8.75391V9.25391ZM19.1885 8.75391C18.9124 8.75391 18.6885 8.97776 18.6885 9.25391C18.6885 9.53005 18.9124 9.75391 19.1885 9.75391V8.75391ZM11.5513 17.0589C11.5048 16.7868 11.2464 16.6038 10.9742 16.6503C10.702 16.6968 10.5191 16.9552 10.5656 17.2274L11.5513 17.0589ZM14.6428 20.6628H21.0064V19.6628H14.6428V20.6628ZM20.694 20.5533L25.2397 24.1897L25.8644 23.4088L21.3187 19.7724L20.694 20.5533ZM26.0521 23.7993V9.25391H25.0521V23.7993H26.0521ZM25.5521 8.75391H19.1885V9.75391H25.5521V8.75391ZM10.5656 17.2274C10.899 19.178 12.5974 20.6628 14.6428 20.6628V19.6628C13.0929 19.6628 11.804 18.5374 11.5513 17.0589L10.5656 17.2274Z"
        fill="#FD8B1F"
      />
      <path
        d="M19.1885 6.07129H19.6885C19.6885 5.79515 19.4647 5.57129 19.1885 5.57129V6.07129ZM4.64282 6.07129V5.57129C4.36668 5.57129 4.14282 5.79515 4.14282 6.07129H4.64282ZM4.64282 20.617H4.14282C4.14282 20.8092 4.253 20.9844 4.42623 21.0677C4.59947 21.1509 4.8051 21.1275 4.95518 21.0074L4.64282 20.617ZM9.18854 16.9802V16.4802C9.075 16.4802 8.96484 16.5189 8.87618 16.5898L9.18854 16.9802ZM19.1885 5.57129H4.64282V6.57129H19.1885V5.57129ZM4.14282 6.07129V20.617H5.14282V6.07129H4.14282ZM4.95518 21.0074L9.5009 17.3706L8.87618 16.5898L4.33046 20.2266L4.95518 21.0074ZM9.18854 17.4802H15.5521V16.4802H9.18854V17.4802ZM15.5521 17.4802C17.8365 17.4802 19.6885 15.6281 19.6885 13.3438H18.6885C18.6885 15.0759 17.2842 16.4802 15.5521 16.4802V17.4802ZM19.6885 13.3438V6.07129H18.6885V13.3438H19.6885Z"
        fill={color}
      />
    </svg>
  );
}

export function LiveCallTransfer({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0418 13.3565C10.9839 13.2639 10.9721 13.1496 11.0094 13.0469L11.6072 11.3982C11.7784 10.9943 11.8246 10.5479 11.7393 10.1172L10.739 6.1617C10.6942 5.98445 10.5227 5.86968 10.3418 5.89578L5.68291 6.5679C5.49887 6.59445 5.36564 6.7578 5.38017 6.94318C5.72973 11.4011 7.59264 15.7604 10.9681 19.1704C14.4004 22.6372 18.896 24.4662 23.391 24.7704C23.5806 24.7832 23.7447 24.6421 23.7641 24.453L24.2657 19.5547C24.284 19.3759 24.1667 19.2114 23.9918 19.1705L20.333 18.3148C19.8809 18.223 19.4119 18.2798 18.9944 18.4766L17.1856 19.2567C17.0767 19.3037 16.9514 19.2935 16.8517 19.2292C15.6737 18.4683 14.6897 17.7521 13.6021 16.6534C12.5088 15.549 11.8103 14.5872 11.0418 13.3565Z"
        stroke={color}
      />
      <path
        d="M17.1252 8.06358L24.2861 8.06358L21.9467 5.35693"
        stroke="#FD8B1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3042 10.714L17.1433 10.714L19.4828 13.4207"
        stroke="#FD8B1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ServiceFusionIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5527 15.4116L15.5549 15.4095L13.6607 14.7305C11.8269 15.0548 9.9468 15.3431 8.37956 15.5335L10.0971 16.1342C9.51502 16.459 9.16889 17.0964 9.27577 17.7685C9.40345 18.5686 10.13 19.1429 10.958 19.1429C11.0429 19.1429 11.1284 19.1375 11.2142 19.1249C12.0541 19.0044 14.4113 18.6524 15.2459 18.5055C16.1711 18.3428 16.7824 17.4997 16.6106 16.6226C16.4999 16.0511 16.0836 15.6084 15.5527 15.4116ZM17.8003 10.1569L16.8737 10.0412L16.1413 9.95047L14.9567 9.80225C12.3046 10.3951 9.61455 10.8371 6.90675 11.124L8.28982 11.2932L9.25089 11.4108L10.1775 11.5244C9.1487 11.6796 8.17009 11.8114 7.32508 11.9048C6.39114 12.008 5.72153 12.8104 5.83045 13.697C5.90775 14.3309 6.3634 14.8352 6.95856 15.0333C7.13519 15.0931 7.32447 15.1262 7.52007 15.1262C7.58574 15.1262 7.65244 15.1227 7.71954 15.116C9.15441 14.9571 10.9346 14.6966 12.7207 14.3938C14.6493 14.0678 16.5839 13.6914 18.0981 13.3389C19.0119 13.126 19.5711 12.2512 19.347 11.3845C19.1651 10.6813 18.5232 10.2005 17.8003 10.1569ZM20.9454 5.98274C20.7148 5.29581 20.0441 4.85715 19.3227 4.85715C19.1514 4.85715 18.9768 4.88211 18.8051 4.93416C14.1362 6.34536 9.31126 7.24301 4.42597 7.61027C3.48856 7.6809 2.78816 8.45955 2.8626 9.34907C2.93358 10.1951 3.67988 10.8379 4.55916 10.8379C4.56038 10.8379 4.5612 10.8371 4.56181 10.8371C4.60648 10.8371 4.65114 10.8359 4.69561 10.8324C7.64795 10.6105 10.5797 10.2034 13.4715 9.61649C15.6184 9.1815 17.7441 8.64666 19.8391 8.01353C20.7358 7.74243 21.231 6.83356 20.9454 5.98274Z"
        fill={color}
      />
    </svg>
  );
}

export function WorkizIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <rect
        x="2.28577"
        y="2.28571"
        width="19.4286"
        height="19.4286"
        fill={color}
      />
      <path
        d="M6.57153 9.06919C6.57153 8.86829 6.64938 8.68749 6.80507 8.52678C6.96076 8.36606 7.15663 8.28571 7.39268 8.28571C7.57349 8.28571 7.73671 8.33844 7.88236 8.44391C8.03303 8.54938 8.13096 8.68498 8.17616 8.85072L9.59246 13.7475L11.167 8.93358C11.2272 8.73771 11.3402 8.58202 11.506 8.46651C11.6767 8.34597 11.8726 8.28571 12.0936 8.28571C12.2945 8.28571 12.4753 8.34597 12.636 8.46651C12.8017 8.58704 12.9197 8.74274 12.9901 8.93358L14.5646 13.7475L15.9809 8.85072C16.0261 8.68498 16.124 8.54938 16.2747 8.44391C16.4253 8.33844 16.5911 8.28571 16.7719 8.28571C17.0029 8.28571 17.1963 8.36355 17.3519 8.51924C17.5076 8.67494 17.5855 8.85825 17.5855 9.06919C17.5855 9.14954 17.5704 9.22739 17.5403 9.30273L15.7398 15.1336C15.6745 15.3596 15.5389 15.548 15.333 15.6987C15.1321 15.8443 14.9111 15.9171 14.67 15.9171H14.6399C14.3938 15.9171 14.1728 15.8443 13.9769 15.6987C13.7811 15.553 13.648 15.3647 13.5777 15.1336L12.0785 10.3951L10.5793 15.1336C10.509 15.3647 10.3734 15.553 10.1725 15.6987C9.97164 15.8443 9.74815 15.9171 9.50206 15.9171H9.47192C9.23587 15.9171 9.0174 15.8443 8.81651 15.6987C8.62064 15.553 8.49006 15.3647 8.42477 15.1336L6.60167 9.30273C6.58158 9.20228 6.57153 9.12443 6.57153 9.06919Z"
        fill="#3B4C53"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2599 8.83977L14.5477 12.7771L15.7058 8.7733C15.7701 8.53947 15.9102 8.35024 16.1108 8.20985C16.3086 8.07138 16.5313 8 16.7718 8C17.0745 8 17.3418 8.10508 17.5539 8.31722C17.7606 8.52388 17.8711 8.77886 17.8711 9.0692C17.8711 9.18206 17.8506 9.29191 17.8101 9.3971L16.0134 15.2157C15.9288 15.5064 15.7532 15.7452 15.5016 15.9292L15.5006 15.93C15.2525 16.1099 14.9731 16.2028 14.67 16.2028H14.6398C14.3329 16.2028 14.052 16.1106 13.8064 15.9279C13.5625 15.7466 13.3932 15.5078 13.3048 15.2184L12.0785 11.3423L10.8521 15.2184C10.763 15.51 10.5895 15.7492 10.3402 15.93C10.091 16.1107 9.80887 16.2028 9.50201 16.2028H9.47187C9.17238 16.2028 8.89576 16.1091 8.64875 15.93L8.64596 15.928C8.40154 15.7462 8.23405 15.5063 8.15091 15.2154L6.32441 9.37358L6.32145 9.35877C6.30023 9.25265 6.28577 9.1529 6.28577 9.0692C6.28577 8.78538 6.39889 8.53539 6.59981 8.32799C6.81253 8.1084 7.08398 8 7.39263 8C7.6325 8 7.85379 8.07108 8.04802 8.21116C8.24756 8.35141 8.38699 8.54018 8.45113 8.77326L9.60918 12.7771L10.8946 8.84701C10.9735 8.59257 11.1241 8.38461 11.3418 8.23261C11.5635 8.07637 11.8174 8 12.0935 8C12.3555 8 12.5959 8.07989 12.8057 8.23669C13.0159 8.39004 13.1683 8.59118 13.2581 8.83482L13.2599 8.83977ZM11.1669 8.93359L9.59241 13.7475L8.17611 8.85073C8.13091 8.68499 8.03298 8.54939 7.88231 8.44392C7.73666 8.33845 7.57343 8.28571 7.39263 8.28571C7.15658 8.28571 6.96071 8.36607 6.80502 8.52679C6.64933 8.6875 6.57148 8.8683 6.57148 9.0692C6.57148 9.12444 6.58153 9.20229 6.60161 9.30273L8.42472 15.1336C8.49001 15.3647 8.62059 15.553 8.81646 15.6987C9.01735 15.8443 9.23582 15.9171 9.47187 15.9171H9.50201C9.7481 15.9171 9.97159 15.8443 10.1725 15.6987C10.3734 15.553 10.509 15.3647 10.5793 15.1336L12.0785 10.3951L13.5776 15.1336C13.6479 15.3647 13.781 15.553 13.9769 15.6987C14.1728 15.8443 14.3937 15.9171 14.6398 15.9171H14.67C14.911 15.9171 15.132 15.8443 15.3329 15.6987C15.5388 15.548 15.6744 15.3597 15.7397 15.1336L17.5402 9.30273C17.5704 9.2274 17.5854 9.14955 17.5854 9.0692C17.5854 8.85826 17.5076 8.67494 17.3519 8.51925C17.1962 8.36356 17.0028 8.28571 16.7718 8.28571C16.591 8.28571 16.4253 8.33845 16.2746 8.44392C16.1239 8.54939 16.026 8.68499 15.9808 8.85073L14.5645 13.7475L12.99 8.93359C12.9197 8.74275 12.8017 8.58705 12.6359 8.46652C12.4752 8.34598 12.2944 8.28571 12.0935 8.28571C11.8725 8.28571 11.6767 8.34598 11.5059 8.46652C11.3402 8.58203 11.2272 8.73772 11.1669 8.93359Z"
        fill="#3B4C53"
      />
    </svg>
  );
}

export function QuickbooksIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M10.0001 19.7143C15.3651 19.7143 19.7143 15.3651 19.7143 10C19.7143 4.63495 15.3651 0.285721 10.0001 0.285721C4.635 0.285721 0.285767 4.63495 0.285767 10C0.285767 15.3651 4.635 19.7143 10.0001 19.7143Z"
        fill={color}
      />
      <path
        d="M2.98413 10C2.98413 12.094 4.66794 13.7778 6.76191 13.7778H7.30159V12.3746H6.76191C5.44508 12.3746 4.38731 11.3168 4.38731 10C4.38731 8.68317 5.44508 7.6254 6.76191 7.6254H8.05715V14.9651C8.05715 15.7422 8.68318 16.3683 9.46032 16.3683V6.22222H6.76191C4.66794 6.22222 2.98413 7.90603 2.98413 10ZM13.2381 6.22222H12.6984V7.6254H13.2381C14.5549 7.6254 15.6127 8.68317 15.6127 10C15.6127 11.3168 14.5549 12.3746 13.2381 12.3746H11.9429V5.03492C11.9429 4.25778 11.3168 3.63174 10.5397 3.63174V13.7778H13.2381C15.3321 13.7778 17.0159 12.094 17.0159 10C17.0159 7.90603 15.3321 6.22222 13.2381 6.22222Z"
        fill="white"
      />
    </svg>
  );
}

export function ZapierIntegrationIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <rect
        x="2.28577"
        y="2.28572"
        width="19.4286"
        height="19.4286"
        rx="2.999"
        fill="#FF4F00"
      />
      <path
        d="M15.8322 13.5843C16.079 13.7228 16.3587 13.7917 16.6416 13.7838C16.872 13.7912 17.1017 13.7541 17.318 13.6743C17.4812 13.6154 17.6265 13.5158 17.7403 13.3849C17.8476 13.2591 17.9251 13.1108 17.9671 12.9509L17.2281 12.7437C17.1923 12.8463 17.1271 12.9361 17.0404 13.0017C16.9276 13.0843 16.7887 13.1231 16.6494 13.1112C16.5513 13.1188 16.4529 13.1033 16.3619 13.0659C16.2709 13.0286 16.1899 12.9704 16.1254 12.8961C16.0217 12.7423 15.9646 12.5617 15.9612 12.3761H17.9828C17.9861 12.3175 17.9861 12.2587 17.9828 12.2001V12.0437C17.987 11.7959 17.9362 11.5502 17.8342 11.3243C17.7351 11.12 17.5789 10.9489 17.3845 10.8316C17.1517 10.7067 16.8899 10.646 16.6259 10.6557C16.4216 10.6419 16.2166 10.6694 16.0231 10.7366C15.8296 10.8037 15.6517 10.9092 15.4998 11.0467C15.225 11.3567 15.0843 11.7631 15.1088 12.1767C15.1027 12.4675 15.1657 12.7556 15.2926 13.0174C15.4103 13.2571 15.5986 13.455 15.8322 13.5843ZM16.6142 11.3008C17.0052 11.3008 17.1851 11.512 17.2125 11.9382H15.9612C15.9728 11.7862 16.0255 11.6402 16.1137 11.5159C16.1763 11.442 16.2562 11.3848 16.3462 11.3493C16.4363 11.3139 16.5337 11.3012 16.6298 11.3125L16.6142 11.3008Z"
        fill={color}
      />
      <path
        d="M8.29658 12.0211C7.99398 11.993 7.69203 12.0811 7.452 12.2674C7.36639 12.3502 7.29917 12.4501 7.25471 12.5606C7.21025 12.6711 7.18953 12.7897 7.19392 12.9087C7.18464 13.0301 7.20387 13.152 7.25003 13.2647C7.29619 13.3774 7.36801 13.4778 7.45981 13.5578C7.66077 13.7091 7.90846 13.7852 8.15974 13.7728C8.28545 13.7767 8.41053 13.7536 8.52655 13.705C8.64257 13.6565 8.7468 13.5836 8.83227 13.4913C8.92596 13.3868 9.00012 13.2662 9.05123 13.1355H9.10207L9.19202 13.7103H9.91538V11.8686C9.9366 11.5476 9.82974 11.2312 9.61821 10.9888C9.48436 10.8741 9.32892 10.7874 9.16104 10.7337C8.99316 10.6799 8.81624 10.6603 8.64067 10.676C8.41449 10.67 8.18913 10.7058 7.97595 10.7816C7.80735 10.8419 7.65857 10.9474 7.54584 11.0866C7.43988 11.2195 7.36865 11.3767 7.3386 11.5441L8.14019 11.6575C8.16798 11.574 8.22307 11.5024 8.29658 11.4541C8.38963 11.4025 8.49533 11.3781 8.60158 11.3837C8.66638 11.3781 8.73163 11.3864 8.79298 11.4079C8.85434 11.4295 8.91039 11.4639 8.95739 11.5089C9.03518 11.6151 9.07387 11.745 9.06689 11.8764V12.0211H8.29658ZM8.44125 13.0847C8.32564 13.0963 8.20989 13.0642 8.11673 12.9947C8.0872 12.9641 8.06403 12.928 8.04859 12.8884C8.03316 12.8488 8.02573 12.8065 8.02678 12.764C8.0259 12.7227 8.03342 12.6817 8.04888 12.6434C8.06434 12.605 8.08743 12.5703 8.11673 12.5411C8.18816 12.4829 8.27886 12.4536 8.37087 12.459H9.06689V12.5724C9.06812 12.6428 9.05325 12.7124 9.02343 12.7761C8.99361 12.8398 8.94964 12.8959 8.89484 12.94C8.76655 13.0427 8.60543 13.0954 8.44125 13.0886V13.0847Z"
        fill={color}
      />
      <path
        d="M14.6825 10.7456H13.8262V13.7095H14.6825V10.7456Z"
        fill={color}
      />
      <path
        d="M14.2645 10.3473C14.3287 10.3493 14.3927 10.3382 14.4526 10.3147C14.5124 10.2911 14.5668 10.2557 14.6125 10.2104C14.7012 10.1151 14.7489 9.9887 14.7454 9.8585C14.7488 9.7295 14.701 9.60439 14.6125 9.51049C14.5665 9.46593 14.5119 9.43119 14.4521 9.40833C14.3923 9.38548 14.3284 9.375 14.2645 9.37755C14.1999 9.37492 14.1354 9.38535 14.075 9.40819C14.0145 9.43103 13.9593 9.46582 13.9126 9.51049C13.8673 9.55615 13.8318 9.61057 13.8083 9.6704C13.7848 9.73023 13.7737 9.79424 13.7757 9.8585C13.7729 9.92342 13.7837 9.98821 13.8073 10.0488C13.8309 10.1093 13.8668 10.1643 13.9127 10.2103C13.9587 10.2562 14.0137 10.2921 14.0742 10.3157C14.1348 10.3393 14.1995 10.35 14.2645 10.3473Z"
        fill={color}
      />
      <path
        d="M11.2929 13.1313H11.332C11.3564 13.1964 11.3865 13.2592 11.4219 13.319C11.5101 13.4807 11.6469 13.6106 11.8129 13.6905C11.9582 13.7643 12.1192 13.8019 12.2821 13.8C12.4429 13.8068 12.6027 13.7719 12.7459 13.6986C12.8891 13.6252 13.0109 13.516 13.0993 13.3816C13.312 13.0287 13.4128 12.6198 13.3887 12.2085C13.41 11.8092 13.3106 11.4127 13.1033 11.0707C13.0072 10.9402 12.8798 10.836 12.7329 10.7677C12.586 10.6994 12.4242 10.6691 12.2626 10.6797C12.1354 10.6751 12.0087 10.6975 11.8908 10.7454C11.7728 10.7932 11.6664 10.8654 11.5783 10.9573C11.458 11.0876 11.3674 11.2423 11.3124 11.4109H11.2655L11.1716 10.7579H10.4404V14.5742H11.2967L11.2929 13.1313ZM11.9185 11.4343C12.0084 11.4266 12.0988 11.4415 12.1814 11.4777C12.2641 11.5139 12.3364 11.5702 12.3916 11.6416C12.499 11.8133 12.5509 12.014 12.5402 12.2164C12.5526 12.4268 12.4993 12.6358 12.3877 12.8146C12.3347 12.8879 12.2636 12.9462 12.1814 12.9839C12.0992 13.0216 12.0086 13.0374 11.9185 13.0297C11.8312 13.0345 11.744 13.0181 11.6644 12.9821C11.5847 12.946 11.515 12.8912 11.461 12.8224C11.3403 12.656 11.2809 12.4529 11.2929 12.2476V12.1929C11.2783 11.991 11.3381 11.7907 11.461 11.6298C11.5174 11.5646 11.5879 11.5131 11.6671 11.4792C11.7464 11.4454 11.8324 11.43 11.9185 11.4343Z"
        fill={color}
      />
      <path
        d="M6.93053 12.9861H5.33519L5.30784 12.8962L6.90315 11.4729V10.7456H4.26382V11.4729H5.75749L5.79269 11.5668L4.22864 12.9861V13.7134H6.96573L6.93053 12.9861Z"
        fill={color}
      />
      <path
        d="M19.2974 12.1929C19.2837 12.1082 19.291 12.0215 19.3187 11.9403C19.3464 11.8592 19.3936 11.786 19.4561 11.7274C19.5187 11.6687 19.5946 11.6262 19.6774 11.6038C19.7602 11.5813 19.8472 11.5795 19.9308 11.5985H20.2553V10.7461H20.0676C19.9589 10.7412 19.8505 10.762 19.7513 10.8069C19.6521 10.8517 19.5649 10.9193 19.4968 11.0042C19.4088 11.1207 19.3449 11.2537 19.3091 11.3952H19.2661L19.1722 10.7422H18.441V13.71H19.2974V12.1929Z"
        fill={color}
      />
    </svg>
  );
}

export function RoofingIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M20.0038 9.7512C19.9896 9.77709 19.9729 9.80256 19.9612 9.8297C19.7742 10.2627 19.3599 10.3842 18.9774 10.1124C18.3582 9.67186 17.7423 9.22715 17.1247 8.78452C15.5684 7.66836 14.0117 6.55219 12.455 5.43602C12.1159 5.19258 11.8896 5.19342 11.5459 5.43978C9.37581 6.99523 7.20361 8.54818 5.03767 10.1095C4.57083 10.446 4.11443 10.145 4.0188 9.75412C3.957 9.50149 4.04678 9.28018 4.29941 9.0977C4.81887 8.72356 5.33958 8.3515 5.85987 7.97819C7.50552 6.79856 9.15283 5.62184 10.7943 4.43678C11.105 4.21254 11.4415 4.07057 11.8136 4H12.1886C12.5372 4.06973 12.8625 4.18749 13.1565 4.39878C15.3003 5.94128 17.447 7.47961 19.595 9.01627C19.7666 9.13904 19.9207 9.26974 20.003 9.46975V9.7512H20.0038Z"
        fill="#FD8B1F"
      />
      <path
        d="M5.25393 15.3291C5.25393 14.4175 5.25477 13.506 5.25393 12.5944C5.2531 11.9104 5.52452 11.3676 6.08156 10.9659C7.67793 9.81508 9.27222 8.66133 10.869 7.51092C11.5776 7.00023 12.4182 6.99481 13.1239 7.50215C14.7299 8.65715 16.3325 9.81716 17.9364 10.9755C18.4826 11.3701 18.7502 11.9079 18.7506 12.579C18.7515 14.4071 18.7523 16.2356 18.7506 18.0638C18.7498 19.1774 17.9289 19.9971 16.8156 19.9988C15.6539 20.0005 14.4927 19.9996 13.331 19.9988C12.8771 19.9988 12.6282 19.7474 12.6278 19.2914C12.6278 18.4893 12.6312 17.6871 12.6261 16.885C12.6236 16.4323 12.1919 16.1333 11.7806 16.2899C11.5321 16.3843 11.3789 16.6123 11.378 16.9012C11.3764 17.6984 11.378 18.4951 11.3772 19.2923C11.3772 19.7482 11.1279 19.9992 10.6736 19.9992C9.5119 20 8.35064 20.0005 7.18896 19.9992C6.07613 19.9979 5.25561 19.177 5.25435 18.0638C5.2531 17.1522 5.25393 16.2406 5.25393 15.3291ZM13.8768 18.7373C13.9127 18.744 13.9273 18.7494 13.9423 18.7494C14.9161 18.7498 15.8899 18.7536 16.8636 18.7482C17.2482 18.7461 17.5004 18.4688 17.5004 18.0679C17.5013 16.2402 17.5 14.4121 17.5021 12.5844C17.5021 12.3234 17.4011 12.1272 17.1889 11.9747C15.6088 10.8373 14.0313 9.6969 12.4528 8.55819C12.1184 8.31683 11.8895 8.316 11.5572 8.55568C9.97833 9.6944 8.40116 10.8352 6.82066 11.9718C6.6031 12.1284 6.50164 12.3276 6.50205 12.594C6.50456 14.4063 6.50331 16.2185 6.50372 18.0308C6.50372 18.503 6.75259 18.7502 7.22863 18.7507C8.13976 18.7511 9.05132 18.7507 9.96246 18.7507C10.013 18.7507 10.0635 18.7461 10.1274 18.7431C10.1274 18.6772 10.1274 18.6208 10.1274 18.5648C10.1274 17.9869 10.1207 17.4086 10.1295 16.8307C10.1491 15.5629 11.4427 14.6773 12.6341 15.1107C13.3773 15.3809 13.8713 16.0778 13.8759 16.8716C13.8797 17.4909 13.8768 18.1093 13.8768 18.7373Z"
        fill={color}
      />
    </svg>
  );
}

export function EncirlceIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M2.28577 12.5571C2.28577 12.1535 2.28577 11.7499 2.28577 11.3457C2.30228 11.2758 2.32802 11.2068 2.33434 11.1359C2.48102 9.51363 3.00365 8.02346 3.91048 6.67123C6.15885 3.32174 10.1184 1.68974 13.9667 2.56986C17.8937 3.46794 20.3815 5.9548 21.386 9.86917C21.5618 10.555 21.5953 11.2777 21.6964 11.9956H12.0064V11.1097H17.0063C16.9815 10.9795 16.9679 10.8848 16.9451 10.792C16.3268 8.27263 13.8404 6.52066 11.1369 6.96897C8.3572 7.42991 6.46485 10.029 6.89908 12.7864C7.29154 15.2791 9.26694 17.0422 11.7859 17.1529C13.8667 17.2443 15.8717 16.0416 16.7173 13.9535C16.7829 13.7923 16.8621 13.7374 17.0345 13.7384C18.4314 13.7452 19.8278 13.7418 21.2247 13.7427C21.301 13.7427 21.3777 13.7539 21.4666 13.7612C21.4569 13.8428 21.4545 13.8982 21.4433 13.9516C21.0591 15.8167 20.2135 17.4444 18.8753 18.7976C17.3031 20.3873 15.3967 21.3272 13.174 21.6118C12.8719 21.6507 12.5688 21.6803 12.2662 21.7143H11.4425C11.3647 21.6973 11.288 21.6754 11.2098 21.6638C10.7489 21.5953 10.2811 21.5579 9.82697 21.4583C6.03305 20.6224 3.03474 17.4395 2.43731 13.6271C2.38145 13.2716 2.3358 12.9141 2.28577 12.5571Z"
        fill={color}
      />
    </svg>
  );
}

export function JobberIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4641 2.28571C18.6226 2.28571 18.7584 2.35364 18.8603 2.45554L21.5433 5.12753C21.6565 5.22943 21.7244 5.37662 21.7131 5.5238V14.5927C21.7131 18.5328 18.5094 21.7143 14.5925 21.7143H5.52468C5.37751 21.7143 5.23034 21.6463 5.12846 21.5444L2.4568 18.8725C2.3436 18.7706 2.27567 18.6234 2.28699 18.4762V9.40725C2.28699 5.46719 5.46808 2.28571 9.385 2.28571H18.4641ZM4.89073 18.9064V9.40725C4.89073 6.90509 6.90579 4.88977 9.40764 4.86713H16.3245C16.4264 4.86713 16.517 4.9577 16.517 5.0596V14.2984C16.517 15.5098 15.5321 16.4835 14.3208 16.4948H9.4416C9.37368 16.4948 9.30575 16.5514 9.27179 16.6194L8.9435 17.4798C8.89821 17.5704 8.9435 17.6836 9.03406 17.7176C9.0567 17.7289 9.07934 17.7289 9.1133 17.7289H14.5925C16.3245 17.7289 17.7396 16.3363 17.7396 14.5927C17.7396 14.5814 17.7396 14.5814 17.7396 14.5701V3.83682C17.7396 3.73492 17.6603 3.64435 17.5471 3.64435H9.39632C6.22656 3.64435 3.64546 6.20312 3.64546 9.37329C3.64546 9.38461 3.64546 9.38461 3.64546 9.39593V18.0459C3.64546 18.0912 3.6681 18.1478 3.70206 18.1818L4.56243 19.0423C4.64167 19.1215 4.75488 19.1215 4.83412 19.0423C4.86809 19.0083 4.89073 18.963 4.89073 18.9064ZM8.84161 14.9437V9.66766C8.84161 9.2261 9.20387 8.86379 9.66801 8.86379H14.9434C15.0453 8.86379 15.1359 8.95437 15.1359 9.05627V14.3323C15.1359 14.7739 14.7736 15.1588 14.3321 15.1588H9.04538C8.93217 15.1249 8.84161 15.0456 8.84161 14.9437ZM14.5925 20.333C17.7622 20.333 20.332 17.7516 20.332 14.5814V5.93139C20.332 5.88611 20.3094 5.82949 20.2754 5.79553L19.415 4.93506C19.3358 4.8558 19.2226 4.8558 19.1433 4.93506C19.1094 4.96902 19.0867 5.02563 19.0867 5.07092V14.5927C19.0867 17.0836 17.0717 19.1102 14.5811 19.1102H14.5698H7.65295C7.55106 19.1102 7.4605 19.0196 7.4605 18.9177V9.67898C7.4605 8.46753 8.44539 7.49383 9.65669 7.48251H14.5359C14.6038 7.48251 14.6717 7.4259 14.7057 7.35797L15.034 6.4975C15.0793 6.40692 15.034 6.2937 14.9434 6.25973C14.9208 6.24841 14.8981 6.24841 14.8642 6.24841H9.40764C7.66427 6.24841 6.26052 7.66366 6.26052 9.39593V20.1292C6.26052 20.2311 6.35108 20.3217 6.45297 20.3217L14.5925 20.333Z"
        fill={color}
      />
    </svg>
  );
}

export function FieldPulseIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <clipPath id="myClipPath">
        <rect
          x="2.28577"
          y="2.28571"
          width="19.4286"
          height="19.4286"
          rx="4.57143"
        />
      </clipPath>
      <g clipPath="url(#myClipPath)">
        <path
          d="M10.2299 21.7143H2.28577C2.28577 15.2381 2.28577 8.7619 2.28577 2.28571C8.76196 2.28571 15.2381 2.28571 21.7143 2.28571C21.7143 5.25007 21.7143 8.21531 21.7143 11.1797C21.6297 11.1365 21.5321 11.108 21.4613 11.0476C21.0192 10.6737 20.5978 10.2739 20.1428 9.91811C19.4235 9.35684 18.7241 8.75326 17.9417 8.29388C16.871 7.66613 15.8158 7.00296 14.6492 6.53754C14.2926 6.39506 14.2676 6.50559 14.2037 6.74392C13.9982 7.51501 13.8117 8.29043 13.5915 9.05635C13.5198 9.3059 13.5621 9.4216 13.7927 9.55113C14.6199 10.0157 15.4186 10.5312 16.2519 10.9854C17.5532 11.6943 18.6783 12.6278 19.7352 13.6475C20.4131 14.3021 21.0555 14.9937 21.7143 15.669V20.9363C21.6332 20.8914 21.5209 20.8672 21.476 20.799C21.0201 20.103 20.5953 19.3854 20.1229 18.7016C19.7128 18.1083 19.294 17.5099 18.8018 16.9867C18.2051 16.3511 17.5324 15.7864 16.884 15.2018C16.5248 14.878 16.1647 14.5516 15.7726 14.271C15.3331 13.9575 14.8625 13.6873 14.3962 13.4118C13.8384 13.0819 13.2711 12.7659 12.7064 12.443C12.4663 13.3514 12.2582 14.1941 12.0139 15.0257C11.9353 15.2942 11.931 15.485 12.1745 15.656C12.9905 16.2294 13.7909 16.8252 14.6156 17.3847C15.6319 18.0738 16.4462 18.9641 17.1914 19.9191C17.6378 20.4916 18.0212 21.1133 18.4331 21.7134H14.2883C13.3635 20.5762 12.2798 19.6307 10.9889 18.9079C10.7247 19.8854 10.4769 20.799 10.2299 21.7134V21.7143Z"
          fill={color}
        />
        <path
          d="M18.4331 21.7143C18.0212 21.115 17.6378 20.4924 17.1914 19.9199C16.4462 18.9649 15.6319 18.0738 14.6156 17.3856C13.7901 16.8261 12.9905 16.2302 12.1745 15.6569C11.931 15.4859 11.9353 15.2951 12.0139 15.0265C12.2582 14.1941 12.4655 13.3514 12.7064 12.4438C13.2711 12.7668 13.8376 13.082 14.3962 13.4127C14.8617 13.6881 15.3331 13.9584 15.7727 14.2718C16.1647 14.5516 16.5248 14.8789 16.884 15.2027C17.5333 15.7873 18.2051 16.352 18.8018 16.9875C19.294 17.5117 19.7128 18.1092 20.1229 18.7024C20.5961 19.3863 21.021 20.103 21.476 20.7998C21.5209 20.8681 21.6332 20.8922 21.7143 20.9371V21.7143H18.4331Z"
          fill="#FFFFFE"
        />
        <path
          d="M21.7143 15.6698C21.0564 14.9946 20.4139 14.3029 19.7352 13.6484C18.6783 12.6278 17.5523 11.6952 16.2519 10.9863C15.4195 10.5321 14.6199 10.0166 13.7927 9.552C13.5621 9.42247 13.5198 9.30676 13.5915 9.05722C13.8125 8.2913 13.999 7.51502 14.2037 6.74478C14.2676 6.50646 14.2926 6.39593 14.6493 6.53841C15.8158 7.00469 16.871 7.66786 17.9418 8.29475C18.7241 8.75327 19.4235 9.35685 20.1428 9.91898C20.5987 10.2747 21.0201 10.6745 21.4613 11.0484C21.5322 11.108 21.6297 11.1374 21.7143 11.1805V15.6707V15.6698Z"
          fill="#FFFFFE"
        />
        <path
          d="M10.2299 21.7143C10.4768 20.8007 10.7246 19.8863 10.9889 18.9088C12.2789 19.6315 13.3635 20.5771 14.2883 21.7143H10.2299Z"
          fill="#FEFFFE"
        />
      </g>
    </svg>
  );
}

export function Improveit360Icon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M18.1692 8.10668C18.4724 8.09897 18.7757 8.10984 19.0776 8.13922C19.7609 8.18656 20.431 8.35122 21.0585 8.62597C21.4081 8.773 21.7316 8.9756 22.0164 9.22591C22.1665 9.364 22.3025 9.51662 22.4225 9.68152L23.4286 9.37306L21.7306 10.9635L19.1002 10.8828L20.1558 10.4923C20.0556 10.3174 19.9296 10.1586 19.7822 10.0211C19.5748 9.81053 19.3263 9.64486 19.0521 9.53436L18.8158 9.4523C18.8158 9.4523 18.7451 9.26128 18.7224 9.20327C18.5646 8.8249 18.3797 8.45842 18.1692 8.10668Z"
        fill={color}
      />
      <path
        d="M16.7329 13.0732C16.8107 13.168 17.1574 13.5599 17.1574 13.5599H16.0792V15.7007C17.0277 15.2432 17.9148 14.668 18.7195 13.9886C18.7375 13.9566 18.7513 13.9224 18.7605 13.8868C18.9203 13.2798 18.996 12.6537 18.9855 12.0261C18.9851 10.7674 18.6662 9.52936 18.0583 8.4272C17.4505 7.32504 16.5736 6.39468 15.5093 5.72278C14.445 5.05089 13.2279 4.65933 11.9715 4.5846C10.715 4.50987 9.46011 4.75438 8.32365 5.29537C7.18719 5.83636 6.20616 6.65622 5.47196 7.67855C4.73777 8.70088 4.2743 9.89243 4.12473 11.1422C3.97517 12.3919 4.14438 13.6592 4.6166 14.8259C5.08883 15.9926 5.84869 17.0208 6.8254 17.8147C6.8254 17.8147 6.83813 17.8147 6.84379 17.8147L6.95982 17.826V13.5599H5.89577L6.32026 13.0703L7.85265 11.2946V8.33166H9.42183V9.46362L11.5259 7.01717L16.7286 13.0703"
        fill="#2AA6C1"
      />
      <path
        d="M20.3241 12.0516L22.6616 11.6271C22.5866 11.9076 22.4832 12.1797 22.3531 12.4393C22.1079 12.8985 21.7896 13.3147 21.4108 13.6717C20.9249 14.1726 20.4048 14.6393 19.8543 15.0682C19.1371 15.6103 18.3771 16.0935 17.5819 16.5129C16.8746 16.8963 16.1483 17.2434 15.4057 17.5529C14.8397 17.7906 14.3403 17.9774 13.961 18.1047L14.319 18.7853L11.2811 18.416L13.1814 16.7181C13.2507 16.8482 13.3229 16.9784 13.3922 17.1072C13.5238 17.0732 13.7304 17.0166 13.9766 16.9289C14.3403 16.8001 15.2345 16.428 15.3406 16.3757C16.3863 15.8677 15.9476 16.1054 16.6381 15.7276C17.2573 15.3927 17.8466 15.0055 18.3998 14.5702C19.1072 14.0042 19.4907 13.649 19.8685 13.042C20.0606 12.7319 20.2136 12.3992 20.3241 12.0516Z"
        fill={color}
      />
      <path
        d="M10.2313 17.7722C10.0785 18.1995 9.9266 18.6268 9.77567 19.0542C9.14215 19.1785 8.5027 19.2706 7.85983 19.3301C6.91117 19.4426 5.95286 19.4478 5.00304 19.3456C4.30971 19.2636 3.71685 19.1872 3.02211 18.8433C2.04155 18.3552 1.74865 17.775 1.69205 17.642C1.6292 17.5014 1.58176 17.3543 1.55056 17.2034L0.571411 17.5274L2.5198 15.8719L4.81627 16.0304L3.84136 16.3714C3.87795 16.5308 3.93804 16.6839 4.01965 16.8256C4.21005 17.1331 4.48724 17.3773 4.81627 17.5274C5.03983 17.6449 5.79824 18.0085 7.13679 18.0793C7.76618 18.1069 8.39679 18.0747 9.02009 17.983C9.52381 17.9194 9.93981 17.8415 10.2384 17.7722"
        fill={color}
      />
      <path
        d="M4.04366 13.9151C4.00121 13.7736 3.80312 12.769 3.84132 12.6289L3.79887 12.6657C3.50576 12.9245 3.23106 13.2034 2.97679 13.5005C2.6746 13.8558 2.40558 14.238 2.1731 14.6424L4.15403 14.249C4.12007 14.1372 4.08611 14.0268 4.05357 13.9151"
        fill={color}
      />
    </svg>
  );
}

export function DeskMobScreenIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M7.5 6.25C6.79688 6.25 6.25 6.83594 6.25 7.5V16.25H16.25V17.5H3.78906C4.02344 18.2422 4.6875 18.75 5.46875 18.75H16.25V20H5.46875C3.82812 20 2.5 18.6719 2.5 17.0312C2.5 16.6016 2.8125 16.25 3.24219 16.25H5V7.5C5 6.13281 6.09375 5 7.5 5H20C21.3672 5 22.5 6.13281 22.5 7.5V8.75H21.25V7.5C21.25 6.83594 20.6641 6.25 20 6.25H7.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 12.375C17.5 11.3594 18.3203 10.5 19.375 10.5H25.625C26.6406 10.5 27.5 11.3594 27.5 12.375V23.625C27.5 24.6797 26.6406 25.5 25.625 25.5H19.375C18.3203 25.5 17.5 24.6797 17.5 23.625V12.375ZM18.77 12.345V23.595C18.77 23.9466 19.0435 24.22 19.395 24.22H25.645C25.9575 24.22 26.27 23.9466 26.27 23.595V12.345C26.27 12.0325 25.9575 11.72 25.645 11.72H19.395C19.0435 11.72 18.77 12.0325 18.77 12.345Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

export function CallRingIcon({ className, width, height, color, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99423 14.3572C9.83012 14.0992 9.79784 13.7792 9.90208 13.4917L10.4298 12.0363C10.6106 11.6101 10.6592 11.1394 10.5694 10.6852L9.65163 7.05701C9.52609 6.56071 9.04601 6.23936 8.53933 6.31248L4.74918 6.85943C4.23388 6.9338 3.85922 7.3915 3.91421 7.90923C4.39234 12.4109 6.33992 16.7834 9.75553 20.2347C13.226 23.7397 17.7267 25.6576 22.2696 26.0934C22.7994 26.1442 23.2593 25.7474 23.3136 25.2179L23.7265 21.1856C23.7777 20.6851 23.4493 20.2245 22.9594 20.11L19.6339 19.3322C19.1571 19.2354 18.6618 19.2954 18.2218 19.5031L16.6179 20.1946C16.3129 20.3261 15.9619 20.2984 15.6844 20.116C14.5622 19.378 13.5948 18.6513 12.534 17.5797C11.4576 16.4923 10.7438 15.5357 9.99423 14.3572Z"
        stroke="#3270D8"
        strokeWidth="1.2"
      />
      <path
        d="M18.5095 12.9912C18.5426 13.2287 18.7338 13.4241 18.9735 13.4241C19.2133 13.4241 19.4101 13.229 19.3842 12.9907C19.1834 11.1405 17.712 9.65493 15.8472 9.45356C15.6089 9.42781 15.4138 9.62465 15.4138 9.86441C15.4138 10.1042 15.6093 10.2953 15.8468 10.3282C17.2326 10.5198 18.3186 11.6183 18.5095 12.9912Z"
        fill={color}
      />
      <path
        d="M21.1931 12.9901C21.2109 13.2292 21.4035 13.4242 21.6433 13.4242C21.883 13.4242 22.0789 13.2293 22.0633 12.99C21.8475 9.6661 19.1719 6.99054 15.848 6.77468C15.6088 6.75914 15.4138 6.95498 15.4138 7.19473C15.4138 7.43448 15.6089 7.62715 15.848 7.64481C18.7116 7.85629 20.982 10.143 21.1931 12.9901Z"
        fill={color}
      />
      <path
        d="M15.8698 4.10089C15.6303 4.08976 15.4355 4.28518 15.4355 4.52493C15.4355 4.76468 15.6301 4.95787 15.8695 4.97003C20.192 5.18951 23.6707 8.66851 23.8897 12.9911C23.9018 13.23 24.0946 13.4242 24.3339 13.4242C24.5738 13.4242 24.7691 13.2287 24.7571 12.9891C24.5162 8.19036 20.649 4.32292 15.8698 4.10089Z"
        fill={color}
      />
    </svg>
  );
}

export function HouseWithTwoTreesIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 202 102"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(1 1)"
      >
        <g transform="translate(160 40)">
          <circle cx="20" cy="20" r="20" />
          <path d="M20,60 L20,20" />
        </g>
        <g transform="translate(20)">
          <circle cx="20" cy="20" r="20" />
          <path d="M20,60 L20,20" />
        </g>
        <polyline points="110 100 110 90 100 90 100 80 90 80 90 70 80 70 80 60" />
        <path d="M200,100 L0,100 C1.38777878e-15,77.90861 17.90861,60 40,60 L160,60 C160,71.045695 168.954305,80 180,80 C191.045695,80 200,88.954305 200,100 Z" />
        <g transform="translate(80)">
          <rect width="40" height="40" y="20" />
          <polygon points="40 20 60 0 80 20 80 60 40 60" />
          <polygon points="0 20 20 0 60 0 40 20" />
        </g>
      </g>
    </svg>
  );
}

export function TwoHousesWithTreeIcon({
  className,
  width,
  height,
  color,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 202 102"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(1 1)"
      >
        <g transform="translate(0 40)">
          <circle cx="20" cy="20" r="20" />
          <path d="M20,60 L20,20" />
        </g>
        <polyline points="90 100 90 90 100 90 100 90 100 80 110 80 110 70 120 70 120 60" />
        <path d="M200,100 L0,100 C0,88.954305 8.954305,80 20,80 C31.045695,80 40,71.045695 40,60 L160,60 C182.09139,60 200,77.90861 200,100 Z" />
        <g transform="translate(110)">
          <polygon points="10 20 30 0 50 20 50 60 10 60" />
          <polygon points="0 10 10 0 30 0 10 20" />
        </g>
        <g transform="translate(60)">
          <rect width="20" height="40" y="20" />
          <polygon points="20 20 40 0 60 20 60 60 20 60" />
          <polygon points="0 20 20 0 40 0 20 20" />
        </g>
      </g>
    </svg>
  );
}

export function TwoTreesIcon({
  className,
  width,
  height,
  color,
  transformTree1,
  transformTree2,
  transitionDelayTree1,
  transitionDelayTree2,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 82 62"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(1 21)"
      >
        <polygon
          className={`tree-transition ${transitionDelayTree1}`}
          points="20 0 40 20 0 20"
          transform={transformTree1}
        />
        <g
          className={`tree-transition ${transitionDelayTree2}`}
          transform={transformTree2}
        >
          <polygon points="20 20 40 40 0 40" />
          <polygon points="20 0 40 20 0 20" />
        </g>
      </g>
    </svg>
  );
}

export function HouseWithFourTreesIcon({
  className,
  width,
  height,
  color,
  transformTree1,
  transformTree2,
  transformTree3,
  transformTree4,
  transitionDelayTree1,
  transitionDelayTree2,
  transitionDelayTree3,
  transitionDelayTree4,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 282 62"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(1 1)"
      >
        <g
          className={`tree-transition ${transitionDelayTree4}`}
          transform={transformTree4}
        >
          <polygon points="20 20 40 40 0 40" />
          <polygon points="20 0 40 20 0 20" />
        </g>
        <g
          className={`tree-transition ${transitionDelayTree3}`}
          transform={transformTree3}
        >
          <polygon points="20 40 40 60 0 60" />
          <polygon points="20 20 40 40 0 40" />
          <polygon points="20 0 40 20 0 20" />
        </g>
        <g
          className={`tree-transition ${transitionDelayTree2}`}
          transform={transformTree2}
        >
          <polygon points="20 20 40 40 0 40" />
          <polygon points="20 0 40 20 0 20" />
        </g>
        <g transform="translate(60 20)">
          <polygon points="0 20 40 20 40 40 0 40" />
          <polygon points="40 20 60 0 80 20 80 40 40 40" />
          <polygon points="0 20 20 0 60 0 40 20" />
        </g>
        <g
          className={`tree-transition ${transitionDelayTree1}`}
          transform={transformTree1}
        >
          <polygon points="20 40 40 60 0 60" />
          <polygon points="20 20 40 40 0 40" />
          <polygon points="20 0 40 20 0 20" />
        </g>
      </g>
    </svg>
  );
}

export function TreesFilledIcon({
  className,
  width,
  height,
  color,
  transformTree,
  transitionDelayTree,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 54 43"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        transform={transformTree}
        className={`tree-transition ${transitionDelayTree}`}
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M39.6522 1.22479C39.445 1.01752 39.1089 1.01752 38.9016 1.22479L26.1632 13.9633C26.0114 14.1151 25.966 14.3433 26.0481 14.5417C26.1303 14.74 26.3238 14.8693 26.5385 14.8693H39.2764C39.1408 14.8695 39.0051 14.9213 38.9016 15.0248L26.5385 27.3879L14.1753 15.0248C13.968 14.8175 13.632 14.8175 13.4247 15.0248L0.686236 27.7633C0.534437 27.9151 0.489027 28.1434 0.57118 28.3417C0.653333 28.54 0.84687 28.6693 1.06155 28.6693H13.8C13.6592 28.6693 13.5242 28.7253 13.4247 28.8248L0.686236 41.5633C0.534437 41.7151 0.489027 41.9434 0.57118 42.1417C0.653333 42.34 0.84687 42.4693 1.06155 42.4693H52.0154C52.2301 42.4693 52.4236 42.34 52.5058 42.1417C52.5879 41.9434 52.5425 41.7151 52.3907 41.5633L39.6522 28.8248C39.5527 28.7253 39.4177 28.6693 39.2769 28.6693H52.0154C52.2301 28.6693 52.4236 28.54 52.5058 28.3417C52.5879 28.1434 52.5425 27.9151 52.3907 27.7633L39.6522 15.0248C39.5487 14.9213 39.4121 14.8695 39.2764 14.8693H52.0154C52.2301 14.8693 52.4236 14.74 52.5058 14.5417C52.5879 14.3433 52.5425 14.1151 52.3907 13.9633L39.6522 1.22479ZM39.2769 28.6693H13.8C13.9408 28.6693 14.0758 28.7253 14.1753 28.8248L26.5385 41.188L38.9016 28.8248C39.0012 28.7253 39.1362 28.6693 39.2769 28.6693Z"
      />
    </svg>
  );
}

export function BellIcon({
  className,
  width,
  height,
  color,
  transformTree,
  transitionDelayTree,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M14.5445 6.23174C14.4724 6.21761 14.385 6.21497 14.3128 6.21497C10.8347 6.21497 8.00363 8.98734 8.00363 12.3954V15.0795C8.00363 16.8665 7.21318 18.56 5.83236 19.7343C5.81163 19.7466 5.7909 19.7608 5.77197 19.7766V22.1076H6.65166H14.3128"
        stroke={color}
        strokeWidth="1.0101"
      />
      <path
        d="M14.0272 6.23174C14.0993 6.21761 14.1867 6.21497 14.2588 6.21497C15.6376 6.21497 16.9146 6.6506 17.954 7.38877M14.2588 22.1076H21.92H22.7997V19.7766C22.7808 19.7608 22.76 19.7466 22.7393 19.7343C21.3585 18.56 20.568 16.8665 20.568 15.0795V12.3954C20.568 12.1509 20.5534 11.9096 20.5251 11.6724"
        stroke={color}
        strokeWidth="1.0101"
      />
      <path
        d="M17.316 22.3666C17.316 23.7612 16.0239 24.8918 14.43 24.8918C12.8361 24.8918 11.544 23.7612 11.544 22.3666"
        stroke={color}
        strokeWidth="1.0101"
      />
      <circle
        cx="20.9902"
        cy="8.58207"
        r="3.00689"
        stroke="#FD8B1F"
        strokeWidth="0.937951"
      />
      <path
        d="M20.444 7.86485H21.5998V10.1376H20.8336V8.44277H20.444V7.86485Z"
        fill="#FD8B1F"
      />
      <path
        d="M6.21777 19.9115L22.2938 19.9115"
        stroke={color}
        strokeWidth="1.0101"
        strokeLinecap="square"
      />
      <path
        d="M12.735 6.39068V5.87529C12.735 5.02135 13.4417 4.3291 14.3134 4.3291C15.1851 4.3291 15.8918 5.02135 15.8918 5.87529V6.39068"
        stroke={color}
        strokeWidth="1.0101"
      />
    </svg>
  );
}

export function NoteIcon({
  className,
  width,
  height,
  color,
  transformTree,
  transitionDelayTree,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.6461 14.7175H21.7491V9.31555H13.6461V14.7175Z"
        stroke={color}
        stroke-width="1.07143"
        stroke-linejoin="round"
      />
      <path
        d="M13.1959 17.4184H22.1992"
        stroke={color}
        stroke-width="1.07143"
        stroke-linecap="round"
      />
      <path
        d="M13.1959 20.1195H19.9484"
        stroke={color}
        stroke-width="1.07143"
        stroke-linecap="round"
      />
      <path
        d="M7.34386 24.6211H22.6494C23.3484 24.6211 23.9855 24.3554 24.4652 23.9195C25.0089 23.4254 25.3504 22.7125 25.3504 21.9201V6.21423C25.3504 5.93809 25.1265 5.71423 24.8504 5.71423H10.5448C10.2687 5.71423 10.0448 5.93809 10.0448 6.21423V21.9201C10.0448 23.4115 8.83526 24.6211 7.34386 24.6211ZM7.34386 24.6211C5.85247 24.6211 4.64288 23.4115 4.64288 21.9201V15.1677C4.64288 14.4217 5.24745 13.8172 5.99337 13.8172C6.73929 13.8172 7.34386 14.4217 7.34386 15.1677V21.0198"
        stroke="#3270D8"
        stroke-width="1.07143"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function MonitorIcon({
  className,
  width,
  height,
  color,
  transformTree,
  transitionDelayTree,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      className={`${className} fx--no-shrink`}
      fill="none"
      {...props}
    >
      <path
        d="M7.5 6.25C6.79688 6.25 6.25 6.83594 6.25 7.5V16.25H16.25V17.5H3.78906C4.02344 18.2422 4.6875 18.75 5.46875 18.75H16.25V20H5.46875C3.82812 20 2.5 18.6719 2.5 17.0312C2.5 16.6016 2.8125 16.25 3.24219 16.25H5V7.5C5 6.13281 6.09375 5 7.5 5H20C21.3672 5 22.5 6.13281 22.5 7.5V8.75H21.25V7.5C21.25 6.83594 20.6641 6.25 20 6.25H7.5Z"
        fill="#3270D8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5 12.375C17.5 11.3594 18.3203 10.5 19.375 10.5H25.625C26.6406 10.5 27.5 11.3594 27.5 12.375V23.625C27.5 24.6797 26.6406 25.5 25.625 25.5H19.375C18.3203 25.5 17.5 24.6797 17.5 23.625V12.375ZM18.77 12.345V23.595C18.77 23.9466 19.0435 24.22 19.395 24.22H25.645C25.9575 24.22 26.27 23.9466 26.27 23.595V12.345C26.27 12.0325 25.9575 11.72 25.645 11.72H19.395C19.0435 11.72 18.77 12.0325 18.77 12.345Z"
        fill="#FD8B1F"
      />
    </svg>
  );
}

MonitorIcon.defaultProps = {
  color: "",
  width: "30",
  height: "30",
  className: "",
};
MonitorIcon.propTypes = iconPropTypes;

NoteIcon.defaultProps = {
  color: "#FD8B1F",
  width: "30",
  height: "30",
  className: "",
};
NoteIcon.propTypes = iconPropTypes;

BellIcon.defaultProps = {
  color: "#3270D8",
  width: "30",
  height: "30",
  className: "",
};
BellIcon.propTypes = iconPropTypes;

TreesFilledIcon.defaultProps = {
  color: "#FFF",
  width: "54",
  height: "43",
  className: "",
};
TreesFilledIcon.propTypes = iconPropTypes;

HouseWithFourTreesIcon.defaultProps = {
  color: "#FFF",
  width: "282",
  height: "62",
  className: "",
};
HouseWithFourTreesIcon.propTypes = iconPropTypes;

TwoTreesIcon.defaultProps = {
  color: "#FFF",
  width: "82",
  height: "62",
  className: "",
};
TwoTreesIcon.propTypes = iconPropTypes;

TwoHousesWithTreeIcon.defaultProps = {
  color: "#FFF",
  width: "202",
  height: "102",
  className: "",
};
TwoHousesWithTreeIcon.propTypes = iconPropTypes;

HouseWithTwoTreesIcon.defaultProps = {
  color: "#FFF",
  width: "202",
  height: "102",
  className: "",
};
HouseWithTwoTreesIcon.propTypes = iconPropTypes;

CallRingIcon.defaultProps = {
  color: "#FD8B1F",
  width: "30",
  height: "30",
  className: "",
};
CallRingIcon.propTypes = iconPropTypes;

DeskMobScreenIcon.defaultProps = {
  color: "#3270D8",
  width: "30",
  height: "30",
  className: "",
};
DeskMobScreenIcon.propTypes = iconPropTypes;

Improveit360Icon.defaultProps = {
  color: "#55565E",
  width: "24",
  height: "24",
  className: "",
};
Improveit360Icon.propTypes = iconPropTypes;

FieldPulseIcon.defaultProps = {
  color: "#3BD826",
  width: "24",
  height: "24",
  className: "",
};
FieldPulseIcon.propTypes = iconPropTypes;

EncirlceIcon.defaultProps = {
  color: "#FC4D00",
  width: "24",
  height: "24",
  className: "",
};
EncirlceIcon.propTypes = iconPropTypes;

JobberIcon.defaultProps = {
  color: "#012939",
  width: "24",
  height: "24",
  className: "",
};
JobberIcon.propTypes = iconPropTypes;

RoofingIcon.defaultProps = {
  color: "#3270D8",
  width: "24",
  height: "24",
  className: "",
};
RoofingIcon.propTypes = iconPropTypes;

ZapierIntegrationIcon.defaultProps = {
  color: "#FFFDF9",
  width: "24",
  height: "24",
  className: "",
};
ZapierIntegrationIcon.propTypes = iconPropTypes;

QuickbooksIcon.defaultProps = {
  color: "#2CA01C",
  width: "24",
  height: "24",
  className: "",
};
QuickbooksIcon.propTypes = iconPropTypes;

WorkizIcon.defaultProps = {
  color: "#FFD504",
  width: "24",
  height: "24",
  className: "",
};
WorkizIcon.propTypes = iconPropTypes;

ServiceFusionIcon.defaultProps = {
  color: "#EF3F42",
  width: "24",
  height: "24",
  className: "",
};
ServiceFusionIcon.propTypes = iconPropTypes;

LiveCallTransfer.defaultProps = {
  color: "#3270D8",
  width: "30",
  height: "30",
  className: "",
};
LiveCallTransfer.propTypes = iconPropTypes;

LiveChatIcon.defaultProps = {
  color: "#3270D8",
  width: "30",
  height: "30",
  className: "",
};
LiveChatIcon.propTypes = iconPropTypes;

AgentOnCallIcon.defaultProps = {
  color: "#3270D8",
  width: "30",
  height: "30",
  className: "",
};
AgentOnCallIcon.propTypes = iconPropTypes;

CircleInfoIcon.defaultProps = {
  color: "#707477",
  width: "12",
  height: "12",
  className: "",
};
CircleInfoIcon.propTypes = iconPropTypes;

PlansTickIcon.defaultProps = {
  color: "#3270D8",
  width: "16",
  height: "12",
  className: "",
};
PlansTickIcon.propTypes = iconPropTypes;

AestheticBg1.defaultProps = {
  color: "white",
  width: "317",
  height: "267",
  className: "",
};
AestheticBg1.propTypes = iconPropTypes;

AestheticBg2.defaultProps = {
  color: "white",
  width: "184",
  height: "230",
  className: "",
};
AestheticBg2.propTypes = iconPropTypes;

AestheticBg3.defaultProps = {
  color: "white",
  width: "375",
  height: "408",
  className: "",
};
AestheticBg3.propTypes = iconPropTypes;

AestheticBg4.defaultProps = {
  color: "white",
  width: "253",
  height: "324",
  className: "",
};
AestheticBg4.propTypes = iconPropTypes;

AestheticBg5.defaultProps = {
  color: "white",
  width: "459",
  height: "434",
  className: "",
};
AestheticBg5.propTypes = iconPropTypes;

ChatMessageIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ChatMessageIcon.propTypes = iconPropTypes;

CalendarIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
CalendarIcon.propTypes = iconPropTypes;

ReceptionistIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ReceptionistIcon.propTypes = iconPropTypes;

LeadQualificationIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
LeadQualificationIcon.propTypes = iconPropTypes;

HeadphoneIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
HeadphoneIcon.propTypes = iconPropTypes;

ChatSmileIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ChatSmileIcon.propTypes = iconPropTypes;

HomeServicesIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
HomeServicesIcon.propTypes = iconPropTypes;

RestorationIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
RestorationIcon.propTypes = iconPropTypes;

PlumbingIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
PlumbingIcon.propTypes = iconPropTypes;

ElectricalIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ElectricalIcon.propTypes = iconPropTypes;

HvacIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
HvacIcon.propTypes = iconPropTypes;

ConstructionIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ConstructionIcon.propTypes = iconPropTypes;

FranchiseIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
FranchiseIcon.propTypes = iconPropTypes;

RemodelingIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
RemodelingIcon.propTypes = iconPropTypes;

LandscapingIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
LandscapingIcon.propTypes = iconPropTypes;

ServiceMinderIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ServiceMinderIcon.propTypes = iconPropTypes;

ConstantContactIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ConstantContactIcon.propTypes = iconPropTypes;

FranConnectIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
FranConnectIcon.propTypes = iconPropTypes;

ServiceTitanIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ServiceTitanIcon.propTypes = iconPropTypes;

PipeDriveIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
PipeDriveIcon.propTypes = iconPropTypes;

ZenDeskIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ZenDeskIcon.propTypes = iconPropTypes;

SalesForceIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
SalesForceIcon.propTypes = iconPropTypes;

AutotaskIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
AutotaskIcon.propTypes = iconPropTypes;

ZapierIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ZapierIcon.propTypes = iconPropTypes;

HouseCallProIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
HouseCallProIcon.propTypes = iconPropTypes;

HubspotIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
HubspotIcon.propTypes = iconPropTypes;

ZohoIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
ZohoIcon.propTypes = iconPropTypes;

TickIcon.defaultProps = {
  color: "#fff",
  width: "10",
  height: "8",
  className: "tick-icon",
};
TickIcon.propTypes = iconPropTypes;

NoMatchIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
NoMatchIcon.propTypes = iconPropTypes;

SuccessIcon.defaultProps = {
  circleColor: "#3270D8",
  tickColor: "#FD8B1F",
  width: "84",
  height: "84",
  className: "",
};
SuccessIcon.propTypes = iconPropTypes;

SearchIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
SearchIcon.propTypes = iconPropTypes;

CloseIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
CloseIcon.propTypes = iconPropTypes;

LinkedInIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
LinkedInIcon.propTypes = iconPropTypes;

InstagramIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
InstagramIcon.propTypes = iconPropTypes;

FacebookIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
FacebookIcon.propTypes = iconPropTypes;

PlaystoreIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
PlaystoreIcon.propTypes = iconPropTypes;

AppstoreIcon.defaultProps = {
  color: "",
  width: "24",
  height: "24",
  className: "",
};
AppstoreIcon.propTypes = iconPropTypes;

PointArrowIcon.defaultProps = {
  color: "white",
  width: "12",
  height: "10",
  className: "",
};
PointArrowIcon.propTypes = iconPropTypes;

NavPhoneIcon.defaultProps = {
  color: "",
  width: "18",
  height: "18",
  className: "",
};
NavPhoneIcon.propTypes = iconPropTypes;

UlCheckedIcon.defaultProps = {
  color: "",
  width: "24",
  height: "22",
  className: "",
};
UlCheckedIcon.propTypes = iconPropTypes;

PlayBtnIcon.defaultProps = {
  color: "",
  width: "118",
  height: "118",
  className: "",
};
PlayBtnIcon.propTypes = iconPropTypes;

TimetableIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
PlayBtnIcon.propTypes = iconPropTypes;

ReceptionistOnCallIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
ReceptionistOnCallIcon.propTypes = iconPropTypes;

ListingIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
ListingIcon.propTypes = iconPropTypes;

ClockWithArrowIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
ClockWithArrowIcon.propTypes = iconPropTypes;

ClockIcon.defaultProps = {
  color: "",
  width: "82",
  height: "82",
  className: "",
};
ClockIcon.propTypes = iconPropTypes;

FilterIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
FilterIcon.propTypes = iconPropTypes;

SchedulingIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
SchedulingIcon.propTypes = iconPropTypes;

BilingualChatIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
BilingualChatIcon.propTypes = iconPropTypes;

PuzzleIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
PuzzleIcon.propTypes = iconPropTypes;

PauseBtnIcon.defaultProps = {
  color: "",
  width: "60",
  height: "60",
  className: "",
};
PauseBtnIcon.propTypes = iconPropTypes;

SarahAudioInfo.defaultProps = {
  color: "",
  width: "200",
  height: "34",
  className: "",
};
SarahAudioInfo.propTypes = iconPropTypes;

AudioWaveTimeline.defaultProps = {
  color: "#8bb8e0",
  width: "302",
  height: "77",
  className: "",
};
AudioWaveTimeline.propTypes = iconPropTypes;

RoundedTickIcon.defaultProps = {
  color: "#00ADED",
  width: "22",
  height: "22",
  className: "",
};
RoundedTickIcon.propTypes = iconPropTypes;

MiniPlayBtnIcon.defaultProps = {
  color: "#FFFFFF",
  width: "13",
  height: "16",
  className: "",
};
MiniPlayBtnIcon.propTypes = iconPropTypes;

ClockBadgeIcon.defaultProps = {
  color: "#FFFFFF",
  width: "14",
  height: "14",
  className: "",
};
ClockBadgeIcon.propTypes = iconPropTypes;

ArrowIcon.defaultProps = {
  color: "#33393D",
  width: "11",
  height: "20",
  className: "",
};
ArrowIcon.propTypes = iconPropTypes;

CustomScriptIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
CustomScriptIcon.propTypes = iconPropTypes;

QualifyLeadIcon.defaultProps = {
  color: "",
  width: "84",
  height: "84",
  className: "",
};
QualifyLeadIcon.propTypes = iconPropTypes;

ChevronArrowIcon.defaultProps = {
  color: "",
  width: "14",
  height: "8",
  className: "",
};
ChevronArrowIcon.propTypes = iconPropTypes;
